webpackJsonp([1],{

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ drawerActive: _vm.menuIsVisible }},[_c('div',{staticClass:"overlay-body",on:{"click":_vm.toggleMenu}}),_vm._v(" "),(_vm.userIsLogged)?_c('nav-bar',{attrs:{"menu-is-Visible":_vm.menuIsVisible}}):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.setting === 'initial')?_c('div',[_c('img',{staticClass:"header-logo",attrs:{"src":"/static/logo.svg"}})]):(_vm.setting === 'appNavigation')?_c('div',{staticClass:"search-header-container"},[_c('div',{staticClass:"app-navigation-links"},[_c('img',{staticClass:"header-menu-icon",attrs:{"src":"/static/menu.svg"},on:{"click":_vm.toggleMenu}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/lista-de-analisis"}},[_c('img',{staticClass:"logged-header-logo",attrs:{"src":"/static/logo.svg"}})])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userIsAdmin),expression:"userIsAdmin"}],staticClass:"admin-header-items"},[_c('router-link',{staticClass:"admin-header-link",attrs:{"to":"/lista-de-asesores"}},[_vm._v("Asesores")]),_vm._v(" "),_c('router-link',{staticClass:"admin-header-link",attrs:{"to":"/lista-de-analisis"}},[_vm._v("Portafolios")])],1),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.hideSearchbar),expression:"hideSearchbar"}],attrs:{"placeholder":_vm.inputPlaceholder},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('i',{staticClass:"el-input__icon el-icon-search",attrs:{"slot":"prefix"},slot:"prefix"}),_vm._v(" "),(_vm.query !== '')?_c('i',{staticClass:"el-input__icon el-icon-circle-close-outline",attrs:{"slot":"suffix"},on:{"click":_vm.resetInput},slot:"suffix"}):_vm._e()])],1):_c('div',{staticClass:"search-header-container"},[_c('div',{staticClass:"app-navigation-links"},[_c('img',{staticClass:"header-menu-icon",attrs:{"src":"/static/menu.svg"},on:{"click":_vm.toggleMenu}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/lista-de-analisis"}},[_c('img',{staticClass:"logged-header-logo",attrs:{"src":"/static/logo.svg"}})])],1),_vm._v(" "),_c('div',{staticClass:"portfolio-navigation-links"},[_c('span',{on:{"click":_vm.editPortfolio}},[_vm._v("Editar")]),_vm._v(" "),_c('span',{on:{"click":_vm.updatePortfolio}},[_vm._v("Actualizar")]),_vm._v(" "),_c('span',{on:{"click":_vm.goToPrintable}},[_vm._v("Generar PDF")]),_vm._v(" "),_c('span',{on:{"click":_vm.sendPortfolioUrl}},[_vm._v("Enviar enlace")])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"send-url-container",attrs:{"title":"Enviar enlace","visible":_vm.displaySendUrlDialog},on:{"update:visible":function($event){_vm.displaySendUrlDialog=$event}}},[_c('div',[_c('el-form',{ref:"sendShareUrl",attrs:{"model":_vm.sendUrlData,"status-icon":"","rules":_vm.rules}},[_c('span',[_vm._v(" Email ")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email"}},[_c('el-input',{staticClass:"send-url",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.sendUrlData.email),callback:function ($$v) {_vm.$set(_vm.sendUrlData, "email", $$v)},expression:"sendUrlData.email"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%","background-color":"#2873DE","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.validateAndSumbit('sendShareUrl')}}},[_vm._v("Enviar")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('el-header',[_c('app-header',{attrs:{"is-user-logged":_vm.isUserLogged}})],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tuple", function() { return tuple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookupArray", function() { return lookupArray; });
// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var useSymbol = typeof Symbol === "function";

// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var brand = useSymbol
  ? Symbol.for("immutable-tuple")
  : "@@__IMMUTABLE_TUPLE__@@";

// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var globalKey = useSymbol
  ? Symbol.for("immutable-tuple-root")
  : "@@__IMMUTABLE_TUPLE_ROOT__@@";

// Convenient helper for defining hidden immutable properties.
function def(obj, name, value, enumerable) {
  Object.defineProperty(obj, name, {
    value: value,
    enumerable: !! enumerable,
    writable: false,
    configurable: false
  });
  return value;
}

var freeze = Object.freeze || function (obj) {
  return obj;
};

function isObjRef(value) {
  switch (typeof value) {
  case "object":
    if (value === null) {
      return false;
    }
  case "function":
    return true;
  default:
    return false;
  }
}

// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function forEachArrayMethod(fn) {
  function call(name, mustConvertThisToArray) {
    var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
    fn(name, desc, !! mustConvertThisToArray);
  }

  call("every");
  call("filter");
  call("find");
  call("findIndex");
  call("forEach");
  call("includes");
  call("indexOf");
  call("join");
  call("lastIndexOf");
  call("map");
  call("reduce");
  call("reduceRight");
  call("slice");
  call("some");
  call("toLocaleString");
  call("toString");

  // The `reverse` and `sort` methods are usually destructive, but for
  // `tuple` objects they return a new `tuple` object that has been
  // appropriately reversed/sorted.
  call("reverse", true);
  call("sort", true);

  // Make `[...someTuple]` work.
  call(useSymbol && Symbol.iterator || "@@iterator");
}

// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var UniversalWeakMap = function UniversalWeakMap() {
  // Since a `WeakMap` cannot hold primitive values as keys, we need a
  // backup `Map` instance to hold primitive keys. Both `this._weakMap`
  // and `this._strongMap` are lazily initialized.
  this._weakMap = null;
  this._strongMap = null;
  this.data = null;
};

// Since `get` and `set` are the only methods used, that's all I've
// implemented here.

UniversalWeakMap.prototype.get = function get (key) {
  var map = this._getMap(key, false);
  if (map) {
    return map.get(key);
  }
};

UniversalWeakMap.prototype.set = function set (key, value) {
  this._getMap(key, true).set(key, value);
  // An actual `Map` or `WeakMap` would return `this` here, but
  // returning the `value` is more convenient for the `tuple`
  // implementation.
  return value;
};

UniversalWeakMap.prototype._getMap = function _getMap (key, canCreate) {
  if (! canCreate) {
    return isObjRef(key) ? this._weakMap : this._strongMap;
  }
  if (isObjRef(key)) {
    return this._weakMap || (this._weakMap = new WeakMap);
  }
  return this._strongMap || (this._strongMap = new Map);
};

// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var root = Array[globalKey] || def(Array, globalKey, new UniversalWeakMap, false);

function lookup() {
  return lookupArray(arguments);
}

function lookupArray(array) {
  var node = root;

  // Because we are building a tree of *weak* maps, the tree will not
  // prevent objects in tuples from being garbage collected, since the
  // tree itself will be pruned over time when the corresponding `tuple`
  // objects become unreachable. In addition to internalization, this
  // property is a key advantage of the `immutable-tuple` package.
  var len = array.length;
  for (var i = 0; i < len; ++i) {
    var item = array[i];
    node = node.get(item) || node.set(item, new UniversalWeakMap);
  }

  // Return node.data rather than node itself to prevent tampering with
  // the UniversalWeakMap tree.
  return node.data || (node.data = Object.create(null));
}

// See [`lookup.js`](lookup.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function tuple() {
  var arguments$1 = arguments;

  var node = lookup.apply(null, arguments);

  if (node.tuple) {
    return node.tuple;
  }

  var t = Object.create(tuple.prototype);

  // Define immutable items with numeric indexes, and permanently fix the
  // `.length` property.
  var argc = arguments.length;
  for (var i = 0; i < argc; ++i) {
    t[i] = arguments$1[i];
  }

  def(t, "length", argc, false);

  // Remember this new `tuple` object so that we can return the same object
  // earlier next time.
  return freeze(node.tuple = t);
}

// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
def(tuple.prototype, brand, true, false);
function isTuple(that) {
  return !! (that && that[brand] === true);
}

tuple.isTuple = isTuple;

function toArray(tuple) {
  var array = [];
  var i = tuple.length;
  while (i--) { array[i] = tuple[i]; }
  return array;
}

// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
forEachArrayMethod(function (name, desc, mustConvertThisToArray) {
  var method = desc && desc.value;
  if (typeof method === "function") {
    desc.value = function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = method.apply(
        mustConvertThisToArray ? toArray(this) : this,
        args
      );
      // Of course, `tuple.prototype.slice` should return a `tuple` object,
      // not a new `Array`.
      return Array.isArray(result) ? tuple.apply(void 0, result) : result;
    };
    Object.defineProperty(tuple.prototype, name, desc);
  }
});

// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var ref = Array.prototype;
var concat = ref.concat;
tuple.prototype.concat = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return tuple.apply(void 0, concat.apply(toArray(this), args.map(
    function (item) { return isTuple(item) ? toArray(item) : item; }
  )));
};

/* harmony default export */ __webpack_exports__["default"] = (tuple);



/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strict */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_data_info__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user_info__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_app_info__ = __webpack_require__(1078);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    dataInfo: __WEBPACK_IMPORTED_MODULE_2__modules_data_info__["a" /* default */],
    userInfo: __WEBPACK_IMPORTED_MODULE_3__modules_user_info__["a" /* default */],
    appInfo: __WEBPACK_IMPORTED_MODULE_4__modules_app_info__["a" /* default */]
  },
  strict: false
}));
var strict = false;

/***/ }),

/***/ 1076:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 'state' declare the initial state of the data storaged
var state = {
  // New Portfolio form modes:
  // 1 - new portfolio,
  // 2 - continue portfolio draft
  // 3 - edit an already created portfolio
  formMode: 1,
  // Used in edition or continue draft
  portfolioId: '',
  formOne: {
    email: '',
    investor_profile: '',
    contract_number: '',
    cutoff_date: '',
    alias: '',
    clientId: 0
  },
  formTwo: [],
  totalInvestment: '',
  advisorComment: '',
  percentageBasedForm: false
};

// 'getters' are useful to get the data from the store and reuse it in the components
var getters = {
  getGeneralData: function getGeneralData(state) {
    return state.formOne;
  },
  getTransmitersData: function getTransmitersData(state) {
    return state.formTwo;
  },
  getFormMode: function getFormMode(state) {
    return state.formMode;
  },
  getSelectedPortfolio: function getSelectedPortfolio(state) {
    return state.portfolioId;
  },
  getAdvisorComment: function getAdvisorComment(state) {
    return state.advisorComment;
  },
  getFormValueTypes: function getFormValueTypes(state) {
    return state.percentageBasedForm;
  },
  getTotalInvestmentAmount: function getTotalInvestmentAmount(state) {
    return state.totalInvestment;
  }
};

// 'actions' call the mutations
var actions = {
  saveGeneralData: function saveGeneralData(context, data) {
    context.commit('updateDataFormOne', data);
  },
  saveInvestment: function saveInvestment(context, data) {
    context.commit('updateDataFormTwo', data);
  },
  deleteInvestment: function deleteInvestment(context, data) {
    context.commit('removeFromDataFormTwo', data);
  },
  resetPortfolioForm: function resetPortfolioForm(context, data) {
    context.commit('resetPortfolioForm', data);
  },
  preloadPortfolioForm: function preloadPortfolioForm(context, data) {
    context.commit('preloadPortfolioForm', data);
  },
  setFormMode: function setFormMode(context, data) {
    context.commit('updateFormMode', data);
  },
  setSelectedPortfolio: function setSelectedPortfolio(context, data) {
    context.commit('updatePortfolioId', data);
  },
  setPercentageBasedForm: function setPercentageBasedForm(context, data) {
    context.commit('updateFormValueTypes', data);
  },
  setTotalInvestment: function setTotalInvestment(context, data) {
    context.commit('updateTotalInvestment', data);
  }
};

// 'mutations' are the ones that modify the 'state'
var mutations = {
  updateDataFormOne: function updateDataFormOne(state, data) {
    state.formOne = data;
  },
  updateDataFormTwo: function updateDataFormTwo(state, data) {
    state.formTwo.push(data);
  },
  updateFormValueTypes: function updateFormValueTypes(state, data) {
    state.percentageBasedForm = data;
  },
  updateTotalInvestment: function updateTotalInvestment(state, data) {
    state.totalInvestment = data;
  },
  removeFromDataFormTwo: function removeFromDataFormTwo(state, data) {
    state.formTwo.splice(data, 1);
  },
  updateFormMode: function updateFormMode(state, data) {
    state.formMode = data;
  },
  updatePortfolioId: function updatePortfolioId(state, data) {
    state.portfolioId = data;
  },
  resetPortfolioForm: function resetPortfolioForm(state) {
    state.formOne = {
      email: '',
      investor_profile: '',
      contract_number: '',
      cutoff_date: '',
      alias: '',
      clientId: 0
    };
    state.formTwo = [];
    state.portfolioId = '';
    state.advisorComment = '';
    state.totalInvestment = '';
    state.percentageBasedForm = false;
  },
  preloadPortfolioForm: function preloadPortfolioForm(state, data) {
    state.formTwo = [];
    state.formOne = {
      email: data.client.email,
      contract_number: data.contractNumber,
      cutoff_date: data.cuttofDate,
      alias: data.client.alias,
      clientId: data.client.id
    };
    state.advisorComment = data.advisorComment;
    var investments = data.investmentSet;
    for (var item in investments) {
      var formattedInvestment = {
        assetClass: investments[item].asset.assetClass.id,
        assetClassLabel: investments[item].asset.assetClass.name,
        assetLabel: investments[item].asset.name,
        idAsset: investments[item].asset.id,
        price_of_note: investments[item].asset.price,
        totalAmount: investments[item].totalAmount,
        totalSecurities: investments[item].totalSecurities
      };
      state.formTwo.push(formattedInvestment);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
  // Syntax to call the maps for the different
  // import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

});

/***/ }),

/***/ 1077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  // initial state
  userIsLogged: false,
  userInfo: {},
  userIsAdmin: false
};

// getters
var getters = {
  userIsLogged: function userIsLogged(state) {
    return state.userIsLogged;
  },
  userInfo: function userInfo(state) {
    return state.userInfo;
  },
  userIsAdmin: function userIsAdmin(state) {
    return state.userIsAdmin;
  }
};

var actions = {
  saveUserData: function saveUserData(context, data) {
    context.commit('updateUserData', data);
  },
  deleteUserData: function deleteUserData(context, data) {
    context.commit('resetUserData');
  }
};

// mutations
var mutations = {
  updateUserData: function updateUserData(state, data) {
    state.userIsLogged = true;
    state.userInfo = data.advisor;
    state.userIsAdmin = data.advisor.isAdmin;
  },
  resetUserData: function resetUserData() {
    state.userIsLogged = false;
    state.userInfo = {};
    state.userIsAdmin = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  menuIsVisible: false,
  portfoliosData: [],
  advisorsData: [],
  currentPortfolioAnalysis: {}
};
var getters = {
  menuIsVisible: function menuIsVisible(state) {
    return state.menuIsVisible;
  },
  portfoliosData: function portfoliosData(state) {
    return state.portfoliosData;
  },
  advisorsData: function advisorsData(state) {
    return state.advisorsData;
  },
  currentPortfolioAnalysis: function currentPortfolioAnalysis(state) {
    return state.currentPortfolioAnalysis;
  },
  fondosrv: function fondosrv(state) {
    return state.currentPortfolioAnalysis.fondosRV;
  },
  fondosrf: function fondosrf(state) {
    return state.currentPortfolioAnalysis.fondosRF;
  },
  capitales: function capitales(state) {
    return state.currentPortfolioAnalysis.capitales;
  },
  deuda: function deuda(state) {
    return state.currentPortfolioAnalysis.deuda;
  },
  estructurados: function estructurados(state) {
    return state.currentPortfolioAnalysis.estructurados;
  },
  labels: function labels(state) {
    return state.currentPortfolioAnalysis.labels;
  }
};
var actions = {
  toggleMenu: function toggleMenu(context, data) {
    context.commit('updateIsMenuVisible', data);
  },
  savePortfolios: function savePortfolios(context, data) {
    context.commit('updatePortfoliosData', data);
  },
  saveAdvisors: function saveAdvisors(context, data) {
    context.commit('updateAdvisorsData', data);
  },
  saveCurrentPortfolioAnalysis: function saveCurrentPortfolioAnalysis(context, data) {
    context.commit('updatePortfolioAnalysis', data);
  }
};
var mutations = {
  updateIsMenuVisible: function updateIsMenuVisible(state, data) {
    state.menuIsVisible = data;
  },
  updatePortfoliosData: function updatePortfoliosData(state, data) {
    state.portfoliosData = data;
  },
  updateAdvisorsData: function updateAdvisorsData(state, data) {
    state.advisorsData = data;
  },
  updatePortfolioAnalysis: function updatePortfolioAnalysis(state, data) {
    state.currentPortfolioAnalysis = {};
    state.currentPortfolioAnalysis = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 1079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListPortfolios__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdvisorsTable__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RegisterGeneralData__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RegisterTransmiters__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RegisterConfirmation__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TestSection__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PortfolioOverview__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AssetClassDeuda__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AssetClassFondosRF__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AssetClassFondosRV__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AssetClassEstructurados__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AssetClassCapitales__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AssetDetailFondosRV__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AssetDetailFondosRF__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AssetDetailDeuda__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AssetDetailCapitales__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AssetDetailEstructurados__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PrintablePortfolioAnalysis__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ClientLogin__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ImportantLinks__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Validacion__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Calculator__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Calculator_Op1__ = __webpack_require__(1364);



























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/', // The URL that our router will read
    name: 'Login', // The name that will be show when we inspect our route
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */] // THe name we use to import our element
  }, {
    path: '/lista-de-analisis',
    name: 'Portfolios',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ListPortfolios__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/lista-de-asesores',
    name: 'Advisors',
    component: __WEBPACK_IMPORTED_MODULE_4__components_AdvisorsTable__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/registro-datos-generales',
    name: 'RegistroGeneral',
    component: __WEBPACK_IMPORTED_MODULE_5__components_RegisterGeneralData__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/registro-emisoras',
    name: 'RegistroEmisoras',
    component: __WEBPACK_IMPORTED_MODULE_6__components_RegisterTransmiters__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/registro-confirmacion',
    name: 'RegistroConfirmacion',
    component: __WEBPACK_IMPORTED_MODULE_7__components_RegisterConfirmation__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/seccion-de-pruebas',
    name: 'TestSection',
    component: __WEBPACK_IMPORTED_MODULE_8__components_TestSection__["a" /* default */]
  }, {
    path: '/analisis-portafolio/:id',
    name: 'PortfolioOverview',
    props: { props: true },
    component: __WEBPACK_IMPORTED_MODULE_9__components_PortfolioOverview__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/deuda',
    name: 'PortfolioAssetClassDeuda',
    component: __WEBPACK_IMPORTED_MODULE_10__components_AssetClassDeuda__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/fondosrf',
    name: 'AssetClassFondosRF',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_11__components_AssetClassFondosRF__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/fondosrv',
    name: 'AssetClassFondosRV',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_12__components_AssetClassFondosRV__["a" /* default */]
  }, {
    path: '/analisis-portafolio/:id/mercado/estructurados',
    name: 'AssetClassEstructurados',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_13__components_AssetClassEstructurados__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/capitales',
    name: 'AssetClassCapitales',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_14__components_AssetClassCapitales__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/fondosrv/detalle/:assetName',
    name: 'AssetDetail_fondosrv',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_15__components_AssetDetailFondosRV__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/fondosrf/detalle/:assetName',
    name: 'AssetDetail_fondosrf',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_16__components_AssetDetailFondosRF__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/deuda/detalle/:assetName',
    name: 'AssetDetail_deuda',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_17__components_AssetDetailDeuda__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/capitales/detalle/:assetName',
    name: 'AssetDetail_capitales',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_18__components_AssetDetailCapitales__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/analisis-portafolio/:id/mercado/estructurados/detalle/:assetName',
    name: 'AssetDetail_estructurados',
    props: { default: true },
    component: __WEBPACK_IMPORTED_MODULE_19__components_AssetDetailEstructurados__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/cliente',
    name: 'ClientLogin',
    props: function props(route) {
      return { query: route.query.portafolio };
    },
    component: __WEBPACK_IMPORTED_MODULE_21__components_ClientLogin__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/imprimir-analisis-portafolio/:id',
    name: 'PrintablePortfolioAnalysis',
    component: __WEBPACK_IMPORTED_MODULE_20__components_PrintablePortfolioAnalysis__["a" /* default */]
  }, {
    path: '/links',
    name: 'ImportantLinks',
    component: __WEBPACK_IMPORTED_MODULE_22__components_ImportantLinks__["a" /* default */]
  }, {
    path: '/validacion',
    name: 'Validacion',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Validacion__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/calculadora',
    name: 'Calculadora',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Calculator__["a" /* default */]
  }, {
    path: '/calculadora/opcion1',
    name: 'Op1',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Calculator_Op1__["a" /* default */]
  }]
}));

/***/ }),

/***/ 1081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71df8cb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71df8cb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71df8cb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"login-container"},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":10}},[_c('p',{staticClass:"login-label"},[_vm._v("Iniciar sesión")]),_vm._v(" "),_c('el-form',[_c('el-input',{attrs:{"placeholder":"Email","tabindex":"1"},model:{value:(_vm.userEmail),callback:function ($$v) {_vm.userEmail=$$v},expression:"userEmail"}}),_vm._v(" "),_c('el-input',{attrs:{"type":"password","placeholder":"Contraseña","tabindex":"2"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendLoginRequest($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('span',{staticClass:"forgot-password",attrs:{"tabindex":"3"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v("¿Olvidaste tu contraseña?")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.sendLoginRequest}},[_vm._v("Iniciar sesión")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Recuperar Contraseña","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"recover-password-container"},[_c('el-form',{ref:"recoverPassword",attrs:{"model":_vm.recoverPassword,"status-icon":"","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"card-input",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.recoverPassword.email),callback:function ($$v) {_vm.$set(_vm.recoverPassword, "email", $$v)},expression:"recoverPassword.email"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%","background-color":"#2873DE","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.validateAndSumbit('recoverPassword')}}},[_vm._v("Enviar")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPortfolios_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04da8de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPortfolios_vue__ = __webpack_require__(1086);
function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a04da8de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPortfolios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04da8de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPortfolios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"list-container"},[_c('el-row',{staticClass:"list-header",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"section-header",attrs:{"span":12}},[_c('span',{staticClass:"section-title"},[_vm._v("Portafolios")])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"new-portfolio",on:{"click":_vm.goToNewPortfolioForm}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v("Nuevo portafolio")])])],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":22}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"empty-text":"Sin resultados","data":_vm.portfolios,"cell-class-name":_vm.setStatusStyles},on:{"cell-click":_vm.goToPortfolio}},[_c('el-table-column',{attrs:{"prop":"client.alias","label":"Alias"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contractNumber","label":"No. de portafolio"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Fecha"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"version","label":"Versión"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Estatus"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"top"}},[_c('span',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"el-icon-more"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(scope.row.status === 'En progreso')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.continueDraft(scope.row.id)}}},[_vm._v("Continuar")]):_vm._e(),_vm._v(" "),(scope.row.status !== 'En progreso')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editPortfolio(scope.row.id)}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),(scope.row.status !== 'En progreso')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.updatePortfolio(scope.row.id)}}},[_vm._v("Actualizar")]):_vm._e(),_vm._v(" "),(scope.row.status !== 'En progreso' && _vm.userIsAdmin)?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.commentPortfolio(scope.row.id)}}},[_vm._v("Comentar")]):_vm._e(),_vm._v(" "),(scope.row.status !== 'En progreso')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.sendUrl(scope.row)}}},[_vm._v("Enviar enlace")]):_vm._e(),_vm._v(" "),(scope.row.status !== 'En progreso')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.deletePortfolio(scope.row.id)}}},[_c('span',{staticClass:"danger"},[_vm._v("Eliminar")])]):_vm._e()],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"send-url-container",attrs:{"title":"Enviar enlace","visible":_vm.displaySendUrlDialog},on:{"update:visible":function($event){_vm.displaySendUrlDialog=$event}}},[_c('div',[_c('el-form',{ref:"sendShareUrl",attrs:{"model":_vm.sendUrlData,"status-icon":"","rules":_vm.rules}},[_c('span',[_vm._v(" Email ")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email"}},[_c('el-input',{staticClass:"send-url",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.sendUrlData.email),callback:function ($$v) {_vm.$set(_vm.sendUrlData, "email", $$v)},expression:"sendUrlData.email"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%","background-color":"#2873DE","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.validateAndSumbit('sendShareUrl')}}},[_vm._v("Enviar")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvisorsTable_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b082bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvisorsTable_vue__ = __webpack_require__(1090);
function injectStyle (ssrContext) {
  __webpack_require__(1088)
  __webpack_require__(1089)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b082bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvisorsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b082bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvisorsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"top-section"},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"container-section-title"},[_c('p',{staticClass:"section-title"},[_vm._v("Asesores")])])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"add-advisor-button"},[_c('div',{staticClass:"container-edit-text",on:{"click":function($event){_vm.dialogVisible = true}}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('p',[_vm._v("Crear cuenta")])])])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":22}},[_c('el-main',{staticClass:"list-container"},[_c('el-table',{attrs:{"empty-text":"Sin resultados","data":_vm.advisors}},[_c('el-table-column',{attrs:{"prop":"name","label":"Nombre","label-class-name":"label-selector"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"Correo electrónico"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"index","width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"top"}},[_c('span',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"el-icon-more"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.recoverPassword(scope.row.email)}}},[_vm._v("Recuperar contraseña")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm._deleteUser(scope.row.id)}}},[_vm._v("Dar de baja")])],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Crear cuenta","visible":_vm.dialogVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"dialogo-card-content"},[_c('el-form',{ref:"registryData",attrs:{"model":_vm.registryData,"status-icon":"","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":"Nombre","prop":"name"}},[_c('el-input',{staticClass:"card-input",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.registryData.name),callback:function ($$v) {_vm.$set(_vm.registryData, "name", $$v)},expression:"registryData.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"card-input",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.registryData.email),callback:function ($$v) {_vm.$set(_vm.registryData, "email", $$v)},expression:"registryData.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Contraseña","prop":"password"}},[_c('el-input',{staticClass:"card-input",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},model:{value:(_vm.registryData.password),callback:function ($$v) {_vm.$set(_vm.registryData, "password", $$v)},expression:"registryData.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Confirmar contraseña","prop":"confirm_password"}},[_c('el-input',{staticClass:"card-input",attrs:{"placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off","required":true},model:{value:(_vm.registryData.confirm_password),callback:function ($$v) {_vm.$set(_vm.registryData, "confirm_password", $$v)},expression:"registryData.confirm_password"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"width":"100%","background-color":"#2873DE","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.validateAndSumbit('registryData')}}},[_vm._v("Crear cuenta")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterGeneralData_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62faa83b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterGeneralData_vue__ = __webpack_require__(1095);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62faa83b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterGeneralData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62faa83b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterGeneralData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb_container"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":4,"offset":2}},[_c('div',{staticClass:"numberCircle",attrs:{"id":"numberCircle1"}},[_vm._v("1")])]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('i',{staticClass:"el-icon-arrow-right"})]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"numberCircle",attrs:{"id":"numberCircle2"}},[_vm._v("2")])]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('i',{staticClass:"el-icon-arrow-right"})]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"numberCircle",attrs:{"id":"numberCircle3"}},[_vm._v("3")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main form-container"},[_c('h2',[_vm._v("Nuevo analisis de Portafolio")]),_vm._v(" "),_c('el-form',{ref:"generalData",attrs:{"model":_vm.generalData,"status-icon":"","rules":_vm.formRules}},[_c('breadcrumbs',{staticClass:"breadcrumbs",attrs:{"section":"1"}}),_vm._v(" "),_c('h3',{staticClass:"second-title"},[_vm._v("Información general")]),_vm._v(" "),_c('el-form-item',{staticClass:"alias-input",attrs:{"label":"Alias","prop":"alias"}},[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.fetchClients,"trigger-on-focus":false,"prefix-icon":"el-icon-edit"},on:{"select":_vm.handleClientSelect},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"link",attrs:{"value":item.value}},[_vm._v(_vm._s(item.alias))])]}}]),model:{value:(_vm.selectedClient),callback:function ($$v) {_vm.selectedClient=$$v},expression:"selectedClient"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"No. de contrato","prop":"contract_number"}},[_c('el-tooltip',{attrs:{"content":"Se encuentra en el estado de cuenta por analizar en la parte superior","placement":"top"}},[_c('i',{staticClass:"el-icon-question label-tooltip"})]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"","prefix-icon":"el-icon-edit"},model:{value:(_vm.generalData.contract_number),callback:function ($$v) {_vm.$set(_vm.generalData, "contract_number", $$v)},expression:"generalData.contract_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Correo electrónico (opcional)","prop":"email"}},[_c('el-input',{attrs:{"placeholder":"","prefix-icon":"el-icon-edit"},model:{value:(_vm.generalData.email),callback:function ($$v) {_vm.$set(_vm.generalData, "email", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"generalData.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Fecha de corte","prop":"cutoff_date"}},[_c('el-date-picker',{attrs:{"type":"month","value-format":"yyyy-MM-dd","placeholder":"AAAA-MM","picker-options":_vm.pickerOptions},model:{value:(_vm.generalData.cutoff_date),callback:function ($$v) {_vm.$set(_vm.generalData, "cutoff_date", $$v)},expression:"generalData.cutoff_date"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"container-continue-button",on:{"click":function($event){_vm.validateForm('generalData')}}},[_c('p',{staticClass:"continue-button"},[_vm._v("Continuar")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right blue-arrow-icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTransmiters_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67319ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTransmiters_vue__ = __webpack_require__(1098);
function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67319ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTransmiters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67319ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTransmiters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',[_vm._v("Nuevo análisis de Portafolio")]),_vm._v(" "),_c('el-form',{ref:"investmentData",attrs:{"model":_vm.investmentData,"status-icon":"","rules":_vm.formRules}},[_c('breadcrumbs',{staticClass:"breadcrumbs",attrs:{"section":"2"}}),_vm._v(" "),_c('h3',{staticClass:"second-title"},[_vm._v("Agregar Emisoras")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Mercado","prop":"assetClass"}},[_c('el-select',{on:{"change":_vm.clearAssets},model:{value:(_vm.investmentData.assetClass),callback:function ($$v) {_vm.$set(_vm.investmentData, "assetClass", $$v)},expression:"investmentData.assetClass"}},_vm._l((_vm.assetClasses),function(item){return _c('el-option-group',{key:item.id,attrs:{"label":item.name,"value":item.id}},_vm._l((item.options),function(assetClass){return _c('el-option',{key:assetClass.id,attrs:{"label":assetClass.name,"value":assetClass.id}})}))}))],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Emisora","prop":"idAsset"}},[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.fetchInvestments,"trigger-on-focus":false,"placeholder":"Buscar por nombre de emisora"},on:{"select":_vm.handleInvestmentSelect},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"link",attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])]}}]),model:{value:(_vm.investmentData.assetLabel),callback:function ($$v) {_vm.$set(_vm.investmentData, "assetLabel", $$v)},expression:"investmentData.assetLabel"}}),_vm._v(" "),(_vm.showNoResultsError)?_c('div',{staticClass:"input-message"},[_vm._v("Ninguna emisora coincide")]):_vm._e(),_vm._v(" "),(_vm.showCreatingNE)?_c('div',{staticClass:"input-message"},[_vm._v("Estarás creando una nota estructurada")]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.usePercentageForm)?_c('el-form-item',{attrs:{"label":"Monto total del portafolio","prop":"totalInvestment"}},[_c('money',_vm._b({class:{'disabled': _vm.currentInvestments.length > 0},attrs:{"disabled":_vm.currentInvestments.length > 0},nativeOn:{"input":function($event){return _vm.getTotalAmount($event)}},model:{value:(_vm.totalInvestment),callback:function ($$v) {_vm.totalInvestment=$$v},expression:"totalInvestment"}},'money',_vm.currencyFormat,false))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"totalSecurities"}},[_c('el-col',{class:['customButtonA',{'selected': !_vm.usePercentageForm}],staticStyle:{"margin-bottom":"6px"},attrs:{"span":12}},[_c('p',{on:{"click":function($event){_vm.togglePercentage()}}},[_vm._v("No. de títulos")])]),_vm._v(" "),_c('el-col',{class:['customButtonB',{'selected': _vm.usePercentageForm}],attrs:{"span":12}},[_c('p',{on:{"click":function($event){_vm.togglePercentage()}}},[_vm._v("%")])]),_vm._v(" "),(_vm.usePercentageForm)?_c('money',_vm._b({nativeOn:{"input":function($event){return _vm.getTotalAmount($event)}},model:{value:(_vm.investmentData.totalSecurities),callback:function ($$v) {_vm.$set(_vm.investmentData, "totalSecurities", $$v)},expression:"investmentData.totalSecurities"}},'money',_vm.percentageFormat,false)):_c('money',_vm._b({nativeOn:{"input":function($event){return _vm.getTotalAmount($event)}},model:{value:(_vm.investmentData.totalSecurities),callback:function ($$v) {_vm.$set(_vm.investmentData, "totalSecurities", $$v)},expression:"investmentData.totalSecurities"}},'money',_vm.securitiesFormat,false))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Precio","prop":"price_of_note"}},[_c('money',_vm._b({class:{'disabled' : !this.isNEAssetClass || _vm.NEExists},attrs:{"disabled":!this.isNEAssetClass || _vm.NEExists},on:{"change":_vm.getTotalAmountAndSecurities},model:{value:(_vm.investmentData.price_of_note),callback:function ($$v) {_vm.$set(_vm.investmentData, "price_of_note", $$v)},expression:"investmentData.price_of_note"}},'money',_vm.currencyFormat,false))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Monto Invertido","prop":"totalAmount"}},[_c('money',{class:{'disabled':_vm.usePercentageForm},attrs:{"disabled":_vm.usePercentageForm},model:{value:(_vm.investmentData.totalAmount),callback:function ($$v) {_vm.$set(_vm.investmentData, "totalAmount", $$v)},expression:"investmentData.totalAmount"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":14}},[_c('div',{staticClass:"blue-button",on:{"click":function($event){_vm.validateAsset('investmentData')}}},[_c('p',[_vm._v("Agregar")])]),_vm._v(" "),(_vm.showDuplicateAssetError)?_c('div',{staticClass:"error-message"},[_vm._v("Esta emisora ya ha sido agregada")]):_vm._e()])],1),_vm._v(" "),(_vm.currentInvestments.length > 0)?_c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('p',{staticClass:"subtitle"},[_vm._v("Emisoras")])])],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.currentInvestments}},[_c('el-table-column',{attrs:{"prop":"assetClassLabel","label":"Mercado","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assetLabel","label":"Emisora","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalSecurities","label":_vm.usePercentageForm ? 'Porcentaje': 'Numero de titulos',"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_vm._v(" "+_vm._s(_vm.formatSecurities(scope.row.totalSecurities))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price_of_note","label":"Precio de la nota","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_vm._v(" "+_vm._s(_vm.formatPrice(scope.row.price_of_note))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalAmount","label":"Monto invertido","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_vm._v(" "+_vm._s(_vm.formatPrice(scope.row.totalAmount))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"index","width":"30"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{staticClass:"el-icon-circle-close-outline",on:{"click":function($event){_vm._deleteAsset(scope.$index)}}})]}}])})],1)],1):_vm._e(),_vm._v(" "),(_vm.showPercentageError)?_c('div',{staticClass:"error-message"},[_vm._v("Es necesario que los montos agregados sumen el 100% del portafolio")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottom-section"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"container-back-button"},[_c('router-link',{attrs:{"to":"/registro-datos-generales"}},[_c('i',{staticClass:"el-icon-arrow-left blue-arrow-icon"}),_vm._v(" "),_c('p',{staticClass:"back-button"},[_vm._v("Atrás")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticStyle:{"margin-left":"auto","margin-right":"0px","display":"block","width":"142px"},on:{"click":function($event){_vm.goToConfirmation()}}},[_c('p',{staticClass:"continue-button"},[_vm._v("Continuar")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right blue-arrow-icon"})])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterConfirmation_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c83251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterConfirmation_vue__ = __webpack_require__(1101);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66c83251"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterConfirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c83251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterConfirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getLastDataDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdvisorData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getAllAdvisors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAdvisorsByQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAllPortfolios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getPortfoliosByAdvisorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getPortfolioById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPortfolioByUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getClientsByAdvisor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return recoverPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getAssetClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getAssets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPortfolioAnalysis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAdvisor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteAdvisor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deletePortfolio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAsset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPortfolio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return upgradePortfolio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sendUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAllValidations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateValidationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCalculation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery lastData {\n  getLastDataDate\n}'], ['\nquery lastData {\n  getLastDataDate\n}']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery advisor ($id: Int!) {\n  advisor(id: $id) {\n    id\n    email\n    isAdmin\n    name\n  }\n}\n'], ['\nquery advisor ($id: Int!) {\n  advisor(id: $id) {\n    id\n    email\n    isAdmin\n    name\n  }\n}\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query allAdvisors {\n    allAdvisors {\n      id\n      name\n      email\n    }\n  }'], ['\n  query allAdvisors {\n    allAdvisors {\n      id\n      name\n      email\n    }\n  }']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery getAdvisorsByFilter ($query: String) {\n  findAdvisors(nameOrEmail: $query) {\n    id\n    name\n    email\n  }\n}'], ['\nquery getAdvisorsByFilter ($query: String) {\n  findAdvisors(nameOrEmail: $query) {\n    id\n    name\n    email\n  }\n}']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query allPortfolios {\n    allPortfolios {\n      client {\n        id\n        alias\n        email\n      },\n      id\n      status\n      contractNumber\n      createdAt\n      version\n    }\n  }'], ['\n  query allPortfolios {\n    allPortfolios {\n      client {\n        id\n        alias\n        email\n      },\n      id\n      status\n      contractNumber\n      createdAt\n      version\n    }\n  }']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query getPortfoliosByAdvisorId ($advisorId: Int, $query: String) {\n    portfoliosByAdvisor(advisorId: $advisorId, aliasOrContractNumber: $query) {\n      id\n      client {\n        id\n        alias\n        email\n      }\n      status\n      cuttofDate\n      contractNumber\n      updatedAt\n      createdAt\n      version\n      investmentSet {\n        id\n        asset {\n          id\n          name\n          assetClass {\n            name\n            id\n          }\n          price\n        }\n        totalAmount\n        totalSecurities\n      }\n    }\n  }'], ['\n  query getPortfoliosByAdvisorId ($advisorId: Int, $query: String) {\n    portfoliosByAdvisor(advisorId: $advisorId, aliasOrContractNumber: $query) {\n      id\n      client {\n        id\n        alias\n        email\n      }\n      status\n      cuttofDate\n      contractNumber\n      updatedAt\n      createdAt\n      version\n      investmentSet {\n        id\n        asset {\n          id\n          name\n          assetClass {\n            name\n            id\n          }\n          price\n        }\n        totalAmount\n        totalSecurities\n      }\n    }\n  }']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery portfolioById($id: Int!) {\n  portfolioById(portfolioId: $id) {\n    id\n    client {\n      id\n      alias\n      email\n    }\n    advisorComment\n    status\n    cuttofDate\n    contractNumber\n    investmentSet {\n      id\n      asset {\n        id\n        name\n        assetClass {\n          name\n          id\n        }\n        price\n      }\n      totalAmount\n      totalSecurities\n    }\n  }\n}'], ['\nquery portfolioById($id: Int!) {\n  portfolioById(portfolioId: $id) {\n    id\n    client {\n      id\n      alias\n      email\n    }\n    advisorComment\n    status\n    cuttofDate\n    contractNumber\n    investmentSet {\n      id\n      asset {\n        id\n        name\n        assetClass {\n          name\n          id\n        }\n        price\n      }\n      totalAmount\n      totalSecurities\n    }\n  }\n}']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query getPortfolioByUrl ($hash: String!, $password: String!){\n    portfolioAnalysisByUrl(hash: $hash, password: $password) {\n      analysisPortfolio {\n        portfolioId\n        contractNumber\n        updatedDataAt\n        creationDate\n        alias\n        labels {\n          month\n          lastYear\n          year1\n          year2\n          year3\n          accum\n        }\n        totalInvestment\n        portfolioProfile\n        advisorComment\n        portfolioComments {\n          id\n          comment\n        }\n        representativePositions {\n          assetName\n          assetClass\n          percentage\n          color\n        }\n        marketInformation {\n          name\n          monthYield\n          accumulatedYield\n        }\n        fondosRV {\n          assetClassId\n          marketName\n          percentage\n          amount\n          comments {\n            id\n          }\n          investments {\n            assetName\n            assetId\n            percentage\n            amount\n            accumulatedYield\n            commission\n            securities\n            price\n            instrumentComposition {\n              name\n              inversionType{\n                name\n              }\n              percentage\n            }\n            comments {\n              comment\n            }\n            benchmarkComparative {\n              assetsData\n              benchmarkData\n            }\n          }\n          accumulatedYields\n          investmentsYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          comissions\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n        }\n        fondosRF {\n          assetClassId\n          marketName\n          percentage\n          amount\n          comments {\n            id\n          }\n          investments {\n            assetName\n            assetId\n            percentage\n            score\n            sliderValue {\n              value\n            }\n            amount\n            accumulatedYield\n            commission\n            securities\n            price\n            investmentYield {\n              assetName\n              year1\n              year2\n              year3\n              accumulatedYield\n            }\n            instrumentComposition {\n              name\n              inversionType{\n                name\n              }\n              percentage\n            }\n            benchmarkComparative {\n              assetsData\n              benchmarkData\n            }\n            comments {\n              comment\n            }\n          }\n          accumulatedYields\n          investmentsYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          comissions\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n        }\n        capitales {\n          assetClassId\n          marketName\n          percentage\n          amount\n          accumulatedYields\n          benchmarkYields\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            completeName\n            assetType\n            sector\n            bursatility\n            investmentYield {\n              assetName\n              initialPrice\n              currentPrice\n              accumulatedYield\n              weightedAccumulatedYield\n            }\n            comments {\n              comment\n            }\n          }\n          investmentsYield {\n            assetName\n            initialPrice\n            currentPrice\n            accumulatedYield\n            weightedAccumulatedYield\n          }\n          sectorDistribution {\n            name\n            percentage\n          }\n          comments {\n            id\n          }\n        }\n        deuda {\n          couponData {\n            assetName\n            frecuency\n            tasa\n            endData\n            ytm\n          }\n          assetClassId\n          marketName\n          percentage\n          amount\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            assetType\n            rateType\n            score\n            couponData {\n              assetName\n              tasa\n              frecuency\n              endData\n              ytm\n            }\n            sliderValue {\n              value\n            }\n            comments {\n              comment\n            }\n          }\n          assetTypesDistribution {\n            name\n            percentage\n          }\n          assetRateDistribution {\n            name\n            percentage\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n          comments {\n            comment\n          }\n        }\n        estructurados {\n          assetClassId\n          marketName\n          percentage\n          amount\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            assetType\n            rateType\n            score\n          }\n          assetTypesDistribution {\n            name\n            percentage\n          }\n          assetRateDistribution {\n            name\n            percentage\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n          comments {\n            comment\n          }\n        }\n      }\n      msg\n      returnCode\n    }\n  }'], ['\n  query getPortfolioByUrl ($hash: String!, $password: String!){\n    portfolioAnalysisByUrl(hash: $hash, password: $password) {\n      analysisPortfolio {\n        portfolioId\n        contractNumber\n        updatedDataAt\n        creationDate\n        alias\n        labels {\n          month\n          lastYear\n          year1\n          year2\n          year3\n          accum\n        }\n        totalInvestment\n        portfolioProfile\n        advisorComment\n        portfolioComments {\n          id\n          comment\n        }\n        representativePositions {\n          assetName\n          assetClass\n          percentage\n          color\n        }\n        marketInformation {\n          name\n          monthYield\n          accumulatedYield\n        }\n        fondosRV {\n          assetClassId\n          marketName\n          percentage\n          amount\n          comments {\n            id\n          }\n          investments {\n            assetName\n            assetId\n            percentage\n            amount\n            accumulatedYield\n            commission\n            securities\n            price\n            instrumentComposition {\n              name\n              inversionType{\n                name\n              }\n              percentage\n            }\n            comments {\n              comment\n            }\n            benchmarkComparative {\n              assetsData\n              benchmarkData\n            }\n          }\n          accumulatedYields\n          investmentsYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          comissions\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n        }\n        fondosRF {\n          assetClassId\n          marketName\n          percentage\n          amount\n          comments {\n            id\n          }\n          investments {\n            assetName\n            assetId\n            percentage\n            score\n            sliderValue {\n              value\n            }\n            amount\n            accumulatedYield\n            commission\n            securities\n            price\n            investmentYield {\n              assetName\n              year1\n              year2\n              year3\n              accumulatedYield\n            }\n            instrumentComposition {\n              name\n              inversionType{\n                name\n              }\n              percentage\n            }\n            benchmarkComparative {\n              assetsData\n              benchmarkData\n            }\n            comments {\n              comment\n            }\n          }\n          accumulatedYields\n          investmentsYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          comissions\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n        }\n        capitales {\n          assetClassId\n          marketName\n          percentage\n          amount\n          accumulatedYields\n          benchmarkYields\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            completeName\n            assetType\n            sector\n            bursatility\n            investmentYield {\n              assetName\n              initialPrice\n              currentPrice\n              accumulatedYield\n              weightedAccumulatedYield\n            }\n            comments {\n              comment\n            }\n          }\n          investmentsYield {\n            assetName\n            initialPrice\n            currentPrice\n            accumulatedYield\n            weightedAccumulatedYield\n          }\n          sectorDistribution {\n            name\n            percentage\n          }\n          comments {\n            id\n          }\n        }\n        deuda {\n          couponData {\n            assetName\n            frecuency\n            tasa\n            endData\n            ytm\n          }\n          assetClassId\n          marketName\n          percentage\n          amount\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            assetType\n            rateType\n            score\n            couponData {\n              assetName\n              tasa\n              frecuency\n              endData\n              ytm\n            }\n            sliderValue {\n              value\n            }\n            comments {\n              comment\n            }\n          }\n          assetTypesDistribution {\n            name\n            percentage\n          }\n          assetRateDistribution {\n            name\n            percentage\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n          comments {\n            comment\n          }\n        }\n        estructurados {\n          assetClassId\n          marketName\n          percentage\n          amount\n          investments {\n            assetName\n            assetId\n            percentage\n            price\n            amount\n            securities\n            assetType\n            rateType\n            score\n          }\n          assetTypesDistribution {\n            name\n            percentage\n          }\n          assetRateDistribution {\n            name\n            percentage\n          }\n          scoreDistribution {\n            name\n            percentage\n          }\n          comments {\n            comment\n          }\n        }\n      }\n      msg\n      returnCode\n    }\n  }']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query clientsByAdvisor ($advisorId: Int!) {\n    clientsByAdvisor(advisorId: $advisorId) {\n      id\n      alias\n      email\n    }\n  }'], ['\n  query clientsByAdvisor ($advisorId: Int!) {\n    clientsByAdvisor(advisorId: $advisorId) {\n      id\n      alias\n      email\n    }\n  }']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery recoverPassword ($email: String!) {\n  recoverPassword (advisorEmail: $email){\n    msg\n  }\n}'], ['\nquery recoverPassword ($email: String!) {\n  recoverPassword (advisorEmail: $email){\n    msg\n  }\n}']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query allAssetClasses {\n    allAssetClasses {\n      id\n      name\n    }\n  }'], ['\n  query allAssetClasses {\n    allAssetClasses {\n      id\n      name\n    }\n  }']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query getAssets ($cuttofDate: Date, $idAssetClass: Int, $startsWith: String) {\n    allAssets(cuttofDate: $cuttofDate, idAssetClass: $idAssetClass, startsWith: $startsWith) {\n      id\n      name\n      price\n      assetClass {\n        id\n        name\n      }\n    }\n  }'], ['\n  query getAssets ($cuttofDate: Date, $idAssetClass: Int, $startsWith: String) {\n    allAssets(cuttofDate: $cuttofDate, idAssetClass: $idAssetClass, startsWith: $startsWith) {\n      id\n      name\n      price\n      assetClass {\n        id\n        name\n      }\n    }\n  }']),
    _templateObject13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query makePortfolioAnalysis ($id: Int!) {\n    portfolioAnalysis(portfolioId: $id) {\n      contractNumber\n      creationDate\n      updatedDataAt\n      alias\n      email\n      labels {\n        month\n        lastYear\n        year1\n        year2\n        year3\n        accum\n      }\n      totalInvestment\n      portfolioProfile\n      advisorComment\n      portfolioComments {\n        id\n        comment\n      }\n      representativePositions {\n        assetName\n        assetClass\n        percentage\n        color\n      }\n      marketInformation {\n        name\n        monthYield\n        accumulatedYield\n      }\n      fondosRV {\n        assetClassId\n        marketName\n        percentage\n        amount\n        comments {\n          id\n          comment\n        }\n        investments {\n          assetName\n          assetId\n          percentage\n          amount\n          accumulatedYield\n          commission\n          securities\n          price\n          instrumentComposition {\n            name\n            inversionType{\n              name\n            }\n            percentage\n          }\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          comments {\n            comment\n          }\n        }\n        accumulatedYields\n        investmentsYield {\n          assetName\n          year1\n          year2\n          year3\n          accumulatedYield\n        }\n        comissions\n        benchmarkComparative {\n          assetsData\n          benchmarkData\n        }\n      }\n      fondosRF {\n        assetClassId\n        marketName\n        percentage\n        amount\n        comments {\n          id\n          comment\n        }\n        investments {\n          assetName\n          assetId\n          percentage\n          amount\n          score\n          sliderValue {\n            value\n          }\n          investmentYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          accumulatedYield\n          commission\n          securities\n          price\n          instrumentComposition {\n            name\n            inversionType{\n              name\n            }\n            percentage\n          }\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          comments {\n            comment\n          }\n        }\n        accumulatedYields\n        investmentsYield {\n          assetName\n          year1\n          year2\n          year3\n          accumulatedYield\n        }\n        comissions\n        benchmarkComparative {\n          assetsData\n          benchmarkData\n        }\n        scoreDistribution {\n            name\n            percentage\n        }\n      }\n      capitales {\n        assetClassId\n        marketName\n        percentage\n        amount\n        accumulatedYields\n        benchmarkYields\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          completeName\n          assetType\n          sector\n          bursatility\n          investmentYield {\n            assetName\n            initialPrice\n            currentPrice\n            accumulatedYield\n            weightedAccumulatedYield\n          }\n          comments {\n            comment\n          }\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        sectorDistribution {\n          name\n          percentage\n        }\n        comments {\n          id\n          comment\n        }\n      }\n      deuda {\n        couponData {\n          assetName\n          frecuency\n          tasa\n          endData\n          ytm\n        }\n        assetClassId\n        marketName\n        percentage\n        amount\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          assetType\n          rateType\n          score\n          couponData {\n            assetName\n            tasa\n            frecuency\n            endData\n            ytm\n          }\n          sliderValue {\n            value\n          }\n          comments {\n            comment\n          }\n        }\n        assetTypesDistribution {\n          name\n          percentage\n        }\n        assetRateDistribution {\n          name\n          percentage\n        }\n        scoreDistribution {\n          name\n          percentage\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          vouchersAndAmortizations\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        comments {\n          id\n          comment\n        }\n      }\n      estructurados {\n        assetClassId\n        marketName\n        percentage\n        amount\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          assetType\n          rateType\n          score\n          comments {\n            comment\n          }\n        }\n        assetTypesDistribution {\n          name\n          percentage\n        }\n        assetRateDistribution {\n          name\n          percentage\n        }\n        scoreDistribution {\n          name\n          percentage\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          vouchersAndAmortizations\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        comments {\n          id\n          comment\n        }\n      }\n    }\n  }\n'], ['\n  query makePortfolioAnalysis ($id: Int!) {\n    portfolioAnalysis(portfolioId: $id) {\n      contractNumber\n      creationDate\n      updatedDataAt\n      alias\n      email\n      labels {\n        month\n        lastYear\n        year1\n        year2\n        year3\n        accum\n      }\n      totalInvestment\n      portfolioProfile\n      advisorComment\n      portfolioComments {\n        id\n        comment\n      }\n      representativePositions {\n        assetName\n        assetClass\n        percentage\n        color\n      }\n      marketInformation {\n        name\n        monthYield\n        accumulatedYield\n      }\n      fondosRV {\n        assetClassId\n        marketName\n        percentage\n        amount\n        comments {\n          id\n          comment\n        }\n        investments {\n          assetName\n          assetId\n          percentage\n          amount\n          accumulatedYield\n          commission\n          securities\n          price\n          instrumentComposition {\n            name\n            inversionType{\n              name\n            }\n            percentage\n          }\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          comments {\n            comment\n          }\n        }\n        accumulatedYields\n        investmentsYield {\n          assetName\n          year1\n          year2\n          year3\n          accumulatedYield\n        }\n        comissions\n        benchmarkComparative {\n          assetsData\n          benchmarkData\n        }\n      }\n      fondosRF {\n        assetClassId\n        marketName\n        percentage\n        amount\n        comments {\n          id\n          comment\n        }\n        investments {\n          assetName\n          assetId\n          percentage\n          amount\n          score\n          sliderValue {\n            value\n          }\n          investmentYield {\n            assetName\n            year1\n            year2\n            year3\n            accumulatedYield\n          }\n          accumulatedYield\n          commission\n          securities\n          price\n          instrumentComposition {\n            name\n            inversionType{\n              name\n            }\n            percentage\n          }\n          benchmarkComparative {\n            assetsData\n            benchmarkData\n          }\n          comments {\n            comment\n          }\n        }\n        accumulatedYields\n        investmentsYield {\n          assetName\n          year1\n          year2\n          year3\n          accumulatedYield\n        }\n        comissions\n        benchmarkComparative {\n          assetsData\n          benchmarkData\n        }\n        scoreDistribution {\n            name\n            percentage\n        }\n      }\n      capitales {\n        assetClassId\n        marketName\n        percentage\n        amount\n        accumulatedYields\n        benchmarkYields\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          completeName\n          assetType\n          sector\n          bursatility\n          investmentYield {\n            assetName\n            initialPrice\n            currentPrice\n            accumulatedYield\n            weightedAccumulatedYield\n          }\n          comments {\n            comment\n          }\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        sectorDistribution {\n          name\n          percentage\n        }\n        comments {\n          id\n          comment\n        }\n      }\n      deuda {\n        couponData {\n          assetName\n          frecuency\n          tasa\n          endData\n          ytm\n        }\n        assetClassId\n        marketName\n        percentage\n        amount\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          assetType\n          rateType\n          score\n          couponData {\n            assetName\n            tasa\n            frecuency\n            endData\n            ytm\n          }\n          sliderValue {\n            value\n          }\n          comments {\n            comment\n          }\n        }\n        assetTypesDistribution {\n          name\n          percentage\n        }\n        assetRateDistribution {\n          name\n          percentage\n        }\n        scoreDistribution {\n          name\n          percentage\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          vouchersAndAmortizations\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        comments {\n          id\n          comment\n        }\n      }\n      estructurados {\n        assetClassId\n        marketName\n        percentage\n        amount\n        investments {\n          assetName\n          assetId\n          percentage\n          price\n          amount\n          securities\n          assetType\n          rateType\n          score\n          comments {\n            comment\n          }\n        }\n        assetTypesDistribution {\n          name\n          percentage\n        }\n        assetRateDistribution {\n          name\n          percentage\n        }\n        scoreDistribution {\n          name\n          percentage\n        }\n        investmentsYield {\n          assetName\n          initialPrice\n          currentPrice\n          vouchersAndAmortizations\n          accumulatedYield\n          weightedAccumulatedYield\n        }\n        comments {\n          id\n          comment\n        }\n      }\n    }\n  }\n']),
    _templateObject14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation login ($username: String!, $password: String!) {\n    advisorLogin (username: $username, password: $password ){\n      token\n      message\n      advisor {\n        id\n        email\n        isAdmin\n        name\n      }\n    }\n  }'], ['\n  mutation login ($username: String!, $password: String!) {\n    advisorLogin (username: $username, password: $password ){\n      token\n      message\n      advisor {\n        id\n        email\n        isAdmin\n        name\n      }\n    }\n  }']),
    _templateObject15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createAdvisor($name: String!, $password: String!, $email: String) {\n  createUser(name: $name, password: $password, email: $email, isAdmin: false) {\n    message\n    returnCode\n  }\n}'], ['\n  mutation createAdvisor($name: String!, $password: String!, $email: String) {\n  createUser(name: $name, password: $password, email: $email, isAdmin: false) {\n    message\n    returnCode\n  }\n}']),
    _templateObject16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation removeAdvisor($advisorId: Int!) {\n    removeUser(id: $advisorId) {\n      message\n      returnCode\n    }\n  }\n'], ['\n  mutation removeAdvisor($advisorId: Int!) {\n    removeUser(id: $advisorId) {\n      message\n      returnCode\n    }\n  }\n']),
    _templateObject17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation removePortfolio($portfolioId: Int!) {\n    removePortfolio(id: $portfolioId) {\n      message\n      returnCode\n    }\n  }\n'], ['\n  mutation removePortfolio($portfolioId: Int!) {\n    removePortfolio(id: $portfolioId) {\n      message\n      returnCode\n    }\n  }\n']),
    _templateObject18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createClient ( $advisorId: Int!, $alias: String!, $email: String){\n    createClient(advisorId: $advisorId, alias: $alias, email: $email) {\n      client {\n        id\n        alias\n        email\n      }\n      message\n      returnCode\n    }\n  }'], ['\n  mutation createClient ( $advisorId: Int!, $alias: String!, $email: String){\n    createClient(advisorId: $advisorId, alias: $alias, email: $email) {\n      client {\n        id\n        alias\n        email\n      }\n      message\n      returnCode\n    }\n  }']),
    _templateObject19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nmutation addAsset($name: String!, $assetClassId: Int!, $price: Float!, $period: Date!) {\n  createAsset(name: $name, assetClassId: $assetClassId, price: $price, period: $period) {\n    asset {\n      id,\n      name\n      price\n      assetClass {\n        id\n        name\n      }\n    }\n    message\n  }\n}'], ['\nmutation addAsset($name: String!, $assetClassId: Int!, $price: Float!, $period: Date!) {\n  createAsset(name: $name, assetClassId: $assetClassId, price: $price, period: $period) {\n    asset {\n      id,\n      name\n      price\n      assetClass {\n        id\n        name\n      }\n    }\n    message\n  }\n}']),
    _templateObject20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nmutation createPortfolio( $portfolioId: Int, $advisorId: Int!, $clientId: Int!, $investmentProfileId: Int, $mode: Int!, $bType: Int!\n  $contractNumber: String!, $cuttofDate: Date!, $advisorComment: String, $investments: [InvestmentInput]) {\n  createPortfolio( portfolioId: $portfolioId, advisorId: $advisorId, clientId: $clientId, mode: $mode, bType: $bType, cuttofDate: $cuttofDate, contractNumber: $contractNumber,\n  investments: $investments, advisorComment: $advisorComment, investmentProfileId: $investmentProfileId) {\n    returnCode\n    message\n    portfolio {\n      id\n    }\n  }\n}\n'], ['\nmutation createPortfolio( $portfolioId: Int, $advisorId: Int!, $clientId: Int!, $investmentProfileId: Int, $mode: Int!, $bType: Int!\n  $contractNumber: String!, $cuttofDate: Date!, $advisorComment: String, $investments: [InvestmentInput]) {\n  createPortfolio( portfolioId: $portfolioId, advisorId: $advisorId, clientId: $clientId, mode: $mode, bType: $bType, cuttofDate: $cuttofDate, contractNumber: $contractNumber,\n  investments: $investments, advisorComment: $advisorComment, investmentProfileId: $investmentProfileId) {\n    returnCode\n    message\n    portfolio {\n      id\n    }\n  }\n}\n']),
    _templateObject21 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nmutation upgradePortfolio($portfolioId: Int!) {\n  upgradePortfolio(idPortfolio: $portfolioId) {\n    returnCode\n    message\n  }\n}'], ['\nmutation upgradePortfolio($portfolioId: Int!) {\n  upgradePortfolio(idPortfolio: $portfolioId) {\n    returnCode\n    message\n  }\n}']),
    _templateObject22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nmutation addPortfolioComments( $portfolioId: Int!, $assetClassComments: [AssetClassCommentInput], $investmentComments: [InvestmentCommentInput], $portfolioComments: [PortfolioCommentInput]) {\n  addPortfolioComments( portfolioId: $portfolioId, assetClassComments: $assetClassComments, investmentComments: $investmentComments, portfolioComments: $portfolioComments ) {\n    returnCode\n    message\n  }\n}'], ['\nmutation addPortfolioComments( $portfolioId: Int!, $assetClassComments: [AssetClassCommentInput], $investmentComments: [InvestmentCommentInput], $portfolioComments: [PortfolioCommentInput]) {\n  addPortfolioComments( portfolioId: $portfolioId, assetClassComments: $assetClassComments, investmentComments: $investmentComments, portfolioComments: $portfolioComments ) {\n    returnCode\n    message\n  }\n}']),
    _templateObject23 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query sendURL($portfolioId: Int!, $email: String!) {\n    sendAnalysisUrl(portfolioId: $portfolioId, email: $email) {\n      msg\n      returnCode\n    }\n  }'], ['\n  query sendURL($portfolioId: Int!, $email: String!) {\n    sendAnalysisUrl(portfolioId: $portfolioId, email: $email) {\n      msg\n      returnCode\n    }\n  }']),
    _templateObject24 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    query allValidations($email: String!, $search: String) {\n        allValidations (email:$email, search:$search){\n            alias\n            nombre\n            mailSiap\n            telCelular\n            mailPromotor\n            cvePromotor\n            codigoCliente\n            \n            createdAt\n            updatedAt\n            sendAt\n            \n            validated\n            edited\n            status\n            strStatus\n            \n            history\n            \n            checkMail\n            checkTel\n            \n            unico\n        }\n    }'], ['\n    query allValidations($email: String!, $search: String) {\n        allValidations (email:$email, search:$search){\n            alias\n            nombre\n            mailSiap\n            telCelular\n            mailPromotor\n            cvePromotor\n            codigoCliente\n            \n            createdAt\n            updatedAt\n            sendAt\n            \n            validated\n            edited\n            status\n            strStatus\n            \n            history\n            \n            checkMail\n            checkTel\n            \n            unico\n        }\n    }']),
    _templateObject25 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    mutation updateValidationStatus($telCelular: String!, $mailSiap:String!, $codigoCliente: String, $alias: String, $history: String, $checked: Boolean, $mailPromotor: String) {\n        updateValidationStatus (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, alias:$alias, history:$history, checked:$checked, mailPromotor:$mailPromotor){\n            message\n            returnCode\n            client{\n                alias\n                nombre\n                mailSiap\n                telCelular\n                mailPromotor\n                codigoCliente\n\n                createdAt\n                updatedAt\n                sendAt\n\n                validated\n                edited\n                status\n                strStatus\n\n                history\n\n                checkMail\n                checkTel\n            }\n        }\n    }'], ['\n    mutation updateValidationStatus($telCelular: String!, $mailSiap:String!, $codigoCliente: String, $alias: String, $history: String, $checked: Boolean, $mailPromotor: String) {\n        updateValidationStatus (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, alias:$alias, history:$history, checked:$checked, mailPromotor:$mailPromotor){\n            message\n            returnCode\n            client{\n                alias\n                nombre\n                mailSiap\n                telCelular\n                mailPromotor\n                codigoCliente\n\n                createdAt\n                updatedAt\n                sendAt\n\n                validated\n                edited\n                status\n                strStatus\n\n                history\n\n                checkMail\n                checkTel\n            }\n        }\n    }']),
    _templateObject26 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    mutation updateValidation($telCelular: String!, $mailSiap:String!, $codigoCliente: String!, $checkMail: Boolean!, $checkTel: Boolean!) {\n        updateValidation (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, checkMail:$checkMail, checkTel: $checkTel){\n            message\n            returnCode\n            client{\n                alias\n                nombre\n                mailSiap\n                telCelular\n                mailPromotor\n                codigoCliente\n\n                createdAt\n                updatedAt\n                sendAt\n\n                validated\n                edited\n                status\n                strStatus\n\n                history\n\n                checkMail\n                checkTel\n                unico\n            }\n        }\n    }'], ['\n    mutation updateValidation($telCelular: String!, $mailSiap:String!, $codigoCliente: String!, $checkMail: Boolean!, $checkTel: Boolean!) {\n        updateValidation (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, checkMail:$checkMail, checkTel: $checkTel){\n            message\n            returnCode\n            client{\n                alias\n                nombre\n                mailSiap\n                telCelular\n                mailPromotor\n                codigoCliente\n\n                createdAt\n                updatedAt\n                sendAt\n\n                validated\n                edited\n                status\n                strStatus\n\n                history\n\n                checkMail\n                checkTel\n                unico\n            }\n        }\n    }']),
    _templateObject27 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    query calculate($capital: Float!, $tasaNominal:Float, $inflacion: Float, $tasaReal: Float, \n                    $tasaIsr: Float, $tasaRet: Float, $rangoTiempo:Int) {\n        calculate (capital:$capital, tasaNominal:$tasaNominal, inflacion:$inflacion, tasaReal:$tasaReal,\n                   tasaIsr: $tasaIsr, tasaRet: $tasaRet, rangoTiempo: $rangoTiempo){\n            message\n            result\n        }\n    }'], ['\n    query calculate($capital: Float!, $tasaNominal:Float, $inflacion: Float, $tasaReal: Float, \n                    $tasaIsr: Float, $tasaRet: Float, $rangoTiempo:Int) {\n        calculate (capital:$capital, tasaNominal:$tasaNominal, inflacion:$inflacion, tasaReal:$tasaReal,\n                   tasaIsr: $tasaIsr, tasaRet: $tasaRet, rangoTiempo: $rangoTiempo){\n            message\n            result\n        }\n    }']);



// Queries

var getLastDataDate = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

var getAdvisorData = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2);

var getAllAdvisors = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3);

var getAdvisorsByQuery = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject4);

var getAllPortfolios = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject5);

var getPortfoliosByAdvisorId = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject6);

var getPortfolioById = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject7);

var getPortfolioByUrl = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject8);

var getClientsByAdvisor = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject9);

var recoverPassword = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject10);

var getAssetClasses = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject11);

var getAssets = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject12);

var getPortfolioAnalysis = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject13);

// Mutations

var loginUser = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject14);

var createAdvisor = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject15);

var deleteAdvisor = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject16);
var deletePortfolio = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject17);

var createClient = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject18);

var addAsset = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject19);

var createPortfolio = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject20);
var upgradePortfolio = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject21);

var addComment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject22);

var sendUrl = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject23);

var getAllValidations = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject24);

var updateValidationStatus = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject25);

var updateValidation = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject26);

var getCalculation = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject27);

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',[_vm._v("Nuevo analisis de Portafolio")]),_vm._v(" "),_c('breadcrumbs',{staticClass:"breadcrumbs",attrs:{"section":"3"}}),_vm._v(" "),_c('h3',{staticClass:"second-title"},[_vm._v("Confirmar Emisoras")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"30px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('p',{staticClass:"subtitle"},[_vm._v("Emisoras")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8,"offset":2}},[_c('div',{staticClass:"add-comment-button"},[_c('div',{staticClass:"container-edit-text"},[_c('router-link',{attrs:{"to":"/registro-emisoras"}},[_c('p',[_vm._v("Agregar emisora")])])],1)])]),_vm._v(" "),(!_vm.comment && !_vm.showAddCommentInput)?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"add-comment-button",on:{"click":function($event){_vm.displayCommentInput()}}},[_c('div',{staticClass:"container-edit-text"},[_c('i',{staticClass:"el-icon-edit text-icon"}),_vm._v(" "),_c('p',[_vm._v("Agregar comentario")])])])]):_vm._e(),_vm._v(" "),(_vm.comment && !_vm.showAddCommentInput)?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"add-comment-button",on:{"click":function($event){_vm.deleteComment()}}},[_c('div',{staticClass:"container-edit-text"},[_c('p',[_vm._v("Eliminar comentario")]),_c('i',{staticClass:"el-icon-delete text-icon"})])])]):_vm._e()],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.currentInvestments}},[_c('el-table-column',{attrs:{"prop":"assetClassLabel","label":"Mercado","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assetLabel","label":"Emisora","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalSecurities","label":_vm.percentageBasedPortfolio ? 'Porcentaje': 'Numero de titulos',"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(" "+_vm._s(_vm.formatSecurities(scope.row.totalSecurities))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price_of_note","label":"Precio de la nota","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(" "+_vm._s(_vm.formatPrice(scope.row.price_of_note))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalAmount","label":"Monto invertido","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(" "+_vm._s(_vm.formatPrice(scope.row.totalAmount))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"index","width":"30"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.percentageBasedPortfolio)?_c('i',{staticClass:"el-icon-circle-close-outline",on:{"click":function($event){_vm._deleteAsset(scope.$index)}}}):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAddCommentInput),expression:"showAddCommentInput"}],staticClass:"commentInput-container"},[_c('el-input',{attrs:{"type":"textarea","rows":4,"placeholder":"Agregar comentario..."},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAddCommentInput),expression:"showAddCommentInput"}],attrs:{"type":"flex","justify":"end"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.addComment()}}},[_vm._v("Agregar")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayCommentSection),expression:"displayCommentSection"}],staticClass:"comment-container"},[_c('span',{staticClass:"comment-title"},[_vm._v("Comentario:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.comment))])]),_vm._v(" "),_c('div',{staticClass:"bottom-section"},[_c('el-row',{attrs:{"gutter":20,"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"container-back-button"},[_c('router-link',{attrs:{"to":"/registro-emisoras"}},[_c('i',{staticClass:"el-icon-arrow-left blue-arrow-icon"}),_vm._v(" "),_c('p',{staticClass:"back-button"},[_vm._v("Atrás")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',{staticClass:"blue-extended-button",on:{"click":function($event){_vm.submitPortfolio(1)}}},[_vm._v("Guarda borrador")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',{staticClass:"blue-extended-button",on:{"click":function($event){_vm.submitPortfolio(2)}}},[_vm._v("Generar análisis")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestSection_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbdc8560_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestSection_vue__ = __webpack_require__(1312);
function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbdc8560_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main bar-chart avoid-page-break"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('div',{attrs:{"id":("tester-" + (_vm.graph_data.trace1.name))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContainer"},[_c('p',{staticClass:"PercentageBar-span"},[_vm._v("\n    "+_vm._s(_vm.formattedPercentage)+"%\n  ")]),_vm._v(" "),_c('div',{staticClass:"main bar",attrs:{"id":"mainBar"}},[_c('div',{ref:"percentage",staticClass:"percentaje bar",style:([{ backgroundColor : _vm.anotherColor }])})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"specialSlider",staticClass:"special-slider avoid-page-break",class:{ smallSpecialSlider:_vm.smallThermometer }},[(!_vm.smallThermometer)?_c('ul',_vm._l((_vm.items),function( item,index){return _c('li',{key:index},[_vm._v(_vm._s(_vm.modifyPercentage(item.percentage)))])})):_vm._e(),_vm._v(" "),(_vm.smallThermometer)?_c('div',{staticClass:"lower-text-section"},[_c('p',{staticStyle:{"text-align":"left"}},[_vm._v("CCC")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_vm._v("AAA")])]):_vm._e(),_vm._v(" "),_c('el-slider',{ref:"slider",class:{ smallThermometer:_vm.smallThermometer, hideButton:_vm.hideButton },attrs:{"disabled":"","show-tooltip":false},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),(!_vm.smallThermometer)?_c('ul',_vm._l((_vm.items),function( item,index){return _c('li',{key:index},[_vm._v(_vm._s(item.name))])})):_vm._e(),_vm._v(" "),(_vm.smallThermometer)?_c('div',{staticClass:"special-letter-section"},[_c('div',{ref:"specialLetterContainer",staticClass:"special-letter-container"},[_c('p',{staticClass:"special-letter"},[_vm._v(_vm._s(_vm.calification_name)+"+")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LevelsIndicator_vue__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b876d162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LevelsIndicator_vue__ = __webpack_require__(1290);
function injectStyle (ssrContext) {
  __webpack_require__(1287)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b876d162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LevelsIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b876d162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LevelsIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"levels_indicator",staticClass:"levels-indicator"},[_c('div',{staticClass:"levels-indicator__barrita"},[_c('div',{staticClass:"levels-indicator-bar"}),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('div',{ref:"first_cicle",staticClass:"levels-indicator__circle circle-centered",class:{ selectedFirst:_vm.selectedFirst  }})]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{ref:"second_cicle",staticClass:"levels-indicator__circle circle-centered visibility-hidden",class:{ selectedSecond:_vm.selectedSecond }})]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{ref:"third_cicle",staticClass:"levels-indicator__circle circle-centered",class:{ selectedThird:_vm.selectedThird  }})])],1)],1),_vm._v(" "),_c('div',{staticClass:"levels-indicator__text"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("SIN BURSATILIDAD")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.dinamicText))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("ALTA")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"main main-table",class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-main',{staticClass:"list-container",class:{ ceropadding:_vm.ceropadding }},[_c('el-table',{ref:"tableElement",class:{ distribution_per_sector: _vm.distribution_styles, 'clickableCell': _vm.isClickable },attrs:{"empty-text":"Sin información","id":"tableElement","data":_vm.tableData,"default-expand-all":_vm.displayExpanded},on:{"cell-click":_vm.goAsssetDetail}},[(_vm.distribution_styles)?_c('el-table-column',{attrs:{"label":'Sector'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"TableData-wrapper"},[_c('img',{attrs:{"src":("/static/sector-icons/icon-" + (scope.row.name) + ".svg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"specialText"},[_vm._v(" "+_vm._s(scope.row.name)+" ")])])]}}])}):_vm._e(),_vm._v(" "),_vm._l((_vm.titles),function( item ,index){return _c('el-table-column',{key:index,attrs:{"prop":item.prop,"label":item.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',{class:_vm.modifyClass(scope.row,item.prop)},[_vm._v(" "+_vm._s(_vm.modifyData(scope.row,item.prop))+" ")])]}}])})}),_vm._v(" "),(_vm.showSubtotal)?_c('el-table-column',{attrs:{"label":_vm.percentageLabel,"min-width":_vm.subtotalWidth},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('percentageBar',{ref:"percentageBar",attrs:{"data":scope.row.percentage,"second-color":_vm.new_color,"third-color":scope.row.color}})]}}])}):_vm._e(),_vm._v(" "),_vm._l((_vm.titles2),function( item2 ){return _c('el-table-column',{key:item2.label,attrs:{"prop":item2.prop,"label":item2.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',{class:_vm.modifyClass(scope.row,item2.prop)},[_vm._v(" "+_vm._s(_vm.modifyData(scope.row,item2.prop))+" ")])]}}])})}),_vm._v(" "),(_vm.showExtraData)?_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Titulos:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"70px"}},[_vm._v(" "+_vm._s(scope.row.securities)+" ")])]),_vm._v(" "),_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Tipo de emisor:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"15px"}},[_vm._v(" "+_vm._s(scope.row.assetType)+" ")])]),_vm._v(" "),(scope.row.rateType)?_c('div',[_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Tipo de tasa:\n                  "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"34px"}},[_vm._v(" "+_vm._s(scope.row.rateType)+" ")])])]):_vm._e(),_vm._v(" "),(scope.row.score)?_c('div',[_c('p',{staticClass:"font-weight-600 specialSliderTittle",staticStyle:{"margin-bottom":"4px"}},[_vm._v("Calificación:")]),_vm._v(" "),[_c('div',{staticClass:"extra-data__special-slider"},[_c('special-slider',{staticClass:"special-slider",attrs:{"smallThermometer":true,"graph_data":scope.row.sliderValue,"calification_name":scope.row.score}})],1)]],2):_vm._e()]}}])}):_vm._e(),_vm._v(" "),(_vm.showExtraDataTwo)?_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("\n                Titulos:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"90px"}},[_vm._v(" "+_vm._s(scope.row.securities)+" ")])]),_vm._v(" "),_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Nombre Completo:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"10px"}},[_vm._v(" "+_vm._s(scope.row.completeName)+" ")])]),_vm._v(" "),_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Tipo de emisor:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"35px"}},[_vm._v(" "+_vm._s(scope.row.assetType)+" ")])]),_vm._v(" "),_c('p',{staticClass:"font-weight-600 extra-data-p"},[_vm._v("Sector:\n                "),_c('span',{staticClass:"font-weight-200",staticStyle:{"margin-left":"91px"}},[_vm._v(" "+_vm._s(scope.row.sector)+" ")])]),_vm._v(" "),_c('p',{ref:"BursatibilityText",staticClass:"font-weight-600 bursatilidad-position"},[_vm._v("Bursatilidad:")]),_vm._v(" "),[_c('levels-indicator',{staticStyle:{"width":"calc(100% - 110px)","display":"inline-block","position":"relative","top":"10px"},attrs:{"graph_data":scope.row.bursatility},on:{"hideText":_vm.hideText}})]]}}])}):_vm._e(),_vm._v(" "),(_vm.showExtraDataThree)?_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"extra-data-three"},[_c('el-row',{attrs:{"type":"flex","justify":"left"}},[_c('el-col',{staticClass:"extra-data-three__table-section",attrs:{"span":1}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('p',{staticClass:"font-weight-600"},[_vm._v("Títulos:")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',[_vm._v(" "+_vm._s(_vm.modifyTitulos(scope.row.securities))+" ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('p',{staticClass:"font-weight-600"},[_vm._v("Precio:")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',[_vm._v(" "+_vm._s(_vm.modifyPrecio(scope.row.price))+" ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"extra-data-three__table-section"},[_c('div',{staticClass:"extra-data-three__table-section__header font-weight-600"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":11}},[_vm._v("\n                        Instrumento\n                    ")]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_vm._v("\n                        Tipo de inversión\n                    ")]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_vm._v("\n                        %\n                    ")])],1)],1),_vm._v(" "),_vm._l((scope.row.instrumentComposition),function( element,index){return _c('div',{key:index,staticClass:"extra-data-three__table-section__data"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":11}},[_vm._v("\n                      "+_vm._s(element.name)+"\n                    ")]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_vm._v("\n                      "+_vm._s(element.inversionType.name)+"\n                    ")]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_vm._v("\n                      "+_vm._s(_vm.modifyPercentage(element.percentage))+"\n                    ")])],1)],1)})],2),_vm._v(" "),(_vm.currentAssetClass === 'fondosrf')?_c('div',{staticClass:"fondosRF-score-container"},[_c('p',{staticClass:"font-weight-600",staticStyle:{"margin-bottom":"4px"}},[_vm._v("Calificación:")]),_vm._v(" "),[_c('div',{staticClass:"extra-data__special-slider"},[_c('special-slider',{staticClass:"special-slider",attrs:{"smallThermometer":true,"graph_data":scope.row.sliderValue,"calification_name":scope.row.score}})],1)]],2):_vm._e()],1)]}}])}):_vm._e()],2)],1),_vm._v(" "),(!_vm.printVersion)?_c('div',{staticStyle:{"height":"38px"}},[(_vm.showSubtotalPercentages)?_c('ul',{ref:"percentage_nodes"},_vm._l((_vm.percentages),function( item,index){return _c('li',{key:index},[_c('span',{staticStyle:{"float":"left"}}),_vm._v("\n            "+_vm._s(item)+"\n          ")])})):_vm._e()]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonnutChartD3_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8ccb86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonnutChartD3_vue__ = __webpack_require__(1297);
function injectStyle (ssrContext) {
  __webpack_require__(1294)
  __webpack_require__(1295)
  __webpack_require__(1296)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d8ccb86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonnutChartD3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8ccb86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonnutChartD3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartwrapper",staticClass:"chartwrapper"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoListDonnut_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f458f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoListDonnut_vue__ = __webpack_require__(1300);
function injectStyle (ssrContext) {
  __webpack_require__(1299)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoListDonnut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f458f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoListDonnut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1299:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-list-container"},_vm._l((_vm.data),function( item ,key,index){return _c('div',{key:index,staticClass:"card",attrs:{"id":item.id},on:{"click":function($event){_vm.goToAssetClass($event)}}},[_c('div',{staticClass:"sectionOne"},[_c('div',{ref:"circle",refInFor:true,class:['circle', item.id]}),_vm._v(" "),_c('p',{staticStyle:{"text-decoration":"underline"}},[_vm._v(" "+_vm._s(item.name)+" ")]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"sectionTwo"},[_c('div',{staticClass:"divisor"},[_c('p',{ref:"percentage",refInFor:true,class:['percentage', item.id]},[_vm._v(" "+_vm._s(_vm.formatPercentage(item.percentage)))])]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('p',{staticClass:"alignRight"},[_vm._v(_vm._s(_vm.formatAmount(item.amount))+" ")])])])])}))}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"alignRight"},[_c('i',{staticClass:"el-icon-arrow-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donnut-chart-section",class:{ printVersion: _vm.printVersion }},[_c('donnut-component-d3',{attrs:{"uni_color":_vm.uniColor,"data-entry":_vm.donnutData,"labels-entry":_vm.donnutLabels,"colors":_vm.colors}}),_vm._v(" "),_c('donnut-info',{attrs:{"data":_vm.infoData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalTableData_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea922634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalTableData_vue__ = __webpack_require__(1305);
function injectStyle (ssrContext) {
  __webpack_require__(1303)
  __webpack_require__(1304)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea922634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalTableData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea922634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalTableData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('p',{staticClass:"percentage"},[_vm._v("0%")]),_vm._v(" "),_c('div',{staticClass:"namesContainer"},_vm._l((_vm.data),function( element,index){return _c('div',{key:index,staticClass:"cards"},[_c('p',[_vm._v(_vm._s(element.name))])])})),_vm._v(" "),_c('div',{staticClass:"chartContainer"},[_c('div',{staticClass:"line1"}),_vm._v(" "),_c('div',{staticClass:"line2"}),_vm._v(" "),_c('div',{staticClass:"line3"}),_vm._v(" "),_c('div',{staticClass:"line4"}),_vm._v(" "),_c('svg',{staticClass:"chart"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-table-data avoid-page-break"},[_c('div',{staticClass:"line-container"},_vm._l((_vm.data),function( element,index){return _c('div',{key:index,staticClass:"line",style:([{ width : _vm.defineWidth(element.value) , transform : _vm.transformLine(element.value) }])},[_c('span',{class:{ positiveValue : _vm.checkIfValueIsPositive(element.value) , negativeValue : !_vm.checkIfValueIsPositive(element.value) }},[_vm._v("\n        "+_vm._s(_vm.definePercentage(element.value))+"\n      ")])])})),_vm._v(" "),_c('p',{staticClass:"percentage"},[_vm._v("0%")]),_vm._v(" "),_c('div',{staticClass:"namesContainer"},_vm._l((_vm.data),function( element,index){return _c('div',{key:index,staticClass:"cards"},[_c('p',[_vm._v(_vm._s(element.name))])])})),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartContainer"},[_c('div',{staticClass:"line1"}),_vm._v(" "),_c('div',{staticClass:"line2"}),_vm._v(" "),_c('div',{staticClass:"line3"}),_vm._v(" "),_c('div',{staticClass:"line4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartContainerTwo"},[_c('div',{staticClass:"line2"}),_vm._v(" "),_c('div',{staticClass:"line3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketGrade_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbacf54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketGrade_vue__ = __webpack_require__(1311);
function injectStyle (ssrContext) {
  __webpack_require__(1309)
  __webpack_require__(1310)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dbacf54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketGrade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbacf54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketGrade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-qualification"},[_c('el-main',{staticClass:"list-container"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"id":"list-container-tableElement","data":_vm.tableData}},[_vm._l((_vm.titles),function( item ,index){return _c('el-table-column',{key:index,attrs:{"prop":item.prop,"label":item.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_vm._v(" "+_vm._s(_vm.modifyData(scope.row,item.prop))+" ")])]}}])})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"%","width":_vm.subtotalWidth},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('percentageBar',{ref:"percentageBar",staticClass:"percentage-bar",attrs:{"second-color":scope.row.color,"data":scope.row.percentage}})]}}])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h1',[_vm._v("Test section")]),_vm._v(" "),_c('bar-chart-component',{attrs:{"graph_data":_vm.data}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData}}),_vm._v(" "),_c('donnut-chart-section',{attrs:{"graph_data":_vm.donnutChartData}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData2,"show_percentage_measurer":true}}),_vm._v(" "),_c('vertical-table-component',{attrs:{"graph_data":_vm.tableDataHorizontal}}),_vm._v(" "),_c('vertical-table-component2',{attrs:{"graph_data":_vm.tableDataHorizontal}}),_vm._v(" "),_c('special-slider',{attrs:{"graph_data":_vm.sliderData}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData3,"percentage_color":_vm.new_color_two}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData4}}),_vm._v(" "),_c('donnut-chart-section',{attrs:{"graph_data":_vm.donnutChartData2,"uni_color":_vm.uniColor}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData5,"percentage_color":_vm.new_color}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData6,"percentage_color":_vm.new_color_three}}),_vm._v(" "),_c('market-grade',{attrs:{"graph_data":_vm.marketGrade}}),_vm._v(" "),_c('table-component',{attrs:{"graph_data":_vm.tableData7,"percentage_color":_vm.new_color_three}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassMenu_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ec47fe8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassMenu_vue__ = __webpack_require__(1317);
function injectStyle (ssrContext) {
  __webpack_require__(1316)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ec47fe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ec47fe8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assetClass-container"},[_c('div',{class:_vm.cssClasses,on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleClick($event)}}},[_c('div',{staticClass:"assetClass-title"},[_c('span',{on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.sectionLabel))]),(_vm.menuData.length > 0)?_c('i',{staticClass:"el-icon-arrow-down",on:{"click":_vm.openMenu}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"assetClass-amount",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.formatAmount(_vm.totalAmount)))]),_vm._v(" "),_c('span',{staticClass:"assetClass-porcentage",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.formatPercentage(_vm.percentage)))])]),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"assetClass-dropwdown-menu"},_vm._l((_vm.menuData),function(item){return _c('div',{key:item.name,staticClass:"dropdownMenu-item",attrs:{"id":item.id},on:{"click":function($event){_vm.goToAssetClass($event)}}},[_c('div',{class:['dropdownMenu-pointer', item.id]},[_c('p',{staticClass:"dropdownMenu-title"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('p',{staticClass:"dropdownMenu-amount"},[_vm._v(_vm._s(_vm.formatAmount(item.amount)))]),_vm._v(" "),_c('p',{staticClass:"dropdownMenu-porcentage"},[_vm._v(_vm._s(_vm.formatPercentage(item.percentage)))])])})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolioHeader-container"},[_c('span',{staticClass:"portfolioHeader-title"},[_vm._v("Análisis de portafolio de inversión")]),_vm._v(" "),_c('img',{staticClass:"portfolio-logo",attrs:{"src":"/static/logo.svg"}}),_vm._v(" "),_c('div',{staticClass:"border-element"}),_vm._v(" "),_c('div',{staticClass:"portfolioHeader-subtitles"},[_c('span',{staticClass:"portfolioHeader-contractNumber"},[_vm._v(_vm._s(_vm.generalData.contractNumber))]),_vm._v(" / "),_c('span',{staticClass:"portfolioHeader-cuttofDate"},[_vm._v(_vm._s(_vm.generalData.creationDate))]),_vm._v(" "),_c('span',{staticClass:"portfolioHeader-alias"},[_c('strong',[_vm._v("Alias:")]),_vm._v(" "+_vm._s(_vm.generalData.alias)+" ")])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"portfolioHeader-navigation",on:{"click":_vm.goToOverview}},[_c('span',{staticClass:"overview-title"},[_vm._v("Posición actual")]),_vm._v(" "),_c('span',{staticClass:"overview-amount"},[_vm._v(_vm._s(_vm.formatTotalAmount(_vm.generalData.totalInvestment)))]),_vm._v(" "),_c('span',{staticClass:"overview-porcentage"},[_vm._v("100%")])])]),_vm._v(" "),(_vm.isAssetClassSection)?_c('el-col',{staticClass:"assetClass-navigation",attrs:{"span":8}},[_c('asset-class-menu',{attrs:{"current-asset-class":_vm.currentAssetClass,"total-amount":_vm.assetClassAmount,"percentage":_vm.assetClassPercentage,"menu-data":_vm.menuData,"section-label":_vm.sectionLabel,"is-asset-detail":_vm.isAssetDetail}})],1):_vm._e(),_vm._v(" "),(_vm.isAssetDetail)?_c('el-col',{class:['asset-container-menu', _vm.currentAssetClass],attrs:{"span":7}},[_c('span',{staticClass:"asset-title"},[_vm._v(_vm._s(_vm.assetDetail.assetName))]),_vm._v(" "),_c('span',{staticClass:"asset-amount"},[_vm._v(_vm._s(_vm.formatTotalAmount(_vm.assetDetail.amount)))]),_vm._v(" "),_c('span',{staticClass:"asset-porcentage"},[_vm._v(_vm._s(_vm.formatPercentage(_vm.assetDetail.percentage)))])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avoid-page-break-before"},[(!_vm.isPrintVersion)?_c('div',{staticClass:"avoid-page-break-before"},[(_vm.comments.length > 0 || _vm.userIsAdmin)?_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{staticClass:"add-comment",attrs:{"name":"1"}},[_c('template',{slot:"title"},[(_vm.userIsAdmin)?_c('i',{staticClass:"el-icon-edit"}):_vm._e(),_c('span',{staticClass:"comment-title"},[_vm._v(_vm._s(_vm.userIsAdmin ? _vm.title.admin : _vm.title.advisor))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"comments-list-container"},[(_vm.comments.length > 0 || _vm.newComments.length > 0)?_c('span',{staticClass:"comments-label"},[_vm._v("Comentarios:")]):_vm._e(),_vm._v(" "),_c('ul',[_vm._l((_vm.comments),function(item){return _c('li',{key:item.id},[_vm._v(_vm._s(item.comment))])}),_vm._v(" "),_vm._l((_vm.newComments),function(item){return _c('li',{key:item.id},[_vm._v(_vm._s(item.comment))])})],2)]),_vm._v(" "),(_vm.userIsAdmin)?_c('div',{staticClass:"comment-input-container"},[_c('span',{staticClass:"comments-label"},[_vm._v("Agregar:")]),_vm._v(" "),_c('el-input',{staticClass:"comment-input",attrs:{"type":"textarea","placeholder":"Comentario de mercado..."},model:{value:(_vm.inputContent),callback:function ($$v) {_vm.inputContent=$$v},expression:"inputContent"}}),_vm._v(" "),_c('el-button',{staticClass:"comment-input-button",attrs:{"size":"small","disabled":_vm.inputContent.length === 0},on:{"click":function($event){_vm.addComment()}}},[_vm._v("Agregar")])],1):_vm._e()])],2)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isPrintVersion && _vm.comments.length > 0)?_c('div',{staticClass:"printVersionComments avoid-page-break-before"},_vm._l((_vm.comments),function(item){return _c('p',{key:item.id},[_vm._v(_vm._s(item.comment))])})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer-container"},[_c('p',{staticClass:"footer-item link",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Aviso Legal")]),_vm._v(" "),_c('p',{staticClass:"footer-item"},[_vm._v(_vm._s(("Datos actualizados al: " + _vm.creationDate)))])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Aviso Legal","visible":_vm.showModal,"before-close":_vm.closeModal},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.legalNotice))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[(_vm.userIsAdmin && _vm.advisorComment)?_c('el-alert',{attrs:{"title":"Comentario de asesor","type":"info","description":_vm.advisorComment,"show-icon":"","closable":false}}):_vm._e(),_vm._v(" "),_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"printableVersion":_vm.printableVersion,"donnut-data":_vm.assetAllocation.data,"info-data":_vm.assetAllocation.titles,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":_vm.marketInformationTitleSpan}},[_c('span',{staticClass:"section-title"},[_vm._v("Información de mercado")])]),_vm._v(" "),_c('el-col',{staticClass:"sectionContainer",attrs:{"span":_vm.marketInformationSpan}},[_c('representative-positions',{attrs:{"printableVersion":_vm.printableVersion,"graph_data":_vm.marketInformationData}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Posiciones Representativas")]),_vm._v(" "),_c('representative-positions',{staticClass:"representative-positions-table",attrs:{"printableVersion":_vm.printableVersion,"graph_data":_vm.representativePositions,"percentage_color":'#001F5C'}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('div',{staticClass:"avoid-page-break"},[(_vm.portfolioComments.length > 0 && _vm.printVersion)?_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de Portafolio")]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-portfolio-overview":true,"comments":_vm.portfolioComments,"is-print-version":_vm.printVersion}})],1)])],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'deuda',"section-label":'Deuda',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"printableVersion":_vm.printableVersion,"donnut-data":_vm.assetAllocation.data,"info-data":_vm.assetAllocation.titles,"uni-color":_vm.assetClassColor,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('asset-overview-table',{attrs:{"graph_data":_vm.investments,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'deuda',"is-clickable":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Tipo de emisor")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.assetTypesDistribution,"percentage_color":_vm.assetClassColor.color}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Tipo de tasa")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.assetRateDistribution,"percentage_color":_vm.assetClassColor.color}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Información de Cupones")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.couponData}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Calificación")]),_vm._v(" "),_c('special-slider',{attrs:{"graph_data":_vm.scoreDistribution}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[(_vm.assetClassComments.length > 0 && _vm.printVersion)?_c('div',[_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de mercado Deuda")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-asset-class-view":true,"comments":_vm.assetClassComments,"asset-class-id":_vm.assetClassId,"is-print-version":_vm.printVersion}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'fondosrf',"section-label":'Fondos RF',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"printableVersion":_vm.printableVersion,"donnut-data":_vm.assetAllocation.data,"info-data":_vm.assetAllocation.titles,"uni-color":_vm.assetClassColor,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Fondos Renta Fija")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investments,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'fondosrf',"is-clickable":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento anualizado por fondo")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.yieldByAsset}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[(_vm.printVersion)?_c('el-row',[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[(_vm.printVersion)?_c('span',{staticClass:"section-title"},[_vm._v("\n            Rendimiento Ponderado y Comisiones en RF\n          ")]):_vm._e(),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":8}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento Ponderado y Comisiones en RF")])]):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"sectionContainer",attrs:{"span":12}},[_c('horizontal-bar-chart',{attrs:{"graph_data":_vm.yieldAndCommissions,"asset-class-color":_vm.assetClassColor.color}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Comparativo Benchmark del mercado")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('bar-chart',{attrs:{"graph_data":_vm.assetClassBenchmark,"asset-class-color":_vm.assetClassColor.color}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Calificación")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('special-slider',{attrs:{"graph_data":_vm.scoreDistribution}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[(_vm.assetClassComments.length > 0 && _vm.printVersion)?_c('div',[_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de mercado Fondos RF")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-asset-class-view":true,"comments":_vm.assetClassComments,"asset-class-id":_vm.assetClassId,"is-print-version":_vm.printVersion}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1328:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'fondosrv',"section-label":'Fondos RV',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"donnut-data":_vm.assetAllocation.data,"printableVersion":_vm.printableVersion,"info-data":_vm.assetAllocation.titles,"uni-color":_vm.assetClassColor,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Fondos Renta Variable")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investments,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'fondosrv',"is-clickable":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento efectivo por fondo")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.yieldByAsset}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[(_vm.printVersion)?_c('el-row',[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[(_vm.printVersion)?_c('span',{staticClass:"section-title"},[_vm._v("\n          "+_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Fondos RV"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":8}},[_c('span',{staticClass:"section-title"},[_vm._v(_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Fondos RV")))])]):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"sectionContainer",attrs:{"span":12}},[_c('horizontal-bar-chart',{attrs:{"graph_data":_vm.yieldAndCommissions,"asset-class-color":_vm.assetClassColor.color}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Comparativo Benchmark del mercado")]),_vm._v(" "),_c('bar-chart',{attrs:{"graph_data":_vm.assetClassBenchmark,"asset-class-color":_vm.assetClassColor.color}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[(_vm.assetClassComments.length > 0 && _vm.printVersion)?_c('div',[_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de mercado Fondos RV")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-asset-class-view":true,"comments":_vm.assetClassComments,"asset-class-id":_vm.assetClassId,"is-print-version":_vm.printVersion}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'estructurados',"section-label":'Estructurados',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"printableVersion":_vm.printableVersion,"donnut-data":_vm.assetAllocation.data,"info-data":_vm.assetAllocation.titles,"uni-color":_vm.assetClassColor,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('asset-overview-table',{attrs:{"graph_data":_vm.investments,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'estructurados'}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[(_vm.assetClassComments.length > 0 && _vm.printVersion)?_c('div',[_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de mercado Estructurados")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-asset-class-view":true,"comments":_vm.assetClassComments,"asset-class-id":_vm.assetClassId,"is-print-version":_vm.printVersion}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'capitales',"section-label":'Capitales',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('asset-allocation',{attrs:{"printableVersion":_vm.printableVersion,"donnut-data":_vm.assetAllocation.data,"info-data":_vm.assetAllocation.titles,"uni-color":_vm.assetClassColor,"donnut-labels":_vm.assetAllocation.labels,"colors":_vm.assetAllocation.dataColors}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('asset-overview-table',{attrs:{"graph_data":_vm.investments,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'capitales',"is-clickable":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento por emisora")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.yieldByAsset}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[(_vm.printVersion)?_c('el-row',[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[(_vm.printVersion)?_c('span',{staticClass:"section-title"},[_vm._v("\n          "+_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Capitales"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":8}},[_c('span',{staticClass:"section-title"},[_vm._v(_vm._s(("Rendimiento acum. " + (this.labels.lastYear) + " en Capitales")))])]):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"sectionContainer",attrs:{"span":12}},[_c('horizontal-bar-chart',{attrs:{"graph_data":_vm.yieldAndCommissions,"asset-class-color":_vm.assetClassColor.color}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Distribución por sector")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.sectorDistribution,"percentage_color":'#001F5C'}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[(_vm.assetClassComments.length > 0 && _vm.printVersion)?_c('div',[_c('span',{staticClass:"section-title"},[_vm._v("Comentarios de mercado Capitales")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e(),_vm._v(" "),_c('comments',{attrs:{"is-asset-class-view":true,"comments":_vm.assetClassComments,"asset-class-id":_vm.assetClassId,"is-print-version":_vm.printVersion}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'fondosrv',"section-label":'Fondos RV',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage,"is-asset-detail":true,"asset-detail":_vm.currentInvesment[0]}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"print-margin-top",staticStyle:{"page-break-inside":"auto"},attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",staticStyle:{"page-break-inside":"auto"},attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Detalle de "+_vm._s(_vm.currentInvesment[0].assetName))]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investmentTableData,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'fondosrv',"display-expanded":true}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[(_vm.printVersion)?_c('el-row',[(_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[_c('span',{staticClass:"section-title"},[_vm._v("\n          "+_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Fondos RV"))+"\n        ")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento")])]):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[_c('asset-overview-table',{attrs:{"graph_data":_vm.yieldTableData}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Comparativo Benchmark del mercado")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('bar-chart',{attrs:{"graph_data":_vm.assetBenchmark,"asset-class-color":_vm.assetClassColor.color}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('comments',{attrs:{"is-investment-view":true,"comments":_vm.currentInvesment[0].comments,"investment-id":_vm.currentInvesment[0].assetId}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'fondosrf',"section-label":'Fondos RF',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage,"is-asset-detail":true,"asset-detail":_vm.currentInvesment[0]}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"page-break-inside":"auto"},attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer print-margin-top",staticStyle:{"page-break-inside":"auto"},attrs:{"span":20}},[_c('span',{staticClass:"section-title detail-title"},[_vm._v("Detalle de "+_vm._s(_vm.currentInvesment[0].assetName))]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investmentTableData,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'fondosrf',"display-expanded":true}})],1)],1),_vm._v(" "),_c('div',{staticClass:"avoid-page-break"},[(_vm.printVersion)?_c('el-row',[(_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[_c('span',{staticClass:"section-title"},[_vm._v("\n        "+_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Fondos RF"))+"\n      ")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":8}},[_c('span',{staticClass:"section-title"},[_vm._v(_vm._s(("Rendimientos y comisiones " + (this.labels.lastYear) + " en Fondos RF")))])]):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"sectionContainer",attrs:{"span":12}},[_c('horizontal-bar-chart',{attrs:{"graph_data":_vm.yieldAndCommissions}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[(!_vm.printVersion)?_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento")])]):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":24}},[_c('asset-overview-table',{attrs:{"graph_data":_vm.yieldTableData}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Comparativo Benchmark del mercado")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('bar-chart',{attrs:{"graph_data":_vm.assetBenchmark,"asset-class-color":_vm.assetClassColor.color}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('comments',{attrs:{"is-investment-view":true,"comments":_vm.currentInvesment[0].comments,"investment-id":_vm.currentInvesment[0].assetId}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'deuda',"section-label":'Deuda',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage,"is-asset-detail":true,"asset-detail":_vm.currentInvesment[0]}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"print-margin-top",staticStyle:{"page-break-inside":"auto"},attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",staticStyle:{"page-break-inside":"auto"},attrs:{"span":20}},[_c('span',{staticClass:"section-title detail-title"},[_vm._v("Detalle de "+_vm._s(_vm.currentInvesment[0].assetName))]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investmentTableData,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'deuda',"display-expanded":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Información de Cupones")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.couponData}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('comments',{attrs:{"is-investment-view":true,"comments":_vm.currentInvesment[0].comments,"investment-id":_vm.currentInvesment[0].assetId}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'capitales',"section-label":'Capitales',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage,"is-asset-detail":true,"asset-detail":_vm.currentInvesment[0]}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"print-margin-top",staticStyle:{"page-break-inside":"auto"},attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",staticStyle:{"page-break-inside":"auto"},attrs:{"span":20}},[_c('span',{staticClass:"section-title detail-title"},[_vm._v("Detalle de "+_vm._s(_vm.currentInvesment[0].assetName))]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investmentTableData,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'capitales',"display-expanded":true}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",attrs:{"span":20}},[_c('span',{staticClass:"section-title"},[_vm._v("Rendimiento")]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.assetYield}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('comments',{attrs:{"is-investment-view":true,"comments":_vm.currentInvesment[0].comments,"investment-id":_vm.currentInvesment[0].assetId}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailEstructurados_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f596ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailEstructurados_vue__ = __webpack_require__(1344);
function injectStyle (ssrContext) {
  __webpack_require__(1343)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f596ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailEstructurados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f596ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailEstructurados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ printVersion: _vm.printVersion }},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-header',{attrs:{"general-data":_vm.portfolioAnalysis,"is-asset-class-section":true,"menu-data":_vm.menuData,"current-asset-class":'estructurados',"section-label":'Estructurados',"asset-class-amount":_vm.assetClassAmount,"asset-class-percentage":_vm.assetClassPercentage,"is-asset-detail":true,"asset-detail":_vm.currentInvesment[0]}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"print-margin-top",staticStyle:{"page-break-inside":"auto"},attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"sectionContainer",staticStyle:{"page-break-inside":"auto"},attrs:{"span":20}},[_c('span',{staticClass:"section-title detail-title"},[_vm._v("Detalle de "+_vm._s(_vm.currentInvesment[0].assetName))]),_vm._v(" "),(_vm.printVersion)?_c('div',{staticClass:"subtitle-line"}):_vm._e(),_vm._v(" "),_c('asset-overview-table',{attrs:{"graph_data":_vm.investmentTableData,"percentage_color":_vm.assetClassColor.color,"current-asset-class":'estructurados',"display-expanded":true}})],1)],1),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('comments',{attrs:{"is-investment-view":true,"comments":_vm.currentInvesment[0].comments,"investment-id":_vm.currentInvesment[0].assetId}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.printVersion)?_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":20}},[_c('portfolio-footer',{attrs:{"creation-date":_vm.portfolioAnalysis.updatedDataAt}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintablePortfolioAnalysis_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f067214_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintablePortfolioAnalysis_vue__ = __webpack_require__(1351);
function injectStyle (ssrContext) {
  __webpack_require__(1346)
  __webpack_require__(1347)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f067214"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintablePortfolioAnalysis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f067214_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintablePortfolioAnalysis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintTittle_vue__ = __webpack_require__(494);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d722d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintTittle_vue__ = __webpack_require__(1350);
function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96d722d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintTittle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d722d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintTittle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-tittle"},[_c('span',{ref:"tittle"},[_vm._v(_vm._s(_vm.VBindTittle))]),_vm._v(" "),_c('img',{attrs:{"src":"/static/logo.svg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"printable-porfolio"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"new-page first-page"},[_vm._m(1),_vm._v(" "),_c('print-tittle',{attrs:{"tittle":"ANÁLISIS DE PORTAFOLIO DE INVERSIÓN","tittleColor":"#2873de"}}),_vm._v(" "),_c('portfolio-overview',{attrs:{"printableVersion":true,"externalMarketInformationTitleSpan":9,"externalmarketInformationSpan":15}})],1),_vm._v(" "),(_vm.portfolioAnalysis.fondosRF.amount > 0)?_c('div',{staticClass:"new-page second-page"},[_c('print-tittle',{attrs:{"tittle":"FONDOS DE RENTA FIJA","tittleColor":"#C2BFE0"}}),_vm._v(" "),_c('fondos-rf',{attrs:{"printableVersion":true}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.portfolioAnalysis.fondosRF.investments),function(investment,index){return _c('div',{key:index,staticClass:"new-page"},[_c('print-tittle',{attrs:{"tittle":("FONDOS DE RENTA FIJA - " + (investment.assetName)),"tittleColor":"#C2BFE0"}}),_vm._v(" "),_c('investment-fondos-rf',{attrs:{"printableVersion":true,"asset-name":investment.assetName}})],1)}),_vm._v(" "),(_vm.portfolioAnalysis.fondosRV.amount > 0)?_c('div',{staticClass:"new-page third-page"},[_c('print-tittle',{attrs:{"tittle":"FONDOS DE RENTA VARIABLE","tittleColor":"#f8b661"}}),_vm._v(" "),_c('fondos-rv',{attrs:{"printableVersion":true}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.portfolioAnalysis.fondosRV.investments),function(investment,index){return _c('div',{key:index,staticClass:"new-page"},[_c('print-tittle',{attrs:{"tittle":("FONDOS DE RENTA VARIABLE - " + (investment.assetName)),"tittleColor":"#f8b661"}}),_vm._v(" "),_c('investment-fondos-rv',{attrs:{"printableVersion":true,"asset-name":investment.assetName}})],1)}),_vm._v(" "),(_vm.portfolioAnalysis.capitales.amount > 0)?_c('div',{staticClass:"new-page fourth-page"},[_c('print-tittle',{attrs:{"tittle":"CAPITALES","tittleColor":"rgb(179, 222, 105)"}}),_vm._v(" "),_c('capitales',{attrs:{"printableVersion":true}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.portfolioAnalysis.capitales.investments),function(investment,index){return _c('div',{key:index,staticClass:"new-page"},[_c('print-tittle',{attrs:{"tittle":("CAPITALES - " + (investment.assetName)),"tittleColor":"rgb(179, 222, 105)"}}),_vm._v(" "),_c('investment-capitales',{attrs:{"printableVersion":true,"asset-name":investment.assetName}})],1)}),_vm._v(" "),(_vm.portfolioAnalysis.deuda.amount > 0)?_c('div',{staticClass:"new-page fifth-page"},[_c('print-tittle',{attrs:{"tittle":"DEUDA","tittleColor":"#6FE8D7"}}),_vm._v(" "),_c('deuda',{attrs:{"printableVersion":true}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.portfolioAnalysis.deuda.investments),function(investment,index){return _c('div',{key:index,staticClass:"new-page"},[_c('print-tittle',{attrs:{"tittle":("DEUDA - " + (investment.assetName)),"tittleColor":"#6FE8D7"}}),_vm._v(" "),_c('investment-deuda',{attrs:{"printableVersion":true,"asset-name":investment.assetName}})],1)}),_vm._v(" "),(_vm.portfolioAnalysis.estructurados.amount > 0)?_c('div',{staticClass:"new-page sixth-page"},[_c('print-tittle',{attrs:{"tittle":"ESTRUCTURADOS","tittleColor":"#FB8070"}}),_vm._v(" "),_c('estructurados',{attrs:{"printableVersion":true}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"new-page legal-text-section"},[_c('print-tittle',{attrs:{"tittle":"AVISO LEGAL","tittleColor":"#2873de"}}),_vm._v(" "),_c('p',{staticClass:"legal-text"},[_vm._v(_vm._s(_vm.legalNotice))])],1)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-page"},[_c('img',{staticClass:"header-logo",attrs:{"src":"/static/logo.svg"}}),_vm._v(" "),_c('p',{staticClass:"cover-page-tittle"},[_vm._v("Análisis de portafolio de inversión")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{attrs:{"id":"pageFooter"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientLogin_vue__ = __webpack_require__(495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554666ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientLogin_vue__ = __webpack_require__(1354);
function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-554666ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554666ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"client-login-bg"},[_c('div',{staticClass:"client-login-container"},[_c('img',{staticClass:"client-login-logo",attrs:{"src":"/static/logo.svg"}}),_vm._v(" "),_c('el-form',{ref:"clientLogin",attrs:{"model":_vm.clientLogin,"status-icon":"","rules":_vm.rules},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"label":"Ingresa tu contraseña","prop":"password"}},[_c('el-input',{attrs:{"type":"password","placeholder":"","prefix-icon":"el-icon-edit","auto-complete":"off"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.validateAndSumbit('clientLogin')}},model:{value:(_vm.clientLogin.password),callback:function ($$v) {_vm.$set(_vm.clientLogin, "password", $$v)},expression:"clientLogin.password"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%","background-color":"#2873DE","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.validateAndSumbit('clientLogin')}}},[_vm._v("Ver mi portafolio")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportantLinks_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e09f513_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportantLinks_vue__ = __webpack_require__(1357);
function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e09f513"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportantLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e09f513_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportantLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"top-section"},[_c('el-row',{staticClass:"list-header"},[_c('el-col',{staticClass:"section-header",attrs:{"span":24,"gutter":20}},[_c('div',{staticClass:"section-title"},[_vm._v("Tablero de Control")])])],1),_vm._v(" "),_c('el-row',{staticClass:"card-row row1",attrs:{"gutter":10}},[_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px'}}},[_c('div',{staticClass:"clearfix",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Herramientas")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('el-button',{staticClass:"text item",attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.goToLink('/validacion')}}},[_vm._v("Validación")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('el-button',{staticClass:"text item",attrs:{"type":"text"},on:{"click":function($event){_vm.goToLink('/calculadora')}}},[_vm._v("Calculadoras")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.tools[2].url,"target":"_blank","title":_vm.tools[2].url}},[_vm._v(_vm._s(_vm.tools[2].text))])])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px' }}},[_c('div',{staticClass:"clearfix",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Aperturas")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.openings[0].url,"target":"_blank","title":_vm.openings[0].url}},[_vm._v(_vm._s(_vm.openings[0].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.openings[1].url,"target":"_blank","title":_vm.openings[1].url}},[_vm._v(_vm._s(_vm.openings[1].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.openings[2].url,"target":"_blank","title":_vm.openings[2].url}},[_vm._v(_vm._s(_vm.openings[2].text))])])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px' }}},[_c('div',{staticClass:"clearfix",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Complemento")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.complements[0].url,"target":"_blank","title":_vm.complements[0].url}},[_vm._v(_vm._s(_vm.complements[0].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.complements[1].url,"target":"_blank","title":_vm.complements[1].url}},[_vm._v(_vm._s(_vm.complements[1].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_vm._v("   ")])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"card-row row2",attrs:{"gutter":10}},[_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px' }}},[_c('div',{staticClass:"clearfix header",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Reportes")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.reports[0].url,"target":"_blank","title":_vm.reports[0].url}},[_vm._v(_vm._s(_vm.reports[0].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('el-button',{staticClass:"text item",attrs:{"type":"text"},on:{"click":function($event){_vm.goToLink('/lista-de-analisis')}}},[_vm._v("Análisis portafolios")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_vm._v(" ")])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px' }}},[_c('div',{staticClass:"clearfix",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Operaciones")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.operations[0].url,"target":"_blank","title":_vm.operations[0].url}},[_vm._v(_vm._s(_vm.operations[0].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.operations[1].url,"target":"_blank","title":_vm.operations[1].url}},[_vm._v(_vm._s(_vm.operations[1].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_vm._v(" ")])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":22,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover","body-style":{ padding: '0px' }}},[_c('div',{staticClass:"clearfix",staticStyle:{"background-color":"#001F5C"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"card-title"},[_vm._v("Web")])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.web[0].url,"target":"_blank","title":_vm.web[0].url}},[_vm._v(_vm._s(_vm.web[0].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.web[1].url,"target":"_blank","title":_vm.web[1].url}},[_vm._v(_vm._s(_vm.web[1].text))])]),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('a',{attrs:{"href":_vm.web[2].url,"target":"_blank","title":_vm.web[2].url}},[_vm._v(_vm._s(_vm.web[2].text))])])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validacion_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f7aa68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validacion_vue__ = __webpack_require__(1360);
function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f7aa68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_b"},[_c('div',{staticClass:"top-section"},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"section-header"},[_c('p',{staticClass:"section-title"},[_vm._v("Validación de datos (Email y correo)")])])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('div',[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"Buscar por Alias/Email Cliente o CVE Promotor","clearable":"","minlength":"2"},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search","type":"primary","circle":""},on:{"click":_vm.validate},slot:"append"})],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"singleTable",attrs:{"empty-text":"Sin resultados","data":_vm.valid,"row-class-name":_vm.tableRowClassName,"height":"70vh"},on:{"filter-change":_vm.filterChange}},[_c('el-table-column',{attrs:{"prop":"alias","label":"Alias","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nombre","label":"Nombre","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codigoCliente","label":"Código","width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mailSiap","label":"Email","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('el-input',{attrs:{"type":"text","disabled":scope.row.edited,"clearable":"","size":"small"},model:{value:(scope.row.mailSiap),callback:function ($$v) {_vm.$set(scope.row, "mailSiap", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.mailSiap"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"telCelular","label":"Celular (10 dígitos)","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"type":"text","maxlength":"10","show-word-limit":"","disabled":scope.row.edited,"clearable":"","size":"small"},model:{value:(scope.row.telCelular),callback:function ($$v) {_vm.$set(scope.row, "telCelular", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.telCelular"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"default","size":"mini","disabled":scope.row.edited},on:{"click":function($event){_vm.handleSave(scope.$index, scope.row)}}},[_vm._v("Guardar")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit","size":"mini","plain":""},on:{"click":function($event){_vm.handleEdit(scope.$index, scope.row)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":scope.row.validated,"plain":""},on:{"click":function($event){_vm.handleValidation(scope.$index, scope.row)}}},[_vm._v("Validar")])]}}])}),_vm._v(" "),(_vm.email ==='middle@columbus.mx')?_c('el-table-column',{attrs:{"prop":"cvePromotor","label":"CVE","width":"60"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatedAt","label":"Última Actualización","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"strStatus","label":"Envio","width":"120","filters":[{ text: 'Enviado', value: 'Enviado' }, { text: 'Sin Enviar', value: 'Sin Enviar' }],"filter-method":_vm.filterTag,"filter-placement":"bottom-end"}})],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Validar Datos y enviar código al Cliente","visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[(_vm.formData.mailSiap)?_c('div',[_c('el-form',{attrs:{"model":_vm.formData}},[_c('el-form-item',{attrs:{"label":"Email Cliente","label-width":_vm.formLabelWidth}},[(_vm.formData.mailSiap)?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"maxlength":"50","readonly":""},model:{value:(_vm.formData.mailSiap),callback:function ($$v) {_vm.$set(_vm.formData, "mailSiap", $$v)},expression:"formData.mailSiap"}}):(_vm.formData.mailSiap === '')?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"value":"Sin datos de Correo","maxlength":"50","disabled":""}}):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Celular Cliente","label-width":_vm.formLabelWidth}},[_c('el-input',{staticStyle:{"width":"40%"},attrs:{"readonly":""},model:{value:(_vm.formData.telCelular),callback:function ($$v) {_vm.$set(_vm.formData, "telCelular", $$v)},expression:"formData.telCelular"}})],1),_vm._v(" "),_c('p',[_vm._v("Enviar los datos del cliente al correo de contratos.")])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.sendData(_vm.formData)}}},[_vm._v("Enviar")])],1),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.formData.mailPromotor)+", actuando dentro del alias "+_vm._s(_vm.formData.alias)+". En mi carácter de Ejecutivo de Relación,\n          manifiesto bajo protesta de decir verdad que la información presentada dentro del expediente que nos ocupa,\n          misma que consiste en número de celular y correo electrónico, fue proporcionada por el cliente,\n          la cual corroboré personalmente por lo que cualquier error u omisión en su veracidad, será mi única\n          y absoluta responsabilidad. "),_c('b',[_vm._v("Al enviar acepto las condiciones.")])])],1):_c('div',[_c('el-form',{attrs:{"model":_vm.formData}},[_c('el-form-item',{attrs:{"label":"Email Cliente","label-width":_vm.formLabelWidth}},[(_vm.formData.mailSiap)?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"maxlength":"30","readonly":""},model:{value:(_vm.formData.mailSiap),callback:function ($$v) {_vm.$set(_vm.formData, "mailSiap", $$v)},expression:"formData.mailSiap"}}):(_vm.formData.mailSiap === '')?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"value":"Sin datos de Correo","maxlength":"50","disabled":""}}):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Celular Cliente","label-width":_vm.formLabelWidth}},[_c('el-input',{staticStyle:{"width":"40%"},attrs:{"value":"Sin datos de Celular","disabled":""}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":""},on:{"click":_vm.sendData}},[_vm._v("Enviar")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__(498);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06d982e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__(1363);
function injectStyle (ssrContext) {
  __webpack_require__(1362)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b06d982e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06d982e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1362:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"top-section"},[_c('el-row',{staticClass:"list-header"},[_c('el-col',{staticClass:"section-header",attrs:{"span":24,"gutter":20}},[_c('div',{staticClass:"section-title"},[_vm._v("Opciones")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"cards-opt"},[_c('el-row',{staticClass:"card-row row-1",attrs:{"gutter":20,"justify":"center"}},[_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":10,"lg":10,"xl":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-title"},[_c('strong',[_vm._v("Calculadora de Inversión Aseguradora vs Tradicional")])]),_vm._v(" "),_c('el-button',{staticClass:"card-button",staticStyle:{"float":"right"},attrs:{"type":"primary"},on:{"click":function($event){_vm.goToAnalysis(1)}}},[_vm._v("Iniciar")])],1),_vm._v(" "),_c('span',{staticClass:"card-body"},[_vm._v("Calculadora de Inversión Aseguradora vs Tradicional")])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":10,"lg":10,"xl":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-title"},[_c('strong',[_vm._v("Opción 2")])]),_vm._v(" "),_c('el-button',{staticClass:"card-button",staticStyle:{"float":"right"},attrs:{"type":"primary","disabled":""},on:{"click":function($event){_vm.goToAnalysis(2)}}},[_vm._v("Iniciar")])],1),_vm._v(" "),_c('span',{staticClass:"card-body"},[_vm._v("Descripción")])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"card-row row-2",attrs:{"gutter":20,"justify":"center"}},[_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":10,"lg":10,"xl":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-title"},[_c('strong',[_vm._v("Opción 3")])]),_vm._v(" "),_c('el-button',{staticClass:"card-button",staticStyle:{"float":"right"},attrs:{"type":"primary","disabled":""},on:{"click":function($event){_vm.goToAnalysis(3)}}},[_vm._v("Iniciar")])],1),_vm._v(" "),_c('span',{staticClass:"card-body"},[_vm._v("Descripción")])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":22,"sm":22,"md":10,"lg":10,"xl":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-title"},[_c('strong',[_vm._v("Opción 4")])]),_vm._v(" "),_c('el-button',{staticClass:"card-button",staticStyle:{"float":"right"},attrs:{"type":"primary","disabled":""},on:{"click":function($event){_vm.goToAnalysis(4)}}},[_vm._v("Iniciar")])],1),_vm._v(" "),_c('span',{staticClass:"card-body"},[_vm._v("Descripción")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_Op1_vue__ = __webpack_require__(499);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01ca37c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_Op1_vue__ = __webpack_require__(1367);
function injectStyle (ssrContext) {
  __webpack_require__(1365)
  __webpack_require__(1366)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e01ca37c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_Op1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01ca37c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_Op1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"top-section"},[_c('el-row',{staticClass:"list-header"},[_c('el-col',{staticClass:"section-header",attrs:{"span":24,"gutter":20}},[_c('div',{staticClass:"section-title"},[_vm._v("Calculadora de Inversión Aseguradora vs Tradicional")])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"graph-form",attrs:{"gutter":10}},[_c('el-col',{staticClass:"card-col col-form",attrs:{"xs":24,"sm":24,"md":4,"lg":4,"xl":4}},[_c('el-card',{staticClass:"box-card"},[_c('el-form',{ref:"ruleForm",staticClass:"graph-form",attrs:{"model":_vm.ruleForm,"status-icon":"","rules":_vm.rules,"label-width":"auto","size":"mini","label-position":"right"}},[_c('el-row',{attrs:{"gutter":1}},[_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Capital Inicial","prop":"capital"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],attrs:{"autofocus":""},model:{value:(_vm.ruleForm.capital),callback:function ($$v) {_vm.$set(_vm.ruleForm, "capital", $$v)},expression:"ruleForm.capital"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Tasa Nominal","prop":"tasa_nominal"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money_p),expression:"money_p"}],model:{value:(_vm.ruleForm.tasa_nominal),callback:function ($$v) {_vm.$set(_vm.ruleForm, "tasa_nominal", $$v)},expression:"ruleForm.tasa_nominal"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":1}},[_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Inflación","prop":"inflacion"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money_p),expression:"money_p"}],model:{value:(_vm.ruleForm.inflacion),callback:function ($$v) {_vm.$set(_vm.ruleForm, "inflacion", $$v)},expression:"ruleForm.inflacion"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Tasa Real"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money_p),expression:"money_p"}],attrs:{"value":_vm.result,"disabled":""}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":1}},[_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Tasa ISR","prop":"tasa_isr"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money_p),expression:"money_p"}],model:{value:(_vm.ruleForm.tasa_isr),callback:function ($$v) {_vm.$set(_vm.ruleForm, "tasa_isr", $$v)},expression:"ruleForm.tasa_isr"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":12,"sm":12,"md":24,"lg":24,"xl":24}},[_c('el-form-item',{staticClass:"label-title",attrs:{"label":"Tasa Ret. Prov","prop":"tasa_ret_prov"}},[_c('el-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money_p),expression:"money_p"}],model:{value:(_vm.ruleForm.tasa_ret_prov),callback:function ($$v) {_vm.$set(_vm.ruleForm, "tasa_ret_prov", $$v)},expression:"ruleForm.tasa_ret_prov"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"block"},[_c('span',{staticClass:"label-title"},[_vm._v("Rango de Tiempo")]),_vm._v(" "),_c('el-slider',{attrs:{"min":10,"step":5,"max":40,"marks":_vm.marks},model:{value:(_vm.sliderY),callback:function ($$v) {_vm.sliderY=$$v},expression:"sliderY"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._v("Gráfica")])],1)],1)],1)],1),_vm._v(" "),_c('el-col',{staticClass:"col-chart",attrs:{"xs":24,"sm":24,"md":20,"lg":20,"xl":20}},[_c('div',{staticClass:"hidden",attrs:{"id":"tooltip"}},[_c('p',[_c('strong',{staticStyle:{"color":"#4366de"}},[_vm._v("Aseguradora")])]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"color":"#4366de"},attrs:{"id":"valueA"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#fd6b7d"}},[_vm._v("Tradicional")])]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"color":"#fd6b7d"},attrs:{"id":"valueT"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#001F5C"}},[_vm._v("Diferencia a")])]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"color":"#001F5C"},attrs:{"id":"valueD"}},[_vm._v("100")])])]),_vm._v(" "),_c('div',{ref:"chartwrapper",staticClass:"chartwrapper"})])],1),_vm._v(" "),_c('el-row',{staticClass:"row-info",attrs:{"id":"cards-info","gutter":15}},[_c('el-col',{staticClass:"card-col",attrs:{"xs":24,"sm":24,"md":12,"lg":8,"xl":8}},[_c('el-card',{staticClass:"info-card card-10",attrs:{"id":"card-info1"}},[_c('div',[_c('p',[_c('strong',{staticStyle:{"color":"#001F5C"},attrs:{"id":"info1-D"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#4366de"},attrs:{"id":"info1-A"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#fd6b7d"},attrs:{"id":"info1-T"}},[_vm._v("100")])])])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":24,"sm":24,"md":12,"lg":8,"xl":8}},[_c('el-card',{staticClass:"info-card card-20"},[_c('div',[_c('p',[_c('strong',{staticStyle:{"color":"#001F5C"},attrs:{"id":"info2-D"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#4366de"},attrs:{"id":"info2-A"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#fd6b7d"},attrs:{"id":"info2-T"}},[_vm._v("100")])])])])],1),_vm._v(" "),_c('el-col',{staticClass:"card-col",attrs:{"xs":24,"sm":24,"md":24,"lg":8,"xl":8}},[_c('el-card',{staticClass:"info-card card-30"},[_c('div',[_c('p',[_c('strong',{staticStyle:{"color":"#001F5C"},attrs:{"id":"info3-D"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#4366de"},attrs:{"id":"info3-A"}},[_vm._v("100")])]),_vm._v(" "),_c('p',[_c('strong',{staticStyle:{"color":"#fd6b7d"},attrs:{"id":"info3-T"}},[_vm._v("100")])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34641ce6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34641ce6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34641ce6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableData_vue__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f67c5e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableData_vue__ = __webpack_require__(1291);
function injectStyle (ssrContext) {
  __webpack_require__(1275)
  __webpack_require__(1276)
  __webpack_require__(1277)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f67c5e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f67c5e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonnutChartSection_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01ea1444_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonnutChartSection_vue__ = __webpack_require__(1301);
function injectStyle (ssrContext) {
  __webpack_require__(1292)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01ea1444"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonnutChartSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01ea1444_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonnutChartSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return legalNoticeText; });
var legalNoticeText = 'Columbus de México S.A de C.V. Asesor en Inversiones Independiente tiene el número de folio de inscripción 30005 en el Registro de Asesores en Inversiones asignado por la Comisión Nacional Bancaria y de Valores (“La Comisión”). La Comisión supervisa exclusivamente la prestación de servicios de administración de cartera de valores cuando se tomen decisiones de inversión a nombre y por cuenta de terceros, así como los servicios consistentes en otorgar asesoría de inversión en valores, análisis y emisión de recomendaciones de inversión de manera individualizada, por lo que carece de atribuciones para supervisar o regular cualquier otro servicio que proporcione el Asesor en Inversiones. Asimismo, la inscripción en el registro de Asesores en Inversiones que lleva la Comisión en términos de la Ley del Mercado de Valores, no implica el apego de los Asesores en Inversiones a las disposiciones aplicables en los servicios prestados, ni la exactitud o veracidad de la información proporcionada.';

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(990);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__["a" /* default */]
  },
  data: function data() {
    return {
      isUserLogged: true,
      menuIsVisible: false,
      clientView: false
    };
  },

  computed: {
    showHeader: function showHeader() {
      return this.$route.path !== '/cliente' && !this.$route.path.startsWith('/imprimir-analisis-portafolio');
    }
  },
  created: function created() {
    this.clientView = this.$route.path === '/cliente';
    var existSession = localStorage.getItem('token');
    var userId = localStorage.getItem('user_id');
    if (existSession && userId) {
      if (this.$route.path !== '/seccion-de-pruebas' && this.$route.name !== 'PrintablePortfolioAnalysis') {
        this.$router.push('/lista-de-analisis');
      }
    } else if (this.$route.path !== '/cliente') {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppHeader',
  components: {
    'nav-bar': __WEBPACK_IMPORTED_MODULE_0__components_NavBar__["a" /* default */]
  },
  data: function data() {
    return {
      query: '',
      displaySendUrlDialog: false,
      sendUrlData: {
        email: ''
      },
      rules: {
        email: [{
          required: true,
          message: "Debes proporcionar un email",
          trigger: "blur"
        }, {
          type: "email",
          message: "Es necesario un email válido, ejemplo@email.com",
          trigger: "blur"
        }]
      }
    };
  },

  watch: {
    query: function query(value) {
      if (value !== '') {
        this.querySearch(value);
      } else {
        this.fetchCleanData(this.searchConfiguration);
      }
    },
    displaySendUrlDialog: function displaySendUrlDialog(value) {
      if (!value) {
        this.$refs["sendShareUrl"].resetFields();
      }
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.$store.dispatch('toggleMenu', !this.menuIsVisible);
    },
    resetInput: function resetInput() {
      this.query = '';
      this.fetchCleanData(this.searchConfiguration);
    },
    fetchCleanData: function fetchCleanData(searchType) {
      var _this = this;

      if (searchType === 'portfolios') {
        // Find portfolios
        if (!this.userIsAdmin) {
          this.$apollo.query({
            query: __WEBPACK_IMPORTED_MODULE_1__graphql__["u" /* getPortfoliosByAdvisorId */],
            variables: {
              advisorId: this.$store.getters.userInfo.id
            },
            fetchPolicy: 'network-only'
          }).then(function (data) {
            return _this.$store.dispatch('savePortfolios', data.data.portfoliosByAdvisor);
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          this.$apollo.query({
            query: __WEBPACK_IMPORTED_MODULE_1__graphql__["k" /* getAllPortfolios */],
            fetchPolicy: 'network-only'
          }).then(function (data) {
            return _this.$store.dispatch('savePortfolios', data.data.allPortfolios);
          }).catch(function (error) {
            console.log(error);
          });
        }
        // Find advisors
      } else {
        this.$apollo.query({
          query: __WEBPACK_IMPORTED_MODULE_1__graphql__["j" /* getAllAdvisors */],
          fetchPolicy: 'network-only'
        }).then(function (data) {
          return _this.$store.dispatch('saveAdvisors', data.data.allAdvisors);
        });
      }
    },
    querySearch: function querySearch(query) {
      var _this2 = this;

      // search data by current section
      // portfolios
      if (this.searchConfiguration === 'portfolios') {
        // search by current user type
        if (this.userIsAdmin) {
          this.$apollo.query({
            query: __WEBPACK_IMPORTED_MODULE_1__graphql__["u" /* getPortfoliosByAdvisorId */],
            variables: {
              query: this.query
            },
            fetchPolicy: 'network-only'
          }).then(function (data) {
            return _this2.$store.dispatch('savePortfolios', data.data.portfoliosByAdvisor);
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          this.$apollo.query({
            query: __WEBPACK_IMPORTED_MODULE_1__graphql__["u" /* getPortfoliosByAdvisorId */],
            variables: {
              advisorId: this.$store.getters.userInfo.id,
              query: this.query
            },
            fetchPolicy: 'network-only'
          }).then(function (data) {
            return _this2.$store.dispatch('savePortfolios', data.data.portfoliosByAdvisor);
          }).catch(function (error) {
            console.log(error);
          });
        }
        //  advisors
      } else {
        this.$apollo.query({
          query: __WEBPACK_IMPORTED_MODULE_1__graphql__["i" /* getAdvisorsByQuery */],
          variables: {
            query: this.query
          },
          fetchPolicy: 'network-only'
        }).then(function (data) {
          return _this2.$store.dispatch('saveAdvisors', data.data.findAdvisors);
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    editPortfolio: function editPortfolio() {
      var _this3 = this;

      var id = this.$route.params.id;
      this.$store.dispatch('setSelectedPortfolio', id);
      this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_1__graphql__["s" /* getPortfolioById */],
        variables: { id: id }
      }).then(function (data) {
        return _this3.redirectToForm(data.data.portfolioById);
      }).catch(function () {
        _this3.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    redirectToForm: function redirectToForm(portfolio) {
      this.$store.dispatch('setFormMode', 3);
      this.$store.dispatch("preloadPortfolioForm", portfolio);
      this.$router.push('/registro-datos-generales');
    },
    goToPrintable: function goToPrintable(event) {
      var route = this.$router.resolve('/imprimir-analisis-portafolio/' + this.$route.params.id);
      window.open(route.href, '_blank');
    },
    updatePortfolio: function updatePortfolio(event) {
      var _this4 = this;

      this.$apollo.mutate({ mutation: __WEBPACK_IMPORTED_MODULE_1__graphql__["A" /* upgradePortfolio */],
        variables: { portfolioId: this.$route.params.id }
      }).then(function (data) {
        return _this4.requestSuccess(data.data.upgradePortfolio.message);
      }).catch(function () {
        _this4.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    sendPortfolioUrl: function sendPortfolioUrl() {
      var _this5 = this;

      var portfolioId = parseInt(this.$route.params.id);
      // this.sendUrlData.email = ''
      // this.$refs["sendShareUrl"].resetFields();
      var userEmail = this.$store.getters.currentPortfolioAnalysis.email;
      if (userEmail) {
        this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_1__graphql__["x" /* sendUrl */],
          variables: { portfolioId: portfolioId, email: userEmail },
          fetchPolicy: 'network-only'
        }).then(function (data) {
          return _this5.requestSuccess(data.data.sendAnalysisUrl.msg);
        }).catch(function () {
          _this5.$message({
            type: "error",
            message: "Ocurrió un error intenta más tarde"
          });
        });
      } else {
        this.displaySendUrlDialog = true;
      }
    },
    validateAndSumbit: function validateAndSumbit(formName) {
      var _this6 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.displaySendUrlDialog = false;
          var email = _this6.sendUrlData.email;
          _this6.sendUrl(email);
        } else {
          return false;
        }
      });
    },
    sendUrl: function sendUrl(email) {
      var _this7 = this;

      var portfolioId = this.$route.params.id;
      this.sendUrlData.email = '';
      this.$refs["sendShareUrl"].resetFields();
      this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_1__graphql__["x" /* sendUrl */],
        variables: { portfolioId: portfolioId, email: email },
        fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this7.requestSuccess(data.data.sendAnalysisUrl.msg);
      }).catch(function () {
        _this7.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    requestSuccess: function requestSuccess(message) {
      this.$message({ type: "success", message: message });
    }
  },
  computed: {
    userIsLogged: function userIsLogged() {
      return this.$store.getters.userIsLogged;
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    menuIsVisible: function menuIsVisible() {
      return this.$store.getters.menuIsVisible;
    },
    hideSearchbar: function hideSearchbar() {

      var hide = true;

      if (this.$route.fullPath.startsWith('/registro')) {
        hide = false;
      } else if (this.$route.fullPath.startsWith('/validacion')) {
        hide = false;
      } else if (this.$route.fullPath.startsWith('/links')) {
        hide = false;
      } else if (this.$route.fullPath.startsWith('/calculadora')) {
        hide = false;
      }

      return hide;
    },
    searchConfiguration: function searchConfiguration() {
      return this.$route.name === 'Advisors' ? 'advisors' : 'portfolios';
    },
    inputPlaceholder: function inputPlaceholder() {
      return this.$route.name === 'Advisors' ? 'Buscar nombre o correo' : 'Busca no. de portafolio o alias';
    },
    portfolioContractNumber: function portfolioContractNumber() {
      return this.$store.getters.currentPortfolioAnalysis.contractNumber || '';
    },
    setting: function setting() {
      var currentComponent = this.$store.state.route.name;
      if (this.$route.params.id && this.userIsLogged) {
        return 'portfolioNavigation';
      } else if (this.userIsLogged) {
        return 'appNavigation';
      } else {
        return 'initial';
      }
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NavBar',
  computed: {
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    }
  },
  methods: {
    handleSelect: function handleSelect(key) {
      this.$store.dispatch('toggleMenu', false);
      if (key !== '/login') {
        this.$router.push(key);
      } else {
        // logout user
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        this.$store.dispatch('deleteUserData');
        this.$router.push('/');
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioHeader_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c89e8de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioHeader_vue__ = __webpack_require__(1318);
function injectStyle (ssrContext) {
  __webpack_require__(1314)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c89e8de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c89e8de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      userEmail: '',
      password: '',
      userExists: 1,
      userData: {},
      dialogVisible: false,
      recoverPassword: {
        email: ''
      },
      rules: {
        email: [{
          required: true,
          message: "Debes proporcionar un email",
          trigger: "blur"
        }, {
          type: "email",
          message: "Es necesario un email válido, ejemplo@email.com",
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    sendLoginRequest: function sendLoginRequest() {
      var _this = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["v" /* loginUser */],
        variables: {
          username: this.userEmail,
          password: this.password
        }
      }).then(function (data) {
        return _this.successHandler(data.data);
      }).catch(function (error) {
        _this.$message({
          type: 'error',
          message: 'Ocurrió un error, intenta más tarde'
        });
      });
    },
    successHandler: function successHandler(data) {
      // User login was succesful
      if (data.advisorLogin) {
        var redirectUrl = data.advisorLogin.advisor.isAdmin ? '/lista-de-asesores' : '/lista-de-analisis';
        this.saveSession(data.advisorLogin.advisor.id, data.advisorLogin.token);
        this.$store.dispatch('toggleMenu', true);
        this.$store.dispatch('saveUserData', data.advisorLogin).then(this.$router.push(redirectUrl));
      } else if (data.errors) {
        this.$message({
          type: 'error',
          message: 'El usuario o contraseña incorrecta'
        });
      }
    },
    saveSession: function saveSession(id, token) {
      localStorage.setItem('user_id', id);
      localStorage.setItem('token', token);
    },
    validateAndSumbit: function validateAndSumbit(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.sendRecoverPassworRequest(_this2.recoverPassword.email);
        } else {
          return false;
        }
      });
    },
    sendRecoverPassworRequest: function sendRecoverPassworRequest(email) {
      var _this3 = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["w" /* recoverPassword */],
        variables: {
          email: email
        }, fetchPolicy: 'network-only'
      }).then(function (data) {
        _this3.dialogVisible = false;
        _this3.$message({
          type: "success",
          message: data.data.recoverPassword.msg
        });
      });
    }
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Portfolios',
  data: function data() {
    return {
      loading: true,
      displaySendUrlDialog: false,
      sendUrlData: {
        email: '',
        portfolioId: 0
      },
      rules: {
        email: [{
          required: true,
          message: "Debes proporcionar un email",
          trigger: "blur"
        }, {
          type: "email",
          message: "Es necesario un email válido, ejemplo@email.com",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    var userId = localStorage.getItem('user_id');
    if (!this.advisorId) {
      this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_0__graphql__["h" /* getAdvisorData */],
        variables: { id: userId },
        fetchPolicy: 'cache-first' }).then(function (data) {
        return _this.$store.dispatch('saveUserData', data.data);
      });
    }
  },

  computed: {
    advisoryQuery: function advisoryQuery() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["u" /* getPortfoliosByAdvisorId */],
        variables: {
          advisorId: this.advisorId
        },
        fetchPolicy: 'network-only'
      };
    },
    adminQuery: function adminQuery() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["k" /* getAllPortfolios */],
        fetchPolicy: 'network-only'
      };
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    advisorId: function advisorId() {
      return this.$store.getters.userInfo.id;
    },
    portfolios: function portfolios() {
      return this.$store.getters.portfoliosData;
    }
  },
  watch: {
    advisorId: function advisorId(value) {
      // console.log("USER HAS CHANGED", value)
      this.getPortfolios();
    }
  },
  mounted: function mounted() {
    this.getPortfolios();
  },

  methods: {
    getPortfolios: function getPortfolios() {
      var _this2 = this;

      // console.log("Loading portfolios", this.userIsAdmin, this.advisorId)
      if (this.advisorId) {
        var q = this.userIsAdmin ? this.adminQuery : this.advisoryQuery;
        this.$apollo.query({
          query: q.query,
          variables: q.variables,
          fetchPolicy: q.fetchPolicy
        }).then(function (data) {
          _this2.successHandler(data.data);
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    goToNewPortfolioForm: function goToNewPortfolioForm() {
      this.$store.dispatch('resetPortfolioForm');
      this.$store.dispatch('setFormMode', 1);
      this.$router.push('/registro-datos-generales');
    },
    setStatusStyles: function setStatusStyles(_ref) {
      var row = _ref.row,
          columnIndex = _ref.columnIndex;

      if (columnIndex === 4 && row.status == 'Listo') {
        return 'ready';
      } else if (columnIndex === 4 && row.status == 'En progreso') {
        return 'in-progress';
      } else if (columnIndex === 4 && row.status == 'Comentado') {
        return 'commented';
      }
    },
    successHandler: function successHandler(data) {
      this.loading = false;
      this.$store.dispatch('savePortfolios', this.userIsAdmin ? data.allPortfolios : data.portfoliosByAdvisor);
    },
    goToPortfolio: function goToPortfolio(row, column, cell, event) {
      if (column.property && row.status !== 'En progreso') {
        var portfolioId = row.id;
        this.$router.push('analisis-portafolio/' + portfolioId);
      }
    },
    continueDraft: function continueDraft(id) {
      var _this3 = this;

      this.$store.dispatch('setSelectedPortfolio', id);
      this.$store.dispatch('setFormMode', 2);
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["s" /* getPortfolioById */],
        variables: { id: id },
        fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this3.redirectToForm(data.data.portfolioById);
      }).catch(function () {
        _this3.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    editPortfolio: function editPortfolio(id) {
      var _this4 = this;

      this.$store.dispatch('setFormMode', 3);
      this.$store.dispatch('setSelectedPortfolio', id);
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["s" /* getPortfolioById */],
        variables: { id: id },
        fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this4.redirectToForm(data.data.portfolioById);
      }).catch(function () {
        _this4.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    redirectToForm: function redirectToForm(portfolio) {
      this.$store.dispatch("preloadPortfolioForm", portfolio);
      this.$router.push('/registro-datos-generales');
    },
    updatePortfolio: function updatePortfolio(portfolioId) {
      var _this5 = this;

      this.$apollo.mutate({ mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["A" /* upgradePortfolio */],
        variables: { portfolioId: portfolioId }
      }).then(function (data) {
        return _this5.requestSuccess(data.data.upgradePortfolio.message);
      }).catch(function () {
        _this5.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    commentPortfolio: function commentPortfolio(portfolioId) {
      this.$router.push('analisis-portafolio/' + portfolioId);
    },
    validateAndSumbit: function validateAndSumbit(formName) {
      var _this6 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.displaySendUrlDialog = false;
          _this6.sendUrlRequest(_this6.sendUrlData);
        } else {
          return false;
        }
      });
    },
    sendUrlRequest: function sendUrlRequest(data) {
      var _this7 = this;

      this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_0__graphql__["x" /* sendUrl */],
        variables: {
          portfolioId: data.portfolioId,
          email: data.email
        }
      }).then(function (data) {
        return _this7.requestSuccess(data.data.sendAnalysisUrl.msg);
      }).catch(function () {
        _this7.$message({
          type: "error",
          message: "Ocurrió un error, intenta más tarde"
        });
      });
    },
    showSendUrlDialog: function showSendUrlDialog(portfolioId) {
      this.sendUrlData.portfolioId = portfolioId;
      this.displaySendUrlDialog = true;
    },
    sendUrl: function sendUrl(portfolioData) {
      var _this8 = this;

      var portfolioId = portfolioData.id;
      var clientEmail = portfolioData.client.email;
      if (clientEmail) {
        this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_0__graphql__["x" /* sendUrl */],
          variables: {
            portfolioId: portfolioId,
            email: clientEmail
          }
        }).then(function (data) {
          return _this8.requestSuccess(data.data.sendAnalysisUrl.msg);
        }).catch(function () {
          _this8.$message({
            type: "error",
            message: "Ocurrió un error intenta más tarde"
          });
        });
      } else {
        this.showSendUrlDialog(portfolioId);
      }
    },
    requestSuccess: function requestSuccess(message) {
      this.$message({ type: "success", message: message });
    },
    deleteRequestSuccess: function deleteRequestSuccess() {
      this.getPortfolios();
      this.$message({ type: "success", message: "Se borró el portafolio efectivamente" });
      // console.log("YESS")
    },
    deletePortfolio: function deletePortfolio(portfolioId) {
      var _this9 = this;

      this.$confirm("¿Deseas borrar el portafolio? Se borrará permanentemente.", "Borrar portafolio", {
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        _this9.doDeletePortfolio(portfolioId);
      }).catch(function () {
        _this9.$message({
          type: "info",
          message: "Acción cancelada"
        });
      });
    },
    doDeletePortfolio: function doDeletePortfolio(portfolioId) {
      var _this10 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["g" /* deletePortfolio */],
        variables: {
          portfolioId: portfolioId
        }
      }).then(function (data) {
        return _this10.deleteRequestSuccess();
      }).catch(function () {
        _this10.$message({
          type: "error",
          message: "Ocurrió un error, por favor intenta más tarde o contacta al admin"
        });
      });
    }
  }
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      dialogVisible: false,
      registryData: {
        name: "",
        email: "",
        password: "",
        confirm_password: ""
      },
      rules: {
        name: [{
          required: true,
          message: "Debes proporcionar un nombre",
          trigger: "blur"
        }, {
          min: 3,
          max: 30,
          message: "El nombre es demasiado corto",
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: "Debes proporcionar un email",
          trigger: "blur"
        }, {
          type: "email",
          message: "Es necesario un email válido, ejemplo@email.com",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "Debes proporcionar una contraseña",
          trigger: "blur"
        }, {
          min: 3,
          message: "La contraseña es demasiado corta",
          trigger: "blur"
        }, {
          max: 15,
          message: "La contraseña es demasiado larga",
          trigger: "blur"
        }],
        confirm_password: [{
          required: true,
          validator: this.validateConfirmPassword,
          trigger: ["blur", "change"]
        }]
      }
    };
  },

  computed: {
    advisors: function advisors() {
      return this.$store.getters.advisorsData;
    }
  },
  mounted: function mounted() {
    this.getAdvisors();
  },

  methods: {
    getAdvisors: function getAdvisors() {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["j" /* getAllAdvisors */],
        fetchPolicy: "network-only"
      }).then(function (data) {
        return _this.successHandler(data.data.allAdvisors);
      }).catch(function (error) {
        console.log(error);
      });
    },
    successHandler: function successHandler(advisors) {
      this.loading = false;
      this.$store.dispatch("saveAdvisors", advisors);
    },
    validateConfirmPassword: function validateConfirmPassword(rule, value, callback) {
      if (value === "" && value === this.registryData.password) {
        callback(new Error("Es necesario confirmar la contraseña"));
      } else if (value !== "" && value !== this.registryData.password) {
        callback(new Error("Las contraseñas no coinciden"));
      } else if (value !== "" && value === this.registryData.password) {
        callback();
      }
    },
    _deleteUser: function _deleteUser(advisorId) {
      var _this2 = this;

      this.$confirm("Esto lo borrará permanentemente. ¿Continuar?", "Dar de baja asesor", {
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        type: "warning"
      }).then(function () {
        _this2.deleteAdvisor(advisorId);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Acción cancelada"
        });
      });
    },
    handleClose: function handleClose(done) {
      var _this3 = this;

      this.$confirm("¿Seguro que quieres salir?", {
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(function (_) {
        _this3.$refs["registryData"].resetFields();
        done();
      }).catch(function (_) {});
    },
    validateAndSumbit: function validateAndSumbit(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.dialogVisible = false;
          _this4.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["c" /* createAdvisor */],
            variables: {
              name: _this4.registryData.name,
              password: _this4.registryData.password,
              email: _this4.registryData.email
            }
          }).then(function (data) {
            return _this4.requestSuccess(data, "create");
          }).catch(function () {
            _this4.$message({
              type: "error",
              message: "Ocurrió un error intenta más tarde"
            });
          });
        } else {
          return false;
        }
      });
    },
    requestSuccess: function requestSuccess(data, action) {
      var successMessage = action === "create" ? "Asesor creado" : "Asesor eliminado";
      // console.log("Run this");
      if (action === "create") {
        this.$refs["registryData"].resetFields();
      }
      // console.log("Maybe not Run this");
      this.getAdvisors();
      this.$message({
        type: "success",
        message: successMessage
      });
    },
    deleteAdvisor: function deleteAdvisor(advisorId) {
      var _this5 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["f" /* deleteAdvisor */],
        variables: {
          advisorId: advisorId
        }
      }).then(function (data) {
        return _this5.requestSuccess(data, "delete");
      }).catch(function () {
        _this5.$message({
          type: "error",
          message: "Ocurrió un error, por favor intenta más tarde o contacta al admin"
        });
      });
    },
    recoverPassword: function recoverPassword(email) {
      var _this6 = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["w" /* recoverPassword */],
        variables: {
          email: email
        }, fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this6.$message({
          type: "success",
          message: data.data.recoverPassword.msg
        });
      });
    }
  }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__["a" /* default */]
  },
  mounted: function mounted() {
    var previousData = this.getPreviousData();
    this.fetchLastDate();
    if (previousData) {
      this.generalData = previousData;
      this.selectedClient = previousData.alias;
    }
  },

  computed: {
    advisorId: function advisorId() {
      return this.$store.getters.userInfo.id;
    },
    pickerOptions: function pickerOptions() {
      return {
        disabledDate: this.disabledDate
      };
    }
  },
  data: function data() {
    return {
      formRules: {
        alias: [{ required: true, message: 'Debes proporcionar un alias', trigger: 'blur' }, { max: 25, message: "El alias es demasiado largo", trigger: "blur" }],
        contract_number: [{ required: true, message: 'Debes proporcionar un número de contrato', trigger: 'blur' }],
        email: [{ required: false, type: 'email', message: 'Es necesario un email válido, ejemplo@email.com', trigger: 'blur' }],
        cutoff_date: [{ required: true, message: 'Debes proporcionar una fecha de corte', trigger: 'blur' }]
      },
      profileOptions: [{
        value: 'Básico',
        label: 'Básico'
      }, {
        value: 'Patrimonial',
        label: 'Patrimonial'
      }, {
        value: 'Balanceado',
        label: 'Balanceado'
      }, {
        value: 'Crecimiento',
        label: 'Crecimiento'
      }],
      generalData: {
        email: '',
        investor_profile: '',
        contract_number: '',
        cutoff_date: '',
        alias: '',
        clientId: 0
      },
      advisorClients: [],
      selectedClient: '',
      acceptedMinDate: ''
    };
  },

  watch: {
    selectedClient: function selectedClient(value) {
      if (value !== this.generalData.alias) {
        // Reset inputs if it is a new client
        this.generalData.email = '';
        this.generalData.clientId = 0;
      }
      this.generalData.alias = value;
    }
  },
  methods: {
    fetchLastDate: function fetchLastDate() {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_1__graphql__["q" /* getLastDataDate */],
        fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this.acceptedMinDate = data.data.getLastDataDate;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPreviousData: function getPreviousData() {
      return this.$store.getters.getGeneralData;
    },
    validateForm: function validateForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // New client case
          if (_this2.generalData.clientId === 0) {
            _this2.createNewClient();
          } else {
            _this2.goToNextStep();
          }
        } else {
          return false;
        }
      });
    },
    fetchClients: function fetchClients(inputQuery, callback) {
      var _this3 = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_1__graphql__["p" /* getClientsByAdvisor */],
        variables: {
          advisorId: this.advisorId
        },
        fetchPolicy: 'network-only'
      }).then(function (data) {
        return _this3.filterClientsByQuery(callback, data.data.clientsByAdvisor, inputQuery);
      }).catch(function (error) {
        console.log(error);
      });
    },
    filterClientsByQuery: function filterClientsByQuery(callback, clients, inputQuery) {
      this.advisorClients = clients;
      // Filter by input query
      var filteredClients = inputQuery ? clients.filter(function (client) {
        return client.alias.includes(inputQuery);
      }) : clients;
      // Callback function to return suggestions
      callback(filteredClients);
    },
    handleClientSelect: function handleClientSelect(client) {
      this.selectedClient = client.alias;
      this.generalData.alias = client.alias;
      this.generalData.clientId = parseInt(client.id);
      this.generalData.email = client.email;
    },
    createNewClient: function createNewClient(clientInfo) {
      var _this4 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__graphql__["d" /* createClient */],
        variables: {
          advisorId: this.advisorId,
          alias: this.generalData.alias,
          email: this.generalData.email
        }
      }).then(function (data) {
        if (data.data.createClient.returnCode === 2) {
          _this4.$message({
            type: 'error',
            message: 'Ya existe un cliente con este alias'
          });
        } else {
          _this4.generalData.clientId = parseInt(data.data.createClient.client.id);
          _this4.goToNextStep();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToNextStep: function goToNextStep() {
      // Primero guarda al store y luego redirige
      this.$store.dispatch('saveGeneralData', this.generalData).then(this.$router.push('registro-emisoras'));
    },
    disabledDate: function disabledDate(date) {
      var disableDate = new Date(this.acceptedMinDate);
      return date >= disableDate;
    }
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Breadcrumbs',
  mounted: function mounted() {
    this.sectionChanged();
  },

  props: {
    section: 0
  },
  data: function data() {
    return {};
  },

  watch: {
    section: 'sectionChanged'
  },
  methods: {
    // Podemos refactorizar esto más adelante
    // con clases dinámicas
    sectionChanged: function sectionChanged() {
      for (var i = 0; i < this.section; i++) {
        var element = '#numberCircle' + (i + 1);
        var node = document.querySelector(element);
        node.style.backgroundColor = '#4366DE';
        node.style.color = 'white';
        node.style.border = 'none';
      }
    }
  }
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__["a" /* default */]
  },
  data: function data() {
    return {
      currencyFormat: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      securitiesFormat: {
        thousands: ',',
        precision: 0,
        masked: false
      },
      percentageFormat: {
        thousands: ',',
        suffix: '%',
        precision: 0,
        masked: false
      },
      filteredAssets: [],
      NEExists: true,
      isLoading: false,
      assetClasses: [{
        label: '',
        options: []
      }, {
        label: '',
        options: [{
          id: 'defaultAll',
          name: 'Todos los mercados'
        }]
      }],
      assets: [],
      formRules: {
        totalAmount: [{ required: true, message: 'Debes ingresar un monto', trigger: 'focus' }, { validator: this.validateAmount,
          trigger: ["blur"]
        }]
      },
      totalInvestment: '',
      showPercentageError: false,
      showDuplicateAssetError: false,
      showNoResultsError: false,
      showCreatingNE: false,
      investmentData: {
        assetClass: 'defaultAll',
        assetClassLabel: '',
        idAsset: '',
        assetLabel: '',
        totalSecurities: '',
        price_of_note: '',
        totalAmount: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$apollo.query({ query: __WEBPACK_IMPORTED_MODULE_1__graphql__["m" /* getAssetClasses */], fetchPolicy: 'cache-first' }).then(function (data) {
      _this.assetClasses[0].options = data.data.allAssetClasses;
    });
    this.totalInvestment = this.$store.getters.getTotalInvestmentAmount || '';
  },

  watch: {
    assets: function assets(value) {
      // Reset select values when getting new list of assets
      this.filteredAssets = value;
    },
    totalPortfolioInvestment: function totalPortfolioInvestment(value) {
      this.totalInvestment = value;
    }
  },
  computed: {
    currentInvestments: function currentInvestments() {
      return this.$store.getters.getTransmitersData;
    },
    currentCuttoffDate: function currentCuttoffDate() {
      return this.$store.getters.getGeneralData.cutoff_date;
    },
    isNEAssetClass: function isNEAssetClass() {
      return this.investmentData.assetClass === '6';
    },
    usePercentageForm: function usePercentageForm() {
      return this.$store.getters.getFormValueTypes;
    }
  },
  methods: {
    fetchInvestments: function fetchInvestments(query, callback) {
      var _this2 = this;

      this.showNoResultsError = false;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_1__graphql__["n" /* getAssets */],
        variables: {
          cuttofDate: this.currentCuttoffDate,
          startsWith: query,
          idAssetClass: this.investmentData.assetClass !== 'defaultAll' ? this.investmentData.assetClass : undefined
        },
        fetchPolicy: 'network-only'
      }).then(function (data) {
        var results = data.data.allAssets;
        if (results.length !== 0) {
          _this2.assets = data.data.allAssets;
        } else if (results.length === 0 && _this2.isNEAssetClass) {
          _this2.NEExists = false;
          _this2.showCreatingNE = true;
        } else {
          _this2.showNoResultsError = true;
        }
        callback(results);
      });
    },
    handleInvestmentSelect: function handleInvestmentSelect(investment) {
      this.investmentData.idAsset = investment.id;
      this.investmentData.assetLabel = investment.name;
      this.investmentData.assetClassLabel = investment.assetClass.name;
      this.investmentData.price_of_note = investment.price;
      if (this.investmentData.totalSecurities) {
        this.getTotalAmount();
      }
    },
    goToConfirmation: function goToConfirmation() {
      if (this.usePercentageForm) {
        this.showPercentageError = true;
        this.validatePercentageForm(this.currentInvestments);
      } else {
        this.$router.push('/registro-confirmacion');
      }
    },
    validatePercentageForm: function validatePercentageForm(investments) {
      var totalPercentage = 0;
      for (var index in investments) {
        totalPercentage += investments[index].totalSecurities;
      }
      if (totalPercentage === 100) {
        this.$router.push('/registro-confirmacion');
      } else {
        this.showPercentageError = true;
      }
    },
    togglePercentage: function togglePercentage() {
      if (this.currentInvestments.length === 0) {
        this.$store.dispatch('setPercentageBasedForm', !this.usePercentageForm);
        this.investmentData.totalSecurities = '';
        this.investmentData.totalAmount = '';
      }
    },
    validateAmount: function validateAmount(rule, value, callback) {
      var amount = parseFloat(value);
      if (amount <= 0) {
        callback(new Error("El monto debe ser mayor a 0"));
      } else if (amount > 0) {
        callback();
      }
    },
    clearAssets: function clearAssets(id) {
      this.assets = [];
      this.showNoResultsError = false;
      this.showCreatingNE = false;
      // Clear if there was any asset already selected
      this.investmentData.idAsset = '';
      this.investmentData.assetLabel = '';
      this.investmentData.totalSecurities = '';
      this.investmentData.price_of_note = '';
      this.investmentData.totalAmount = '';
      this.$refs['investmentData'].clearValidate();
    },
    getAssetInfo: function getAssetInfo(id) {
      var asset = this.assets.filter(function (asset) {
        return asset.id === id;
      });
      this.NEExists = asset.length === 1;
      if (!this.isNEAssetClass || this.NEExists) {
        this.investmentData.assetLabel = asset[0].name;
        this.investmentData.assetClassLabel = asset[0].assetClass.name;
        this.investmentData.price_of_note = asset[0].price;
        if (this.investmentData.totalSecurities) {
          this.getTotalAmount();
        }
      }
    },
    parseValues: function parseValues(data) {
      var idAsset = data.idAsset !== '' ? parseInt(data.idAsset) : 0;
      var totalSecurities = data.totalSecurities !== '' ? parseFloat(data.totalSecurities) : 0;
      var totalAmount = data.totalAmount !== '' ? parseFloat(data.totalAmount) : 0;
      return {
        assetClass: data.assetClass,
        assetClassLabel: data.assetClassLabel,
        idAsset: idAsset,
        assetLabel: data.assetLabel,
        totalSecurities: totalSecurities,
        price_of_note: data.price_of_note,
        totalAmount: totalAmount
      };
    },
    validateAsset: function validateAsset(form) {
      var _this3 = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          var isDuplicateAsset = _this3.validateNoDuplicateInvestment(_this3.investmentData.idAsset);
          if (isDuplicateAsset) {
            _this3.showDuplicateAssetError = true;
          } else {
            var parsedValues = _this3.parseValues(_this3.investmentData);
            _this3.addAssetToList(parsedValues);
          }
        } else {
          return false;
        }
      });
    },
    validateNoDuplicateInvestment: function validateNoDuplicateInvestment(id) {
      var result = this.currentInvestments.filter(function (investment) {
        return investment.idAsset == id;
      });
      var isDuplicateAsset = result.length > 0;
      return isDuplicateAsset;
    },
    addAssetToList: function addAssetToList(data) {
      this.$store.dispatch('setTotalInvestment', this.totalInvestment);
      if (!this.isNEAssetClass || this.NEExists) {
        this.$store.dispatch('saveInvestment', data).then(this.$refs['investmentData'].resetFields());
      } else {
        // If its a non registred NE asset it will be created
        this.createAsset();
      }
    },

    // Use to create - Notas Estructuradas investments
    createAsset: function createAsset() {
      var _this4 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* addAsset */],
        variables: {
          name: this.investmentData.assetLabel,
          assetClassId: 6,
          price: parseFloat(this.investmentData.price_of_note),
          period: this.currentCuttoffDate
        }
      }).then(function (data) {
        return _this4.createAssetSuccess(data.data.createAsset.asset);
      }).catch(function (error) {
        _this4.$message({
          type: 'error',
          message: 'Ocurrió un error, intenta más tarde'
        });
      });
    },
    createAssetSuccess: function createAssetSuccess(data) {
      var investment = {
        assetClass: data.assetClass.id,
        assetClassLabel: data.assetClass.name,
        idAsset: parseInt(data.id),
        assetLabel: data.name,
        totalSecurities: parseFloat(this.investmentData.totalSecurities),
        price_of_note: data.price,
        totalAmount: parseFloat(this.investmentData.totalAmount)
      };
      this.$store.dispatch('saveInvestment', investment).then(this.$refs['investmentData'].resetFields());
    },
    _deleteAsset: function _deleteAsset(assetIndex) {
      var _this5 = this;

      this.$confirm('Desea eliminar esta emisora. Continuar?', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this5.$store.dispatch('deleteInvestment', assetIndex);
        _this5.$message({
          type: 'success',
          message: 'Emisora eliminada'
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: 'Eliminación cancelada'
        });
      });
    },

    // We use this method to call a getter that will get the data from a state
    getPreviousData: function getPreviousData() {
      return this.$store.getters.getTransmitersData;
    },
    getTotalAmount: function getTotalAmount() {
      var amount = parseInt(this.investmentData.totalSecurities);
      // Percentage based investment registry
      if (this.usePercentageForm && amount) {
        var total = this.totalInvestment;
        var percentage = amount / 100;
        this.investmentData.totalAmount = percentage * total / 1;
        // Total securities based investment registry
      } else {
        if (this.investmentData.price_of_note && this.investmentData.totalSecurities) {
          this.investmentData.totalAmount = this.investmentData.price_of_note * amount;
        } else {
          this.investmentData.totalAmount = '';
        }
      }
    },
    getSecurities: function getSecurities() {
      var amount = parseFloat(this.investmentData.totalAmount);
      // Percentage based investment registry
      if (this.usePercentageForm) {
        console.log('por %');
        // Total securities based investment registry
      } else {
        if (this.investmentData.price_of_note && this.investmentData.totalAmount) {
          this.investmentData.totalSecurities = amount / this.investmentData.price_of_note;
        } else {
          this.investmentData.totalSecurities = '';
        }
      }
    },
    getTotalAmountAndSecurities: function getTotalAmountAndSecurities() {
      var price = parseFloat(this.investmentData.price_of_note);
      // Total securities based investment registry
      if (!this.usePercentageForm) {
        if (this.investmentData.totalSecurities) {
          this.investmentData.totalAmount = price * this.investmentData.totalSecurities;
        } else if (this.investmentData.totalAmount) {
          this.investmentData.totalSecurities = this.investmentData.totalAmount / price;
        }
      }
    },
    formatPrice: function formatPrice(price) {
      return price % 1 !== 0 ? '$' + price.toFixed(2).toLocaleString() : '$' + price.toLocaleString();
    },
    formatSecurities: function formatSecurities(amount) {
      if (this.usePercentageForm) {
        return amount % 1 !== 0 ? amount.toFixed(2) + '%' : amount + '%';
      } else {
        return amount % 1 !== 0 ? amount.toFixed(2).toLocaleString() : amount.toLocaleString();
      }
    }
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__["a" /* default */]
  },
  data: function data() {
    return {
      formattedData: [],
      showAddCommentInput: false,
      displayCommentSection: false,
      advisorComment: '',
      comment: '',
      bType: 1
    };
  },
  mounted: function mounted() {
    if (this.formMode !== 1 && this.$store.getters.getAdvisorComment) {
      this.comment = this.$store.getters.getAdvisorComment;
      this.displayCommentSection = true;
    }
  },

  computed: {
    currentPortfolioId: function currentPortfolioId() {
      return this.$store.getters.getSelectedPortfolio;
    },
    formMode: function formMode() {
      return this.$store.getters.getFormMode;
    },
    currentInvestments: function currentInvestments() {
      return this.$store.getters.getTransmitersData;
    },
    advisorId: function advisorId() {
      return parseInt(this.$store.getters.userInfo.id);
    },
    generalData: function generalData() {
      return this.$store.getters.getGeneralData;
    },
    percentageBasedPortfolio: function percentageBasedPortfolio() {
      return this.$store.getters.getFormValueTypes;
    }
  },
  methods: {
    displayCommentInput: function displayCommentInput() {
      this.showAddCommentInput = true;
    },
    addComment: function addComment() {
      this.showAddCommentInput = false;
      this.advisorComment = this.comment;
      this.displayCommentSection = true;
    },
    deleteComment: function deleteComment() {
      this.comment = '';
      this.advisorComment = '';
      this.displayCommentSection = false;
    },
    formatPrice: function formatPrice(price) {
      return price % 1 !== 0 ? '$' + price.toFixed(2).toLocaleString() : '$' + price.toLocaleString();
    },
    formatSecurities: function formatSecurities(amount) {
      if (this.percentageBasedPortfolio) {
        return amount % 1 !== 0 ? amount.toFixed(2) + '%' : amount + '%';
      } else {
        return amount % 1 !== 0 ? amount.toFixed(2).toLocaleString() : amount.toLocaleString();
      }
    },
    _deleteAsset: function _deleteAsset(assetIndex) {
      var _this = this;

      this.$confirm('Desea eliminar esta emisora. Continuar?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch('deleteInvestment', assetIndex);
        _this.$message({
          type: 'success',
          message: 'Eliminación completada'
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: 'Eliminación cancelada'
        });
      });
    },
    submitPortfolio: function submitPortfolio(bType) {
      var _this2 = this;

      this.formatData(this.currentInvestments);
      this.bType = bType;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__graphql__["e" /* createPortfolio */],
        variables: {
          advisorId: this.advisorId,
          cuttofDate: this.generalData.cutoff_date,
          clientId: this.generalData.clientId,
          contractNumber: this.generalData.contract_number,
          investments: this.formattedData,
          advisorComment: this.advisorComment,
          mode: this.formMode,
          bType: this.bType,
          portfolioId: this.currentPortfolioId ? parseInt(this.currentPortfolioId) : undefined
        }
      }).then(function (data) {
        return _this2.requestSuccess(data.data.createPortfolio);
      }).catch(function () {
        _this2.$message({
          type: 'error',
          message: 'Ocurrió un error intenta más tarde'
        });
      });
    },
    requestSuccess: function requestSuccess(data) {
      this.$store.dispatch('resetPortfolioForm');
      if (this.bType === 2) {
        this.$router.push('/analisis-portafolio/' + data.portfolio.id);
      } else {
        this.$router.push('/lista-de-analisis');
      }
    },
    formatData: function formatData(data) {
      var _this3 = this;

      var cleanData = [];
      var asset = {};
      data.map(function (investment) {
        if (_this3.percentageBasedPortfolio) {
          asset = {
            idAsset: investment.idAsset,
            totalAmount: investment.totalAmount
          };
        } else {
          asset = {
            idAsset: investment.idAsset,
            totalAmount: investment.totalAmount,
            totalSecurities: investment.totalSecurities
          };
        }
        cleanData.push(asset);
      });
      this.formattedData = cleanData;
    }
  }
});

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VerticalTableData__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__marketGrade__ = __webpack_require__(1308);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    barChartComponent: __WEBPACK_IMPORTED_MODULE_0__BarChart__["a" /* default */],
    tableComponent: __WEBPACK_IMPORTED_MODULE_1__TableData__["a" /* default */],
    donnutChartSection: __WEBPACK_IMPORTED_MODULE_2__DonnutChartSection__["a" /* default */],
    verticalTableComponent: __WEBPACK_IMPORTED_MODULE_3__VerticalTableData__["a" /* default */],
    verticalTableComponent2: __WEBPACK_IMPORTED_MODULE_4__VerticalTableData2__["a" /* default */],
    specialSlider: __WEBPACK_IMPORTED_MODULE_5__SpecialSlider__["a" /* default */],
    marketGrade: __WEBPACK_IMPORTED_MODULE_6__marketGrade__["a" /* default */]
  },
  data: function data() {
    return {
      new_color: "red",
      new_color_two: "#001F5C",
      new_color_three: "#FFB25D",
      uniColor: {
        name: "Estructurados",
        color: "#F48073"
      },
      data: {
        tittle: "Comparativo benchmark del mercado",
        dates: ["Rto.2015", "Rto.2016", "Rto.Acum.2017", "Rto.Acum.2015-17"],
        trace1: {
          name: "Fondos RV",
          data: [-0.2, 0.14, 0.23, 0.5]
        },
        trace2: {
          name: "Benchmark",
          data: [-0.6, 0.18, 0.275589, 1]
        }
      },
      tableData: {
        titles: [{
          prop: "name",
          label: "Nombre"
        }, {
          prop: "mail",
          label: "Correo electrónico"
        }, {
          prop: "percentage",
          label: "Ejemplo Porcentage"
        }],
        data: [{
          name: "Hector Ivan Patricio",
          mail: "hectorivan@hal.com.mx.co",
          percentage: 0.1
        }, {
          name: "David Gonzáles",
          mail: "david@hal.com.mx.co",
          percentage: 0.10
        }, {
          name: "Grecia de Hal",
          mail: "gracias@hal.com.mx.co",
          percentage: 0.0100
        }]
      },
      donnutChartData: {
        data: [0.1, 0.2, 0.3, 0.4, 0.6],
        labels: ["Estructurados", "Deuda", "Capitales", "Fondos RF", "Fondos RV"],
        titles: [{
          name: "Estructurados",
          percentage: 0.03445,
          amount: 5330.5
        }, {
          name: "Deuda",
          percentage: 0.3254,
          amount: 3330.5
        }, {
          name: "Capitales",
          percentage: 1,
          amount: 3330.5
        }, {
          name: "Fondos RF",
          percentage: 0.6255,
          amount: 3330.5
        }, {
          name: "Fondos RV",
          percentage: 0.902,
          amount: 3330.5
        }]
      },
      sliderData: {
        // value: 0.1,
        items: [{
          percentage: 0.5,
          name: "CCC"
        }, {
          percentage: 0.4869,
          name: "B"
        }, {
          percentage: 0.1385,
          name: "BB"
        }, {
          percentage: 0,
          name: "BBB"
        }, {
          percentage: 0,
          name: "A"
        }, {
          percentage: 0.375,
          name: "AA"
        }, {
          percentage: 0,
          name: "AAA"
        }]
      },
      tableData2: {
        titles: [{
          prop: "tipo",
          label: "Tipo"
        }],
        data: [{
          tipo: "Hector Ivan Patricio",
          percentage: 0.72
        }, {
          tipo: "David Gonzáles",
          percentage: 0.5
        }, {
          tipo: "Grecia de Hal",
          percentage: 0.1
        }],
        percentage: true
      },
      tableDataHorizontal: [{
        name: "Rendimientos acum. 2017",
        value: -0.151489
      }, {
        name: "Comisiones",
        value: 0.1 // 0.551489
      }],
      tableData3: {
        titles: [],
        data: [{
          name: "MATERIALES",
          percentage: 0.72
        }, {
          name: "DERIVADO",
          percentage: 0.5
        }, {
          name: "SALUD",
          percentage: 0.1
        }, {
          name: "MATERIALES",
          percentage: 1
        }, {
          name: "MATERIALES",
          percentage: 0.1
        }],
        distributionPerSector: true
      },
      tableData4: {
        titles: [{
          prop: "emisora",
          label: "Emisora"
        }],
        titles2: [{
          prop: "price",
          label: "Precio"
        }, {
          prop: "amount",
          label: "Monto"
        }],
        data: [{
          emisora: "BONDESD 201224",
          percentage: 0.72,
          price: 99.69,
          amount: 535582.72,
          securities: 10,
          assetType: "Tipo de emisor",
          rateType: "Tasa Variable",
          score: "EJEMPLO1",
          sliderValue: { value: 1 }
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.5,
          price: 99.69,
          amount: 535582.72,
          securities: 60,
          assetType: "Tipo de emisor",
          rateType: "Tasa Variable",
          score: "EJEMPLO2",
          sliderValue: { value: 0.112321 }
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.1,
          price: 99.69,
          amount: 12,
          securities: 20,
          assetType: "Tipo de emisor",
          rateType: "Tasa Variable",
          score: "EJEMPLO3",
          sliderValue: { value: 0.9 }
        }],
        percentage: true,
        extraData: true
      },
      donnutChartData2: {
        data: [0.1987123, 0.2, 0.3, 0.11, 0.2],
        labels: ["Estructurados", "Deuda", "Capitales", "Fondos RF", "Fondos RV"],
        titles: [{
          name: "Estructurados",
          percentage: 0.1987123,
          amount: 5330.99
        }, {
          name: "Deuda",
          percentage: 0.2,
          amount: 3330.5
        }, {
          name: "Capitales",
          percentage: 0.3,
          amount: 3330.5
        }, {
          name: "Fondos RF",
          percentage: 0.11,
          amount: 3330.5
        }, {
          name: "Fondos RV",
          percentage: 0.2,
          amount: 3330.5
        }]
      },
      tableData5: {
        titles: [{
          prop: "emisora",
          label: "Emisora"
        }],
        titles2: [{
          prop: "price",
          label: "Precio"
        }, {
          prop: "amount",
          label: "Monto"
        }],
        data: [{
          emisora: "BONDESD 201224",
          percentage: 0.72,
          price: 99.69,
          amount: 535582.72,
          /* Hidden Data */
          securities: 1743876,
          completeName: "Grupo Aeroportuario del sureste S.A.",
          assetType: "Acciones Domésticas",
          sector: "Industrial",
          bursatility: "NA"
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.5,
          price: 99.69,
          amount: 535582.72,
          /* Hidden Data */
          securities: 1743876,
          completeName: "Grupo Aeroportuario del sureste S.A.",
          assetType: "Acciones Domésticas",
          sector: "Industrial",
          bursatility: "SIN BURSATILIDAD"
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.1,
          price: 99.69,
          amount: 535582.72,
          /* Hidden Data */
          securities: 1743876,
          completeName: "Grupo Aeroportuario del sureste S.A.",
          assetType: "Acciones Domésticas",
          sector: "Industrial",
          bursatility: "ALTA"
        }, {
          emisora: "BONDESD 201227",
          percentage: 0.1,
          price: 99.01,
          amount: 535542.72,
          /* Hidden Data */
          securities: 1743876,
          completeName: "Grupo Aeroportuario del sureste S.A.",
          assetType: "Acciones Domésticas",
          sector: "Industrial",
          bursatility: "MEDIA"
        }],
        percentage: true,
        extraDataTwo: true
      },
      tableData6: {
        titles: [{
          prop: "emisora",
          label: "Emisora"
        }],
        titles2: [{
          prop: "amount",
          label: "Monto"
        }, {
          prop: "rtoAcom_2015_2017",
          label: "Rto Acom. 2015-2017"
        }, {
          prop: "comisiones",
          label: "Comisiones"
        }],
        data: [{
          emisora: "BONDESD 201224",
          percentage: 0.72,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1256,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.5,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1289,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }, {
          emisora: "BONDESD 201224",
          percentage: 0.1,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1256,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }],
        percentage: true,
        extraDataThree: true
      },
      marketGrade: {
        titles: [{
          prop: "grade",
          label: "Calificación"
        }],
        titles2: [{
          prop: "percentage",
          label: "%"
        }, {
          prop: "color"
        }],
        data: [{
          grade: "mxAAA",
          percentage: 0.425477,
          color: "red"
        }, {
          grade: "mxAA+",
          percentage: 0.45,
          color: "blue"
        }, {
          grade: "mxAA",
          percentage: 0.12,
          color: "yellow"
        }]
      },
      tableData7: {
        titles: [{
          prop: "emisora",
          label: "Emisora"
        }, {
          prop: "mercado",
          label: "Mercado"
        }],
        titles2: [],
        data: [{
          emisora: "BONDESD 201224",
          color: "green",
          mercado: "Mercado uno",
          percentage: 0.72,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1256,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }, {
          emisora: "BONDESD 201224",
          color: "yellow",
          mercado: "Mercado dos",
          percentage: 0.5,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1289,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }, {
          emisora: "BONDESD 201224",
          color: "red",
          mercado: "Mercado tres",
          percentage: 0.1,
          amount: 535582.72,
          rtoAcom_2015_2017: 0.1256,
          comisiones: 0.1256,
          /* Hidden Data */
          securities: 1743876,
          price: 8.83,
          score: "AAA",
          instrumentComposition: [{
            name: "instrumento1",
            inversionType: "inversionType1",
            percentage: 0.4582
          }, {
            name: "instrumento2",
            inversionType: "inversionType2",
            percentage: 0.4582
          }, {
            name: "instrumento3",
            inversionType: "inversionType3",
            percentage: 0.4582
          }]
        }],
        percentage: true,
        extraDataThree: true
      }
    };
  },

  computed: {},
  watch: {},
  methods: {}
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plotly_js_lib_index_basic__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plotly_js_lib_index_basic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_plotly_js_lib_index_basic__);
//
//
//
//
//
//
//
//


var layout = {
  // showlegend: false,
  hovermode: false,
  autosize: false,
  width: 768,
  height: 400,
  bargap: 0.3,
  bargroupgap: 0.3,
  type: 'bar',
  legend: {
    x: 0.8,
    y: 100,
    traceorder: 'normal',
    bgcolor: 'white'
  },
  margin: {
    l: 100, r: 100, b: 50, t: 50, pad: 0, autoexpand: true
  },
  font: {
    size: 10
  },
  title: '',
  size: '0.5',
  paper_bgcolor: 'white',
  plot_bgcolor: 'white',
  ticks: '',
  yaxis: {
    fixedrange: true,
    showticklabels: false,
    scaleratio: 1,
    tickformat: ',.0%',
    range: [-0.72, 0.71]
  },
  xaxis: {
    fixedrange: true
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BarChartComponent',
  props: {
    graph_data: Object,
    assetClassColor: String
  },
  data: function data() {
    return {
      title: String,
      yValue: [],
      trace1: { x: [], y: [], text: [],
        textposition: 'outside',
        name: '',
        type: 'bar',
        marker: {
          color: '#FFB54F'
        }
      },
      trace2: { x: [], y: [], text: [],
        textposition: 'outside',
        name: 'Benchmark',
        type: 'bar',
        marker: {
          color: '#B7B7B7'
        }
      }
    };
  },

  computed: {
    output: function output() {
      return [this.trace1, this.trace2];
    }
  },
  watch: {
    graph_data: function graph_data(value) {
      this.data = this.graph_data;
      this.title = this.graph_data.tittle, this.trace1.marker.color = this.assetClassColor;
      this.transformData(this.trace1, this.data.trace1);
      this.transformData(this.trace2, this.data.trace2);
      this.displayGraph();
    }
  },
  methods: {
    transformData: function transformData(key, trace) {
      key.y = trace.data;
      key.text = this.transformTopercentage(trace.data);
      key.x = this.data.dates;
      key.name = trace.name;
    },
    transformTopercentage: function transformTopercentage(data) {
      return data.map(function (d) {
        // num is multiplied for 1000 an the divided between 10 to aviod js bugs
        var num = d * 1000 / 10;
        if (num % 1 != 0) {
          num = num.toFixed(2);
        }
        return num + '%';
      });
    },
    displayGraph: function displayGraph() {
      var container = document.getElementById('tester-' + this.graph_data.trace1.name);
      __WEBPACK_IMPORTED_MODULE_0_plotly_js_lib_index_basic___default.a.newPlot(container, this.output, layout, { displayModeBar: false });
    }
  }
});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentsSection_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488669ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentsSection_vue__ = __webpack_require__(1320);
function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-488669ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488669ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioFooter_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5faf6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioFooter_vue__ = __webpack_require__(1322);
function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca5faf6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5faf6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PercentageBar__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LevelsIndicator__ = __webpack_require__(1286);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    percentageBar: __WEBPACK_IMPORTED_MODULE_1__PercentageBar__["a" /* default */],
    specialSlider: __WEBPACK_IMPORTED_MODULE_2__SpecialSlider__["a" /* default */],
    levelsIndicator: __WEBPACK_IMPORTED_MODULE_3__LevelsIndicator__["a" /* default */]
  },
  props: {
    graph_data: Object,
    percentage_color: String,
    show_percentage_measurer: false,
    currentAssetClass: "",
    isClickable: false,
    displayExpanded: false,
    printableVersion: false
  },
  watch: {
    graph_data: function graph_data(value) {
      this.tableData = value.data;
      this.titles = value.titles;
      if (value.percentage || value.distributionPerSector) {
        this.showSubtotal = true;
      }
      if (value.displayTotalLabel) {
        this.percentageLabel = 'Total';
      }
      this.arragePercentageBar();
    }
  },
  methods: {
    goAsssetDetail: function goAsssetDetail(row, column, cell, event) {
      if (this.isClickable) {
        var assetName = row.assetName;
        var portfolioId = this.$route.params.id;
        var routeName = "AssetDetail_" + this.currentAssetClass;
        this.$router.push({
          name: routeName,
          params: { id: portfolioId, assetName: assetName }
        });
      }
    },
    arragePercentageBar: function arragePercentageBar() {
      var self = this;
      setTimeout(function () {
        var node = self.$refs.percentageBar;
        if (!node || node == undefined) {
          return;
        }
        var nodeSize = node.$el.querySelector("#mainBar");
        if (self.showSubtotalPercentages) {
          self.$refs.percentage_nodes.style.width = nodeSize.offsetWidth + "px";
        }

        var position = nodeSize.getBoundingClientRect().left;
        var mainNode = self.$refs.main.getBoundingClientRect().left;
        var finalPosition = position - mainNode;
        if (self.showSubtotalPercentages) {
          self.$refs.percentage_nodes.style.left = finalPosition + 11 + "px";
          self.$refs.percentage_nodes.querySelector("li").firstChild.innerHTML = "0";
        }
      }, 100);
    },
    hideText: function hideText() {
      this.$refs.BursatibilityText.style.display = "none";
    },
    modifyClass: function modifyClass(object, keyValue) {
      var value = object[keyValue];
      var valueType = typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
      if (valueType == "number") {
        if (value < 0) {
          return "red-text";
        }
      }
    },
    modifyData: function modifyData(object, keyValue) {
      var value = object[keyValue];
      if (value) {
        if (keyValue == "price" || keyValue == "amount" || keyValue == "currentPrice" || keyValue == "initialPrice") {
          value = "$" + value.toLocaleString();
        } else if (keyValue.includes("Yield") || keyValue == "commission" || keyValue.includes("year") || keyValue == "percentage") {
          value = value * 1000 / 10;
          if (value % 1 !== 0) {
            var num = value;
            num = num.toFixed(2);
            value = Number(num);
            value = value.toFixed(2) + "%";
          } else {
            value = value.toFixed(2) + "%";
          }
        }
        return value;
      }
    },
    modifyPrecio: function modifyPrecio(keyValue) {
      return "$" + keyValue.toLocaleString();
    },
    modifyTitulos: function modifyTitulos(keyValue) {
      return keyValue.toLocaleString();
    },
    modifyPercentage: function modifyPercentage(keyValue) {
      keyValue = keyValue * 1000 / 10;
      if (keyValue % 1 != 0) {
        var num = keyValue;
        num = num.toFixed(2);
        keyValue = Number(num);
      }
      return keyValue.toFixed(2) + "%";
    }
  },
  mounted: function mounted() {
    this.tableData = this.graph_data.data;
    this.titles = this.graph_data.titles;
    this.titles2 = this.graph_data.titles2;
    if (this.percentage_color != undefined) {
      this.new_color = this.percentage_color;
    }
    if (this.graph_data.percentage || this.graph_data.distributionPerSector) {
      this.showSubtotal = true;
    }
    if (this.show_percentage_measurer == true) {
      this.showSubtotalPercentages = true;
    }
    if (this.graph_data.distributionPerSector) {
      this.distribution_styles = true;
      this.tableData = this.graph_data.data;
      this.subtotalWidth = 160;
    }
    if (this.graph_data.extraData) {
      this.showExtraData = true;
    }
    if (this.graph_data.extraDataTwo) {
      this.showExtraDataTwo = true;
    }
    if (this.graph_data.extraDataThree) {
      this.showExtraDataThree = true;
      this.ceropadding = true;
    }
    if (this.printableVersion == true) {
      this.printVersion = true;
    }

    this.arragePercentageBar();
  },
  data: function data() {
    return {
      printVersion: false,
      red: true,
      new_color: String,
      showSubtotal: false,
      showExtraData: false,
      showExtraDataTwo: false,
      showExtraDataThree: false,
      distribution_styles: false,
      showSubtotalPercentages: false,
      ceropadding: false,
      subtotalWidth: 0,
      tableData: [],
      titles: [],
      titles2: [],
      percentageLabel: '% Subtotal',
      imageX: "static/open-arrow.svg",
      percentages: ["25%", "50%", "75%", "100%"],
      sliderData: {
        value: 0.1,
        items: [{
          percentage: "0%",
          name: "CCC"
        }, {
          percentage: "0%",
          name: "B"
        }, {
          percentage: "0%",
          name: "BB"
        }, {
          percentage: "0%",
          name: "BBB"
        }, {
          percentage: "0%",
          name: "A"
        }, {
          percentage: "0%",
          name: "AA"
        }, {
          percentage: "100%",
          name: "AAA"
        }]
      }
    };
  },

  computed: {}
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PercentageBar_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053d332a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PercentageBar_vue__ = __webpack_require__(1279);
function injectStyle (ssrContext) {
  __webpack_require__(1278)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-053d332a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PercentageBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053d332a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PercentageBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Number,
    secondColor: "",
    thirdColor: ""
  },
  data: function data() {
    return {
      dataOne: Number,
      anotherColor: false
    };
  },

  computed: {
    formattedPercentage: function formattedPercentage() {
      var amount = this.dataOne * 100;
      if (amount % 1 !== 0) {
        return amount.toFixed(2);
      } else {
        return amount;
      }
    }
  },
  watch: {
    dataOne: "printData",
    data: function data(value) {
      this.dataOne = value;
    }
  },
  methods: {
    printData: function printData() {
      this.$refs.percentage.style.width = this.dataOne * 100 + "%";
    }
  },
  beforeMount: function beforeMount() {
    this.dataOne = this.data;
  },
  mounted: function mounted() {
    if (this.secondColor != undefined) {
      this.anotherColor = this.secondColor;
      // this.$refs.percentage.style.backgroundColor = this.anotherColor;
    }
    if (this.thirdColor != undefined) {
      //console.log(this.thirdColor);
      this.anotherColor = this.thirdColor;
    }
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    graph_data: {},
    calification_name: String,
    smallThermometer: false
  },
  data: function data() {
    return {
      value: 0,
      internal_calification_name: String,
      hideButton: false,
      items: [],
      colors: ["#C14027", "#EA805A", "#EA8E5A", "#FBBF8F", "#BBD89B", "#94C75A", "#60A114"]
    };
  },

  computed: {},
  watch: {
    value: "changeColor"
  },
  methods: {
    updateComponent: function updateComponent() {
      // if the is no data at all don´t display anything
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.graph_data).length < 1) {
        this.$el.style.display = "none";
        console.log("Don´t display the special slider");
      }
      // Show the button data if there is data for the button
      if (this.graph_data.value) {
        this.value = this.graph_data.value * 1000 / 10;
      }
      // Hide the button is there is no data for the button
      if (!this.graph_data.value) {
        this.hideButton = true;
      }
      // Modify the button value to a percentage version
      var num = this.value;
      if (num % 1 != 0) {
        num = num.toFixed(2);
        this.value = Number(num);
      }
      // Assign the data of the ul v-for data
      this.items = this.graph_data.items;
    },
    changeColor: function changeColor() {
      var button = this.$refs.slider.$el.querySelector(".el-slider__button");
      var section = Math.floor((this.value - 1) / 14);
      if (this.value > 80) {
        section = Math.floor((this.value - 2) / 14);
      }
      if (section == -1) {
        section = 0;
      }
      if (section >= 6) {
        section = 6;
      }
      button.style.backgroundColor = this.colors[section];
      var valueText = this.$refs.valueText;
      if (valueText) {
        valueText.style.color = this.colors[section];
      }
    },
    modifyPercentage: function modifyPercentage(keyValue) {
      keyValue = keyValue * 1000 / 10;
      if (keyValue % 1 != 0) {
        var num = keyValue;
        num = num.toFixed(2);
        keyValue = Number(num);
      }
      return keyValue + "%";
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    this.updateComponent();
    if (this.smallThermometer) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.graph_data).length < 1) {
        console.log(this.$el.parentElement.parentElement.querySelector(".specialSliderTittle"));
        var tittle = this.$el.parentElement.parentElement.querySelector(".specialSliderTittle");
        tittle.style.display = "none";
      }
      this.$refs.slider.$el.style.width = "360px";
      this.$refs.slider.$el.querySelector(".el-slider__runway").style.margin = "0px";
      this.$refs.slider.$el.querySelector(".el-slider__runway").style.height = "6px";
      this.$refs.specialSlider.style.margin = "0px";
      this.internal_calification_name = this.calification_name;
      var special_letter_container = this.$refs.specialLetterContainer;
      special_letter_container.style.left = this.value + "%";
    }
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Imports are written here */
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    graph_data: String
  },
  data: function data() {
    return {
      selected: String,
      selectedFirst: false,
      selectedSecond: false,
      selectedThird: false,
      selectedFourth: false,
      dinamicText: "",
      drawText: ["MEDIA", "BAJA", "MINIMA", "NULA"]
    };
  },

  computed: {},
  watch: {
    graph_data: "updateComponent",
    selected: "updateComponent"
  },
  methods: {
    updateComponent: function updateComponent() {
      this.selected = this.graph_data;
      this.drawSelection();
    },
    cleanCircles: function cleanCircles() {
      this.selectedFirst = false;
      this.selectedSecond = false;
      this.selectedThird = false;
    },
    drawSelection: function drawSelection() {
      if (this.selected == "NA") {
        this.$refs.levels_indicator.style.display = "none";
        this.$emit("hideText");
      } else if (this.selected == "SIN BURSATILIDAD") {
        this.selectedFirst = true;
      } else if (this.selected == "ALTA") {
        this.selectedThird = true;
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.drawText), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var element = _step.value;

            if (this.selected == element) {
              this.selectedSecond = true;
              this.dinamicText = element.toUpperCase();;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    this.updateComponent();
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DonnutChartD3__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfoListDonnut__ = __webpack_require__(1298);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetAllocationSection",
  components: {
    donnutComponentD3: __WEBPACK_IMPORTED_MODULE_0__DonnutChartD3__["a" /* default */],
    donnutInfo: __WEBPACK_IMPORTED_MODULE_1__InfoListDonnut__["a" /* default */]
  },
  props: {
    printableVersion: false,
    uniColor: {},
    donnutData: Array,
    infoData: Array,
    donnutLabels: Array,
    colors: Array
  },
  mounted: function mounted() {
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false
    };
  }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dataEntry: Array,
    labelsEntry: Array,
    uni_color: Object,
    colors: Array
  },
  data: function data() {
    return {
      personalColor: {},
      drawed: false,
      selectedAssetIndex: 0
    };
  },
  mounted: function mounted() {
    // If the uni_color object was send them we will draw our donut differently
    // if (this.uni_color != undefined) {
    //   this.personalColor = this.uni_color;
    //   this.colorPosition = this.labels.indexOf(this.personalColor.name);
    // }
  },

  watch: {
    dataEntry: "draw"
  },
  methods: {
    clickCallback: function clickCallback(d, i) {
      var assetClass = this.labelsEntry[i].replace(/\s+/g, '').toLowerCase();
      this.$router.push("/analisis-portafolio/" + this.$route.params.id + "/mercado/" + assetClass);
    },
    draw: function draw() {
      if (this.drawed) {
        return;
      }
      var dataset = this.dataEntry;
      var labels = this.labelsEntry;
      var colors = this.colors;
      if (this.uni_color) {
        this.colorPosition = this.labelsEntry.indexOf(this.uni_color.name);
        var personalColor = true;
        var percentajeElement = dataset[this.colorPosition] * 1000 / 10;
        /* if our percentaje number is a float */
        var num = percentajeElement;
        if (num % 1 != 0) {
          num = num.toFixed(2);
          percentajeElement = Number(num);
        }
      }

      var width = document.querySelector(".chartwrapper").offsetWidth;
      var height = document.querySelector(".chartwrapper").offsetHeight;
      var minOfWH = Math.min(width, height) / 2;
      var initialAnimDelay = 0;
      var arcAnimDelay = 10;
      var arcAnimDur = 2000;
      /* delay for the sec animations */
      var secDur = 1000;
      var secIndividualdelay = 150;
      var radius = void 0;
      // calculate minimum of width and height to set chart radius
      if (minOfWH > 150) {
        radius = 150;
      } else {
        radius = minOfWH;
      }
      // append svg
      var chartwrapper = this.$refs.chartwrapper;
      var svg = d3.select(chartwrapper).append("svg").attr({
        width: width,
        height: height,
        class: "pieChart"
      }).append("g");
      svg.attr({
        transform: "translate(" + width / 2 + ", " + height / 2 + ")"
      });
      // for drawing slices, also it manages the proportion of the circle in
      // relation of the canvas
      var arc = d3.svg.arc().outerRadius(radius * (0.6 * 1.1)).innerRadius(radius * (0.45 * 1.1));
      // for labels and polylines
      var outerArc = d3.svg.arc().innerRadius(radius * 0.85).outerRadius(radius * 0.85);
      // d3 color generator
      var pie = d3.layout.pie().value(function (d) {
        return d;
      });
      var draw = function draw(clickFunction) {
        svg.append("g").attr("class", "lines");
        svg.append("g").attr("class", "slices");
        svg.append("g").attr("class", "labels");
        // define slice
        var slice = svg.select(".slices").datum(dataset).selectAll("path").data(pie);
        slice.enter().append("path").attr({
          fill: function fill(d, i) {
            return colors[i];
          },
          d: arc,
          "stroke-width": "25px",
          transform: function transform(d, i) {
            return "rotate(-180, 0, 0)";
          }
        }).style("opacity", 0).transition().delay(function (d, i) {
          return i * arcAnimDelay + initialAnimDelay;
        }).duration(arcAnimDur).ease("elastic").style("opacity", 1).attr("transform", "rotate(0,0,0)");

        slice.transition().delay(function (d, i) {
          return arcAnimDur + i * secIndividualdelay;
        }).duration(secDur).attr("stroke-width", "5px");

        var midAngle = function midAngle(d) {
          return d.startAngle + (d.endAngle - d.startAngle) / 2;
        };

        // CHART TEXT AND DOTTED LINES
        if (dataset.length === 2) {
          var text = svg.select(".labels").selectAll("text").data(pie(dataset));
          text.enter().append("text").attr("dy", "0.3em").style("opacity", 0).style("fill", "#4A4A4A").text(function (d, i) {
            return labels[i];
          }).attr("transform", function (d) {
            // calculate outerArc centroid for 'this' slice
            var pos = outerArc.centroid(d);
            // define left and right alignment of text labels
            pos[0] = radius * (midAngle(d) < Math.PI ? 1 : -1);
            return "translate(" + pos + ")";
          }).style("text-anchor", function (d) {
            return midAngle(d) < Math.PI ? "start" : "end";
          }).transition().delay(function (d, i) {
            return arcAnimDur + i * secIndividualdelay;
          }).duration(secDur).style("opacity", 1);
          // Here we draw the line that connects the text with their slices
          var polyline = svg.select(".lines").selectAll("polyline").data(pie(dataset));
          polyline.enter().append("polyline").style("opacity", 0.5).attr("points", function (d) {
            var pos = outerArc.centroid(d);
            pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
            return [arc.centroid(d), arc.centroid(d), arc.centroid(d)];
          }).transition().duration(secDur).delay(function (d, i) {
            return arcAnimDur + i * secIndividualdelay;
          }).attr("points", function (d) {
            var pos = outerArc.centroid(d);
            pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
            return [arc.centroid(d), outerArc.centroid(d), pos];
          });
        }

        // Here we add the inner text to our donnut component
        if (personalColor || dataset.length === 1) {
          svg.append("text").attr("dy", "0.26em").style("text-anchor", "middle").attr("class", "inner-circle").attr("fill", "#848484").text(function (d) {
            if (personalColor) {
              return percentajeElement + "%";
            } else {
              return "100%";
            }
          });
        }
        slice.on("click", clickFunction);
      };
      this.drawed = true;
      draw(this.clickCallback);
    }
  }
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Array
  },
  methods: {
    formatPercentage: function formatPercentage(percentage) {
      percentage = percentage * 100;
      return percentage.toFixed(2) + "%";
    },
    formatAmount: function formatAmount(amount) {
      amount = parseFloat(amount);
      return "$" + amount.toLocaleString();
    },
    goToAssetClass: function goToAssetClass(event) {
      event.preventDefault();
      var assetClass = event.currentTarget.id;
      this.$router.push("/analisis-portafolio/" + this.$route.params.id + "/mercado/" + assetClass);
    }
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Imports are written here */
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    graph_data: Array,
    assetClassColor: String
  },
  data: function data() {
    return {
      data: []
    };
  },

  computed: {},
  watch: {},
  methods: {
    draw: function draw() {
      var colors = [this.assetClassColor, '#E3ECFF', '#B8B8B8'];

      var data = this.data;
      // We set the styles of our bars
      var width = 220,
          barHeight = 30;

      var x = d3.scale.linear().domain(d3.extent(data, function (d) {
        return d.value;
      })).range([0, width]);

      var chart = d3.select(".chart").attr("width", width).attr("height", (barHeight + 20) * data.length);
      // Next we initiate the data join by defining the selection to which we will join data.
      var bar = chart.selectAll("g").data(data)
      /* Since we know the selection is empty, the returned update and exit
      selections are also empty, and we need only handle the enter selection
      which represents new data for which there was no existing element.
      We instantiate these missing elements by appending to the enter selection.*/
      .enter().append("g").attr("transform", function (d, i) {
        return "translate(0," + i * (barHeight + 20) + ")";
      });
      // Now we set the width of each new bar as a multiple of the associated data value, d.
      bar.append("rect").attr("width", function (d) {
        return x(d.value) * 0.8 + "px";
      }).attr("height", barHeight - 1).attr("marginTop", barHeight + 10)
      // We can set our colors by iterating between our array
      .attr({
        'fill': function fill(d, i) {
          return colors[i];
        }
      });
      bar.append("text").attr("x", function (d) {
        return x(d.value) * 0.8 + 2;
      }).attr("y", barHeight / 2).attr("dy", ".35em")
      // Here we set our text the way we want it
      .text(function (d) {
        d = d.value;
        // This is multiplied for 1000 an the divided
        // between 10 to aviod bugs by multiplying for 100
        d = d * 1000;
        d = d / 10;
        if (d % 1 != 0) {
          d = d.toFixed(2);
        }
        return d + '%';
      });
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    this.data = this.graph_data;
    this.draw();
  }
});

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    graph_data: Array,
    assetClassColor: String
  },
  data: function data() {
    return {
      scalatedVersion: false,
      data: []
    };
  },

  watch: {
    graph_data: function graph_data(value) {
      this.data = value;

      var length = value.length;
      var counter = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          var _value = element.value;
          if (_value < 0.5) {
            counter++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (counter == length) {
        this.createScalatedVersion();
      }
    }
  },
  methods: {
    transformToPercentage: function transformToPercentage(value) {
      var newValue = value;
      // This is multiplied for 1000 an the divided
      // between 10 to aviod bugs by multiplying for 100
      if (newValue < 0) {
        newValue = newValue * -1;
      }
      newValue = newValue * 1000;
      newValue = newValue / 10;
      if (newValue % 1 != 0) {
        newValue = newValue.toFixed(2);
      }
      return newValue;
    },
    defineWidth: function defineWidth(value) {
      var finalValue = this.transformToPercentage(value);
      if (this.scalatedVersion) {
        finalValue = finalValue * 2;
      }
      return finalValue + "%";
    },
    definePercentage: function definePercentage(value) {
      var finalValue = this.transformToPercentage(value);
      if (value < 0) {
        return "-" + finalValue + "%";
      }
      return finalValue + "%";
    },
    transformLine: function transformLine(value) {
      if (value > 0) {
        return;
      }
      return "translateX( calc(-100% - 1px) )";
    },
    checkIfValueIsPositive: function checkIfValueIsPositive(value) {
      if (value >= 0) {
        return true;
      } else {
        return false;
      }
    },
    createScalatedVersion: function createScalatedVersion() {
      this.scalatedVersion = true;
    }
  }
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PercentageBar__ = __webpack_require__(457);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Imports are written here */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    percentageBar: __WEBPACK_IMPORTED_MODULE_0__PercentageBar__["a" /* default */]
  },
  props: {
    graph_data: Object
  },
  data: function data() {
    return {
      subtotalWidth: Number,
      titles: [],
      colore: "red"
    };
  },

  computed: {},
  watch: {
    graph_data: "updateComponent"
  },
  methods: {
    manageColor: function manageColor(value) {
      return value;
    },
    modifyData: function modifyData(object, keyValue) {
      var value = object[keyValue];
      if (keyValue == "price" || keyValue == "amount") {
        value = "$" + value.toLocaleString();
      } else if (keyValue.includes("rtoAcom") || keyValue == "comisiones") {
        value = value * 1000 / 10;
        if (value % 1 != 0) {
          var num = value;
          num = num.toFixed(2);
          value = Number(num);
          value = "%" + value;
        }
      }
      return value;
    },
    updateComponent: function updateComponent() {
      this.tableData = this.graph_data.data;
      this.titles = this.graph_data.titles;
      this.subtotalWidth = 500;
    }
  },
  beforeMount: function beforeMount() {
    this.updateComponent();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioOverview_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0a926b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioOverview_vue__ = __webpack_require__(1323);
function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0a926b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0a926b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PortfolioOverview",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "representative-positions": __WEBPACK_IMPORTED_MODULE_2__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_3__CommentsSection__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_4__PortfolioFooter__["a" /* default */]
  },
  props: {
    externalMarketInformationTitleSpan: Number,
    externalmarketInformationSpan: Number,
    printableVersion: false
  },
  created: function created() {
    var _this = this;

    var userId = localStorage.getItem("user_id");
    if (!this.advisorId) {
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_5__graphql__["h" /* getAdvisorData */],
        variables: {
          id: userId
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.$store.dispatch("saveUserData", data.data);
      });
    }
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.externalMarketInformationTitleSpan) {
      this.marketInformationTitleSpan = this.externalMarketInformationTitleSpan;
    }
    if (this.externalmarketInformationSpan) {
      this.marketInformationSpan = this.externalmarketInformationSpan;
    }
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      marketInformationTitleSpan: 7,
      marketInformationSpan: 13,
      assetAllocation: {},
      marketInformation: [],
      portfolioComments: [],
      advisorComment: "",
      labels: {
        month: '',
        lastYear: ''
      }
    };
  },

  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    representativePositions: function representativePositions() {
      return {
        titles: [{
          prop: "assetName",
          label: ""
        }, {
          prop: "assetClass",
          label: "Asset Class"
        }],
        data: this.$store.getters.currentPortfolioAnalysis.representativePositions,
        percentage: true,
        displayTotalLabel: true
      };
    },
    marketInformationData: function marketInformationData() {
      return {
        titles: [{
          prop: "name",
          label: "Rendimiento"
        }, {
          prop: "monthYield",
          label: "Mensual " + this.labels.month + " " + this.labels.lastYear
        }, {
          prop: "accumulatedYield",
          label: "Acumulado " + this.labels.lastYear
        }],
        data: this.marketInformation
      };
    }
  },
  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.portfolioComments = value.portfolioComments;
        this.advisorComment = value.advisorComment;
        this.marketInformation = value.marketInformation;
        this.labels = value.labels;
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this2 = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_5__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "network-only"
      }).then(function (data) {
        return _this2.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this2.$message({
          type: "error",
          message: "Ocurrió un error, intenta más tarde"
        });
      });
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          dataColors.push(color);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
        }
      }
      this.assetAllocation = {
        data: data,
        labels: labels,
        titles: titles,
        dataColors: dataColors
      };
    }
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssetClassMenu__ = __webpack_require__(1315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PortfolioHeader',
  props: {
    generalData: {},
    isAssetClassSection: false,
    sectionLabel: '',
    currentAssetClass: '',
    assetClassAmount: 0,
    assetClassPercentage: 0,
    isAssetDetail: false,
    menuData: {},
    assetDetail: {}
  },
  components: {
    'asset-class-menu': __WEBPACK_IMPORTED_MODULE_0__AssetClassMenu__["a" /* default */]
  },
  methods: {
    goToOverview: function goToOverview() {
      var portfolioId = this.$route.params.id;
      this.$router.push('/analisis-portafolio/' + portfolioId);
    },
    formatPercentage: function formatPercentage(percentage) {
      percentage = percentage * 100;
      return percentage.toFixed(2) + '%';
    },
    formatTotalAmount: function formatTotalAmount(amount) {
      amount = parseFloat(amount) || 0;
      return '$' + amount.toLocaleString();
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Imports are written here */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssetClassMenu',
  props: {
    currentAssetClass: '',
    totalAmount: 0,
    percentage: 0,
    menuData: {},
    sectionLabel: '',
    isAssetDetail: false
  },
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: {
    cssClasses: function cssClasses() {
      var initial = { 'assetClass-container-menu': true };
      initial[this.currentAssetClass] = true;
      initial["isDetail"] = this.isAssetDetail;
      return initial;
    }
  },
  methods: {
    openMenu: function openMenu() {
      this.showMenu = !this.showMenu;
    },
    handleClick: function handleClick(event) {
      event.preventDefault();
      if (this.isAssetDetail) {
        this.$router.push('/analisis-portafolio/' + this.$route.params.id + '/mercado/' + this.currentAssetClass);
      } else {
        this.showMenu = !this.showMenu;
      }
    },
    formatPercentage: function formatPercentage(percentage) {
      percentage = percentage * 100;
      return percentage.toFixed(2) + '%';
    },
    formatAmount: function formatAmount(amount) {
      amount = parseFloat(amount) || 0;
      return '$' + amount.toLocaleString();
    },
    goToAssetClass: function goToAssetClass(event) {
      event.preventDefault();
      var assetClass = event.currentTarget.id.toLowerCase();
      this.$router.push('/analisis-portafolio/' + this.$route.params.id + '/mercado/' + assetClass);
    }
  }
});

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommentsSection',
  props: {
    content: String,
    isPortfolioOverview: Boolean,
    isAssetClassView: Boolean,
    isInvestmentView: Boolean,
    comments: Array,
    assetClassId: Number,
    investmentId: Number,
    isPrintVersion: Boolean
  },
  data: function data() {
    return {
      title: {
        admin: 'Ver y agregar comentarios',
        advisor: 'Ver comentarios'
      },
      inputContent: '',
      commentData: {},
      newComments: []
    };
  },

  computed: {
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    portofolioId: function portofolioId() {
      return parseInt(this.$route.params.id);
    }
  },
  methods: {
    addComment: function addComment() {
      var _this = this;

      this.commentData = this.getRequestVariables(this.portofolioId, this.inputContent);
      this.$apollo.mutate({ mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["b" /* addComment */],
        variables: this.commentData
      }).then(function (data) {
        return _this.requestSuccess(data.data.addPortfolioComments);
      }).catch(function () {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    requestSuccess: function requestSuccess(data) {
      if (this.isPortfolioOverview) {
        this.newComments.push(this.commentData.portfolioComments[0]);
      }
      if (this.isAssetClassView) {
        this.newComments.push(this.commentData.assetClassComments[0]);
      }
      if (this.isInvestmentView) {
        this.newComments.push(this.commentData.investmentComments[0]);
      }
      this.inputContent = '';
      if (data.returnCode === 0) {
        this.$message({ type: "success",
          message: "Comentario agregado" });
      }
    },
    getRequestVariables: function getRequestVariables(id, comment, assetClass) {
      var requestVariables = {};
      if (this.isAssetClassView) {
        requestVariables = {
          portfolioId: id,
          assetClassComments: [{
            idAssetClass: this.assetClassId,
            comment: comment
          }]
        };
      } else if (this.isInvestmentView) {
        requestVariables = {
          portfolioId: id,
          investmentComments: [{
            idInvestment: this.investmentId,
            comment: comment
          }]
        };
      } else if (this.isPortfolioOverview) {
        requestVariables = {
          portfolioId: id,
          portfolioComments: [{
            comment: comment
          }]
        };
      }
      return requestVariables;
    }
  }
});

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentConfig__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PortfolioFooter',
  props: {
    creationDate: ''

  },
  data: function data() {
    return {
      legalNotice: __WEBPACK_IMPORTED_MODULE_0__componentConfig__["a" /* legalNoticeText */],
      showModal: false
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassDeuda_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f5c89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassDeuda_vue__ = __webpack_require__(1325);
function injectStyle (ssrContext) {
  __webpack_require__(1324)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-421f5c89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassDeuda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f5c89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassDeuda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetClassDeuda",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_2__TableData__["a" /* default */],
    "special-slider": __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_3__CommentsSection__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */]
  },
  props: {
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_6__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Deuda",
        color: "#97E3D6"
      },
      currentAssetClass: "deuda",
      assetAllocation: {},
      menuData: {},
      assetClassComments: [],
      assetClassId: 0
    };
  },

  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.deuda.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.deuda.percentage;
    },
    investments: function investments() {
      return {
        titles: [{ prop: "assetName", label: "Emisora" }],
        titles2: [{ prop: "price", label: "Precio" }, { prop: "amount", label: "Monto" }],
        data: this.$store.getters.deuda.investments,
        percentage: true,
        extraData: true
      };
    },
    assetTypesDistribution: function assetTypesDistribution() {
      return {
        titles: [{ prop: "name", label: "Tipo" }],
        data: this.$store.getters.deuda.assetTypesDistribution,
        percentage: true
      };
    },
    assetRateDistribution: function assetRateDistribution() {
      return {
        titles: [{ prop: "name", label: "Tipo" }],
        data: this.$store.getters.deuda.assetRateDistribution,
        percentage: true
      };
    },
    scoreDistribution: function scoreDistribution() {
      return {
        items: this.$store.getters.deuda.scoreDistribution
      };
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    },
    couponData: function couponData() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }, {
          prop: "tasa",
          label: "Tasa Cupón"
        }, {
          prop: "frecuency",
          label: "Frecuencia Cupón"
        }, {
          prop: "endData", // Esto es un error de nombrado :/
          label: "F. Vencimiento"
        }, {
          prop: "ytm",
          label: "YTM"
        }],
        data: this.$store.getters.deuda.couponData
      };
    }
  },
  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.assetClassComments = value.deuda.comments;
        this.assetClassId = value.deuda.assetClassId;
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_7__graphql__["r" /* getPortfolioAnalysis */],
        variables: { id: id },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var menuData = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
          if (label !== this.assetClassColor.name) {
            menuData.push(titleObject);
            dataColors.push("#A5A5A5");
          } else {
            dataColors.push(color);
          }
        }
      }
      this.assetAllocation = { data: data, labels: labels, titles: titles, dataColors: dataColors };
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassFondosRF_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9605e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassFondosRF_vue__ = __webpack_require__(1327);
function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c9605e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassFondosRF_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9605e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassFondosRF_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetClassFondosRF",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "horizontal-bar-chart": __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_7__PortfolioFooter__["a" /* default */],
    "special-slider": __WEBPACK_IMPORTED_MODULE_6__SpecialSlider__["a" /* default */]
  },
  props: {
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_8__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Fondos RF",
        color: "#C2BFE0"
      },
      assetAllocation: {},
      menuData: {},
      assetClassComments: [],
      assetClassId: 0
    };
  },

  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.fondosrf.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.fondosrf.percentage;
    },
    investments: function investments() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }],
        titles2: [{
          prop: "amount",
          label: "Monto"
        },
        // {
        //   prop: "accumulatedYield",
        //   label: `Rto Acum ${this.labels.accum}`
        // },
        {
          prop: "commission",
          label: "Comisión"
        }],
        data: this.$store.getters.fondosrf.investments,
        percentage: true,
        extraDataThree: true
      };
    },
    yieldByAsset: function yieldByAsset() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }, {
          prop: "year3",
          label: "" + this.labels.year3
        }, {
          prop: "year2",
          label: "" + this.labels.year2
        }, {
          prop: "year1",
          label: "" + this.labels.year1
        }, {
          prop: "accumulatedYield",
          label: "Acum. " + this.labels.lastYear
        }],
        data: this.$store.getters.fondosrf.investmentsYield
      };
    },
    yieldAndCommissions: function yieldAndCommissions() {
      return [{
        name: "Rendimientos acum. " + this.labels.lastYear,
        value: this.$store.getters.fondosrf.accumulatedYields
      }, {
        name: "Comisiones",
        value: this.$store.getters.fondosrf.comissions
      }];
    },
    assetClassBenchmark: function assetClassBenchmark() {
      return {
        title: "Comparativo benchmark del mercado",
        dates: ["Rto." + this.labels.year3, "Rto." + this.labels.year2, "Rto." + this.labels.year1, "Rto.Acum." + this.labels.lastYear],
        trace1: {
          name: "Fondos RF",
          data: this.$store.getters.fondosrf.benchmarkComparative.assetsData
        },
        trace2: {
          name: "Cetes 28 días",
          data: this.$store.getters.fondosrf.benchmarkComparative.benchmarkData
        }
      };
    },
    scoreDistribution: function scoreDistribution() {
      return {
        items: this.$store.getters.fondosrf.scoreDistribution
      };
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.assetClassComments = value.fondosRF.comments;
        this.assetClassId = value.fondosRF.assetClassId;
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_9__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var menuData = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
          if (label !== this.assetClassColor.name) {
            menuData.push(titleObject);
            dataColors.push("#A5A5A5");
          } else {
            dataColors.push(color);
          }
        }
      }
      this.assetAllocation = {
        data: data,
        labels: labels,
        titles: titles,
        dataColors: dataColors
      };
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassFondosRV_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7d2dede_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassFondosRV_vue__ = __webpack_require__(1329);
function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7d2dede"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassFondosRV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7d2dede_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassFondosRV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetClassFondosRV",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "horizontal-bar-chart": __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__["a" /* default */]
  },
  props: {
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_7__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Fondos RV",
        color: "#FDB462"
      },
      assetAllocation: {},
      menuData: {},
      assetClassComments: [],
      assetClassId: 0
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.assetClassComments = value.fondosRV.comments;
        this.assetClassId = value.fondosRV.assetClassId;
      }
    }
  },
  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.fondosrv.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.fondosrv.percentage;
    },
    investments: function investments() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }],
        titles2: [{
          prop: "amount",
          label: "Monto"
        },
        // {
        //   prop: "accumulatedYield",
        //   label: `Rto Acum ${this.labels.accum}`
        // },
        {
          prop: "commission",
          label: "Comisión"
        }],
        data: this.$store.getters.fondosrv.investments,
        percentage: true,
        extraDataThree: true
      };
    },
    yieldByAsset: function yieldByAsset() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }, {
          prop: "year3",
          label: "" + this.labels.year3
        }, {
          prop: "year2",
          label: "" + this.labels.year2
        }, {
          prop: "year1",
          label: "" + this.labels.year1
        }, {
          prop: "accumulatedYield",
          label: "Acum. " + this.labels.lastYear
        }],
        data: this.$store.getters.fondosrv.investmentsYield
      };
    },
    yieldAndCommissions: function yieldAndCommissions() {
      return [{
        name: "Rendimientos acum. " + this.labels.lastYear,
        value: this.$store.getters.fondosrv.accumulatedYields
      }, {
        name: "Comisiones",
        value: this.$store.getters.fondosrv.comissions
      }];
    },
    assetClassBenchmark: function assetClassBenchmark() {
      return {
        title: "Comparativo benchmark del mercado",
        dates: ["Rto." + this.labels.year3, "Rto." + this.labels.year2, "Rto." + this.labels.year1, "Rto.Acum." + this.labels.lastYear],
        trace1: {
          name: "Fondos RV",
          data: this.$store.getters.fondosrv.benchmarkComparative.assetsData
        },
        trace2: {
          name: "IPC",
          data: this.$store.getters.fondosrv.benchmarkComparative.benchmarkData
        }
      };
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_8__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var menuData = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
          if (label !== this.assetClassColor.name) {
            menuData.push(titleObject);
            dataColors.push("#A5A5A5");
          } else {
            dataColors.push(color);
          }
        }
      }
      this.assetAllocation = {
        data: data,
        labels: labels,
        titles: titles,
        dataColors: dataColors
      };
      this.menuData = menuData;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    }
  }
});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassEstructurados_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3074_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassEstructurados_vue__ = __webpack_require__(1331);
function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c9b3074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassEstructurados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3074_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassEstructurados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetClassEstructurados",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_2__TableData__["a" /* default */],
    "special-slider": __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_3__CommentsSection__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */]
  },
  props: {
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_6__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Estructurados",
        color: "#FB8070"
      },
      currentAssetClass: "estructurados",
      assetAllocation: {},
      menuData: {},
      assetClassComments: [],
      assetClassId: 0
    };
  },

  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.estructurados.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.estructurados.percentage;
    },
    investments: function investments() {
      return {
        "titles": [{ prop: 'assetName', label: 'Emisora' }],
        "titles2": [{ prop: 'price', label: 'Precio' }, { prop: 'amount', label: 'Monto' }, { prop: 'securities', label: 'Títulos' }],
        "data": this.$store.getters.estructurados.investments
      };
    },
    assetTypesDistribution: function assetTypesDistribution() {
      return {
        titles: [{ prop: "name", label: "Tipo" }],
        data: this.$store.getters.estructurados.assetTypesDistribution,
        percentage: true
      };
    },
    assetRateDistribution: function assetRateDistribution() {
      return {
        titles: [{ prop: "name", label: "Tipo" }],
        data: this.$store.getters.estructurados.assetRateDistribution,
        percentage: true
      };
    },
    scoreDistribution: function scoreDistribution() {
      return {
        items: this.$store.getters.estructurados.scoreDistribution
      };
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.assetClassComments = value.estructurados.comments;
        this.assetClassId = value.estructurados.assetClassId;
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_7__graphql__["r" /* getPortfolioAnalysis */],
        variables: { id: id },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var menuData = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
          if (label !== this.assetClassColor.name) {
            menuData.push(titleObject);
            dataColors.push("#A5A5A5");
          } else {
            dataColors.push(color);
          }
        }
      }
      this.assetAllocation = { data: data, labels: labels, titles: titles, dataColors: dataColors };
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassCapitales_vue__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9943dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassCapitales_vue__ = __webpack_require__(1333);
function injectStyle (ssrContext) {
  __webpack_require__(1332)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e9943dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetClassCapitales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9943dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetClassCapitales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetClassCapitales",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_2__TableData__["a" /* default */],
    "special-slider": __WEBPACK_IMPORTED_MODULE_4__SpecialSlider__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_3__CommentsSection__["a" /* default */],
    "horizontal-bar-chart": __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__["a" /* default */]
  },
  props: {
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_7__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Capitales",
        color: "#B3DE69"
      },
      currentAssetClass: "capitales",
      assetAllocation: {},
      menuData: {},
      assetClassComments: [],
      assetClassId: 0
    };
  },

  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.capitales.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.capitales.percentage;
    },
    investments: function investments() {
      if (this.portfolioAnalysis) {
        return {
          titles: [{
            prop: "assetName",
            label: "Emisora"
          }],
          titles2: [{
            prop: "price",
            label: "Precio"
          }, {
            prop: "amount",
            label: "Monto"
          }],
          data: this.$store.getters.capitales.investments,
          percentage: true,
          extraDataTwo: true
        };
      }
    },
    yieldByAsset: function yieldByAsset() {
      if (this.portfolioAnalysis) {
        return {
          titles: [{
            prop: "assetName",
            label: "Emisora"
          }, {
            prop: "initialPrice",
            label: "Precio inicial"
          }, {
            prop: "currentPrice",
            label: "Precio Actual"
          }, {
            prop: "accumulatedYield",
            label: "Rendimiento Acum."
          }, {
            prop: "weightedAccumulatedYield",
            label: "Rend. Acum. Ponderado"
          }],
          data: this.$store.getters.capitales.investmentsYield
        };
      }
    },
    yieldAndCommissions: function yieldAndCommissions() {
      if (this.portfolioAnalysis) {
        return [{
          name: "Rendimientos acum. " + this.labels.lastYear,
          value: this.$store.getters.capitales.accumulatedYields || 0.0
        }, {
          name: "IPC",
          value: this.$store.getters.capitales.benchmarkYields || 0.0
        }];
      }
    },
    sectorDistribution: function sectorDistribution() {
      return {
        titles: [],
        data: this.$store.getters.capitales.sectorDistribution,
        distributionPerSector: true
      };
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getChartData(value);
        this.assetClassComments = value.capitales.comments;
        this.assetClassId = value.capitales.assetClassId;
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_8__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData: function getChartData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      var data = [];
      var labels = [];
      var titles = [];
      var menuData = [];
      var dataColors = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        var color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          var titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
          if (label !== this.assetClassColor.name) {
            menuData.push(titleObject);
            dataColors.push("#A5A5A5");
          } else {
            dataColors.push(color);
          }
        }
      }
      this.assetAllocation = {
        data: data,
        labels: labels,
        titles: titles,
        dataColors: dataColors
      };
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailFondosRV_vue__ = __webpack_require__(485);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e308128a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailFondosRV_vue__ = __webpack_require__(1335);
function injectStyle (ssrContext) {
  __webpack_require__(1334)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e308128a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailFondosRV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e308128a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailFondosRV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetDetailFondosRV",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */]
  },
  props: {
    // used for print version
    assetName: "",
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_6__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Fondos RV",
        color: "#FDB462"
      },
      assetAllocation: {},
      menuData: {},
      currentInvesment: [{
        assetName: "",
        amount: 0,
        percentage: 0,
        assetId: 0,
        comments: []
      }],
      assetYield: {},
      assetBenchmarkData: {
        assetsData: [],
        benchmarkData: []
      }
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getCurrentInvestment(value.fondosRV.investments);
        this.getMenuData(value);
        this.getInvestmentYield(value.fondosRV.investmentsYield);
      }
    },
    assetName: function assetName(value) {
      if (value) {
        this.getCurrentInvestment(portfolioAnalysis.fondosRV.investments);
      }
    }
  },
  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.fondosrv.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.fondosrv.percentage;
    },
    investmentTableData: function investmentTableData() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }],
        titles2: [{
          prop: "amount",
          label: "Monto"
        }, {
          prop: "accumulatedYield",
          label: "Rto Acum " + this.labels.accum
        }, {
          prop: "commission",
          label: "Comisión"
        }],
        data: this.currentInvesment,
        percentage: true,
        extraDataThree: true
      };
    },
    assetBenchmark: function assetBenchmark() {
      return {
        title: "Comparativo benchmark del mercado",
        dates: ["Rto." + this.labels.year2, "Rto." + this.labels.year1, "Rto.Acum." + this.labels.lastYear, "Rto.Acum." + this.labels.accum],
        trace1: {
          name: this.$route.params.assetName || this.assetName,
          data: this.assetBenchmarkData.assetsData
        },
        trace2: {
          name: "IPC",
          data: this.assetBenchmarkData.benchmarkData
        }
      };
    },
    yieldTableData: function yieldTableData() {
      return {
        titles: [{
          prop: "year3",
          label: "" + this.labels.year3
        }, {
          prop: "year2",
          label: "" + this.labels.year2
        }, {
          prop: "year1",
          label: "" + this.labels.year1
        }, {
          prop: "accumulatedYield",
          label: "Acum. " + this.labels.lastYear
        }],
        data: this.assetYield
      };
    },
    yieldAndCommissions: function yieldAndCommissions() {
      return [{
        name: "Rendimientos acum. " + this.labels.lastYear,
        value: this.$store.getters.fondosrf.accumulatedYields
      }, {
        name: "Comisiones",
        value: this.$store.getters.fondosrf.comissions
      }];
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_7__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getCurrentInvestment: function getCurrentInvestment(investments) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investments.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.currentInvesment = investmentDetail;
      this.assetBenchmarkData = investmentDetail[0].benchmarkComparative;
    },
    getInvestmentYield: function getInvestmentYield(investmentsYield) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investmentsYield.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.assetYield = investmentDetail;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getMenuData: function getMenuData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var menuData = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        if (portfolioAnalysis[id].amount !== 0 && label !== this.assetClassColor.name) {
          var assetClass = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          menuData.push(assetClass);
        }
      }
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailFondosRF_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f04c078_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailFondosRF_vue__ = __webpack_require__(1337);
function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f04c078"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailFondosRF_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f04c078_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailFondosRF_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetDetailFondosRF",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    "comments": __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */],
    "horizontal-bar-chart": __WEBPACK_IMPORTED_MODULE_6__VerticalTableData2__["a" /* default */]
  },
  props: {
    // used for print version
    assetName: "",
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_7__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Fondos RF",
        color: "#C2BFE0"
      },
      assetAllocation: {},
      menuData: {},
      currentInvesment: [{
        assetName: "",
        amount: 0,
        percentage: 0,
        assetId: 0,
        comments: []
      }],
      assetYield: 0,
      assetYearYield: [],
      assetComission: 0,
      assetBenchmarkData: {
        assetsData: [],
        benchmarkData: []
      }
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getCurrentInvestment(value.fondosRF.investments);
        this.getMenuData(value);
      }
    },
    assetName: function assetName(value) {
      if (value) {
        this.getCurrentInvestment(portfolioAnalysis.fondosRF.investments);
      }
    }
  },
  computed: {
    yieldTableData: function yieldTableData() {
      return {
        titles: [{
          prop: "year3",
          label: "" + this.labels.year3
        }, {
          prop: "year2",
          label: "" + this.labels.year2
        }, {
          prop: "year1",
          label: "" + this.labels.year1
        }, {
          prop: "accumulatedYield",
          label: "Acum. " + this.labels.lastYear
        }],
        data: this.assetYearYield
      };
    },
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.fondosrf.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.fondosrf.percentage;
    },
    investmentTableData: function investmentTableData() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }],
        titles2: [{
          prop: "amount",
          label: "Monto"
        }, {
          prop: "accumulatedYield",
          label: "Rto Acum " + this.labels.accum
        }, {
          prop: "commission",
          label: "Comisión"
        }],
        data: this.currentInvesment,
        percentage: true,
        extraDataThree: true
      };
    },
    assetBenchmark: function assetBenchmark() {
      return {
        title: "Comparativo benchmark del mercado",
        dates: ["Rto." + this.labels.year3, "Rto." + this.labels.year2, "Rto." + this.labels.year1, "Rto.Acum." + this.labels.lastYear],
        trace1: {
          name: this.$route.params.assetName || this.assetName,
          data: this.assetBenchmarkData.assetsData
        },
        trace2: {
          name: "Cetes 28 días",
          data: this.assetBenchmarkData.benchmarkData
        }
      };
    },
    yieldAndCommissions: function yieldAndCommissions() {
      return [{
        name: "Rendimientos acum. " + this.labels.lastYear,
        value: this.assetYield
      }, {
        name: "Comisiones",
        value: this.assetComission
      }];
    },
    labels: function labels() {
      return this.$store.getters.currentPortfolioAnalysis.labels;
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_8__graphql__["r" /* getPortfolioAnalysis */],
        variables: {
          id: id
        },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getCurrentInvestment: function getCurrentInvestment(investments) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investments.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.currentInvesment = investmentDetail;
      this.assetBenchmarkData = investmentDetail[0].benchmarkComparative;
      this.assetYield = investmentDetail[0].accumulatedYield;
      this.assetComission = investmentDetail[0].commission;
      this.assetYearYield.push(investmentDetail[0].investmentYield);
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getMenuData: function getMenuData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var menuData = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        if (portfolioAnalysis[id].amount !== 0 && label !== this.assetClassColor.name) {
          var assetClass = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          menuData.push(assetClass);
        }
      }
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailDeuda_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527cd1e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailDeuda_vue__ = __webpack_require__(1339);
function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-527cd1e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailDeuda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527cd1e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailDeuda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetDetailDeuda",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "horizontal-bar-chart": __WEBPACK_IMPORTED_MODULE_5__VerticalTableData2__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_6__PortfolioFooter__["a" /* default */]
  },
  props: {
    // used for print version
    assetName: "",
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_7__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Deuda",
        color: "#97E3D6"
      },
      assetAllocation: {},
      menuData: {},
      currentInvesment: [{
        assetName: "",
        amount: 0,
        percentage: 0,
        assetId: 0,
        comments: []
      }],
      assetYield: {},
      invesmentCouponData: []
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getCurrentInvestment(value.deuda.investments);
        this.getMenuData(value);
      }
    },
    assetName: function assetName(value) {
      if (value) {
        this.getCurrentInvestment(portfolioAnalysis.deuda.investments);
      }
    }
  },
  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.deuda.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.deuda.percentage;
    },
    investmentTableData: function investmentTableData() {
      return {
        titles: [{ prop: "assetName", label: "Emisora" }],
        titles2: [{ prop: "amount", label: "Monto" }],
        data: this.currentInvesment,
        percentage: true,
        extraData: true
      };
    },
    couponData: function couponData() {
      return {
        titles: [{
          prop: "assetName",
          label: "Emisora"
        }, {
          prop: "tasa",
          label: "Tasa Cupón"
        }, {
          prop: "frecuency",
          label: "Frecuencia Cupón"
        }, {
          prop: "endData", // Esto es un error de nombrado :/
          label: "F. Vencimiento"
        }, {
          prop: "ytm",
          label: "YTM"
        }],
        data: this.invesmentCouponData
      };
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_8__graphql__["r" /* getPortfolioAnalysis */],
        variables: { id: id },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getCurrentInvestment: function getCurrentInvestment(investments) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investments.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.currentInvesment = investmentDetail;
      this.invesmentCouponData.push(investmentDetail[0].couponData);
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getMenuData: function getMenuData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var menuData = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        if (portfolioAnalysis[id].amount !== 0 && label !== this.assetClassColor.name) {
          var assetClass = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          menuData.push(assetClass);
        }
      }
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailCapitales_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca6c659_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailCapitales_vue__ = __webpack_require__(1341);
function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ca6c659"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetDetailCapitales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca6c659_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetDetailCapitales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetDetailFondosRV",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */]
  },
  props: {
    // used for print version
    assetName: "",
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_6__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Capitales",
        color: "#B3DE69"
      },
      assetAllocation: {},
      menuData: {},
      currentInvesment: [{
        assetName: "",
        amount: 0,
        percentage: 0,
        assetId: 0,
        comments: []
      }],
      investmentYield: []
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getCurrentInvestment(value.capitales.investments);
        this.getMenuData(value);
      }
    },
    assetName: function assetName(value) {
      if (value) {
        this.getCurrentInvestment(portfolioAnalysis.capitales.investments);
      }
    }
  },
  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.capitales.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.capitales.percentage;
    },
    investmentTableData: function investmentTableData() {
      return {
        titles: [{ prop: "assetName", label: "Emisora" }],
        titles2: [{ prop: "price", label: "Precio" }, { prop: "amount", label: "Monto" }],
        data: this.currentInvesment,
        percentage: true,
        extraDataTwo: true
      };
    },
    assetYield: function assetYield() {
      if (this.portfolioAnalysis) {
        return {
          titles: [{
            prop: "assetName",
            label: "Emisora"
          }, {
            prop: "initialPrice",
            label: "Precio inicial"
          }, {
            prop: "currentPrice",
            label: "Precio Actual"
          }, {
            prop: "accumulatedYield",
            label: "Rendimiento Acum."
          }, {
            prop: "weightedAccumulatedYield",
            label: "Rend. Acum. Ponderado"
          }],
          data: this.investmentYield
        };
      }
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_7__graphql__["r" /* getPortfolioAnalysis */],
        variables: { id: id },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getCurrentInvestment: function getCurrentInvestment(investments) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investments.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.currentInvesment = investmentDetail;
      this.investmentYield.push(investmentDetail[0].investmentYield);
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getMenuData: function getMenuData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var menuData = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        if (portfolioAnalysis[id].amount !== 0 && label !== this.assetClassColor.name) {
          var assetClass = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          menuData.push(assetClass);
        }
      }
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommentsSection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetDetailEstructurados",
  components: {
    "portfolio-header": __WEBPACK_IMPORTED_MODULE_0__PortfolioHeader__["a" /* default */],
    "asset-allocation": __WEBPACK_IMPORTED_MODULE_1__DonnutChartSection__["a" /* default */],
    "asset-overview-table": __WEBPACK_IMPORTED_MODULE_3__TableData__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_4__CommentsSection__["a" /* default */],
    "bar-chart": __WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],
    "portfolio-footer": __WEBPACK_IMPORTED_MODULE_5__PortfolioFooter__["a" /* default */]
  },
  props: {
    // used for print version
    assetName: "",
    printableVersion: false
  },
  mounted: function mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data: function data() {
    return {
      printVersion: false,
      legalNotice: __WEBPACK_IMPORTED_MODULE_6__componentConfig__["a" /* legalNoticeText */],
      showModal: false,
      assetClassColor: {
        name: "Estructurados",
        color: "#FB8070"
      },
      assetAllocation: {},
      menuData: {},
      currentInvesment: [{
        assetName: "",
        amount: 0,
        percentage: 0,
        assetId: 0,
        comments: []
      }],
      assetYield: {}
    };
  },

  watch: {
    portfolioAnalysis: function portfolioAnalysis(value) {
      if (value) {
        this.getCurrentInvestment(value.estructurados.investments);
        this.getMenuData(value);
      }
    },
    assetName: function assetName(value) {
      if (value) {
        this.getCurrentInvestment(portfolioAnalysis.estructurados.investments);
      }
    }
  },
  computed: {
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    assetClassAmount: function assetClassAmount() {
      return this.$store.getters.estructurados.amount;
    },
    assetClassPercentage: function assetClassPercentage() {
      return this.$store.getters.estructurados.percentage;
    },
    investmentTableData: function investmentTableData() {
      return {
        titles: [{ prop: "assetName", label: "Emisora" }],
        titles2: [{ prop: "amount", label: "Monto" }],
        data: this.currentInvesment,
        percentage: true,
        extraData: true
      };
    }
  },
  methods: {
    getPortfolioData: function getPortfolioData(id) {
      var _this = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_7__graphql__["r" /* getPortfolioAnalysis */],
        variables: { id: id },
        fetchPolicy: "cache-first"
      }).then(function (data) {
        return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
      }).catch(function (error) {
        _this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    getCurrentInvestment: function getCurrentInvestment(investments) {
      var investmentName = this.$route.params.assetName || this.assetName;
      var investmentDetail = investments.filter(function (investment) {
        return investment.assetName === investmentName;
      });
      this.currentInvesment = investmentDetail;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getMenuData: function getMenuData(portfolioAnalysis) {
      var objectKeys = ["fondosRF", "fondosRV", "deuda", "capitales", "estructurados"];
      var placeholders = ["Fondos RF", "Fondos RV", "Deuda", "Capitales", "Estructurados"];
      var menuData = [];
      for (var index in objectKeys) {
        var id = objectKeys[index];
        var label = placeholders[index];
        if (portfolioAnalysis[id].amount !== 0 && label !== this.assetClassColor.name) {
          var assetClass = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          menuData.push(assetClass);
        }
      }
      this.menuData = menuData;
    }
  }
});

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrintTittle__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PortfolioOverview__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssetClassFondosRV__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssetClassFondosRF__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssetClassCapitales__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssetClassDeuda__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AssetClassEstructurados__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssetDetailFondosRF__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AssetDetailFondosRV__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AssetDetailDeuda__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssetDetailCapitales__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__componentConfig__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PrintablePortfolio",
  components: {
    "portfolio-overview": __WEBPACK_IMPORTED_MODULE_1__PortfolioOverview__["a" /* default */],
    // Asset Class views
    "fondos-rv": __WEBPACK_IMPORTED_MODULE_2__AssetClassFondosRV__["a" /* default */],
    "fondos-rf": __WEBPACK_IMPORTED_MODULE_3__AssetClassFondosRF__["a" /* default */],
    deuda: __WEBPACK_IMPORTED_MODULE_5__AssetClassDeuda__["a" /* default */],
    capitales: __WEBPACK_IMPORTED_MODULE_4__AssetClassCapitales__["a" /* default */],
    estructurados: __WEBPACK_IMPORTED_MODULE_6__AssetClassEstructurados__["a" /* default */],
    "investment-fondos-rf": __WEBPACK_IMPORTED_MODULE_7__AssetDetailFondosRF__["a" /* default */],
    "investment-fondos-rv": __WEBPACK_IMPORTED_MODULE_8__AssetDetailFondosRV__["a" /* default */],
    "investment-deuda": __WEBPACK_IMPORTED_MODULE_9__AssetDetailDeuda__["a" /* default */],
    "investment-capitales": __WEBPACK_IMPORTED_MODULE_10__AssetDetailCapitales__["a" /* default */],
    "print-tittle": __WEBPACK_IMPORTED_MODULE_0__PrintTittle__["a" /* default */]
  },
  data: function data() {
    return {
      legalNotice: __WEBPACK_IMPORTED_MODULE_12__componentConfig__["a" /* legalNoticeText */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$apollo.query({
      query: __WEBPACK_IMPORTED_MODULE_11__graphql__["r" /* getPortfolioAnalysis */],
      variables: {
        id: this.portofolioId
      },
      fetchPolicy: "cache-first"
    }).then(function (data) {
      return _this.analysisSuccessHandler(data.data.portfolioAnalysis);
    }).catch(function (error) {
      _this.$message({
        type: "error",
        message: "Ocurrió un error intenta más tarde"
      });
    });
  },

  computed: {
    portofolioId: function portofolioId() {
      return parseInt(this.$route.params.id);
    },
    portfolioAnalysis: function portfolioAnalysis() {
      return this.$store.getters.currentPortfolioAnalysis;
    }
  },
  methods: {
    analysisSuccessHandler: function analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    }
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* Imports are written here */
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    tittle: "",
    tittleColor: ""
  },
  data: function data() {
    return {
      VBindTittle: "",
      VBindTittleColor: "sad"
    };
  },

  computed: {},
  watch: {},
  methods: {},
  beforeMount: function beforeMount() {
    this.VBindTittle = this.tittle;
  },
  mounted: function mounted() {
    if (this.tittleColor) {
      this.$refs.tittle.style.color = this.tittleColor;
    }
  }
});

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientLogin',
  mounted: function mounted() {
    this.clientLogin.hash = this.$route.query.portafolio;
  },
  data: function data() {
    return {
      clientLogin: {
        password: '',
        hash: ''
      },
      rules: {
        password: [{
          required: true,
          message: "Debes proporcionar una contraseña",
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    validateAndSumbit: function validateAndSumbit(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.sendLoginRequest(_this.clientLogin);
        } else {
          return false;
        }
      });
    },
    sendLoginRequest: function sendLoginRequest(data) {
      var _this2 = this;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_0__graphql__["t" /* getPortfolioByUrl */],
        variables: {
          hash: data.hash,
          password: data.password
        }
      }).then(function (data) {
        return _this2.successHandler(data.data.portfolioAnalysisByUrl);
      }).catch(function (error) {
        _this2.$message({
          type: 'error',
          message: 'Ocurrió un error, intenta más tarde'
        });
      });
    },
    successHandler: function successHandler(data) {
      if (data.analysisPortfolio) {
        var portfolioId = data.analysisPortfolio.portfolioId;
        localStorage.setItem('portafolio_id', portfolioId);
        localStorage.setItem('client_token', this.clientLogin.hash);
        this.$store.dispatch("saveCurrentPortfolioAnalysis", data.analysisPortfolio).then(this.$router.push('/analisis-portafolio/' + portfolioId));
      } else if (data.returnCode === 1) {
        this.$message({
          type: 'error',
          message: 'La constraseña es incorrecta'
        });
      }
    }
  }
});

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ImportantLinks',
    data: function data() {
        return {
            links: [{ 'url': 'https://columbus-cdm.formstack.com/forms/rti_1_3', 'text': 'Recepción y Transmisión de Instrucciones' }, { 'url': 'https://columbus-cdm.formstack.com/forms/solicitud_de_traspasos_copy', 'text': 'Solicitud de Traspasos' }, { 'url': 'https://columbus-cdm.formstack.com/forms/solicitud_one_page', 'text': 'Solicitud One Page' }, { 'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_1_1', 'text': 'Apertura Cta. Individual PF' }, { 'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_aseguradora', 'text': 'Apertura Aseguradora PF' }],
            tools: [{ 'url': 'http://localhost:8000/validacion', 'text': 'Validación Clientes' }, { 'url': 'Calculadora', 'text': 'Calculadora' }, { 'url': 'https://app.powerbi.com/view?r=eyJrIjoiNDU0NzI2M2EtNmNlOC00MjIyLT' + 'gzNmMtMmNkOGNjNDE3NTk5IiwidCI6ImEwNWE0ZDg1LTUxZDgtNDQ4MS1hMDNkLTcyNjI4YjA0NDY2NiJ9', 'text': 'Comparativo de Fondos' }],
            openings: [{ 'url': 'https://onboarding.columbus.mx/sign-up', 'text': 'Apertura Aseguradora' }, { 'url': 'https://columbus-cdm.formstack.com/forms/kyc_pm_copy', 'text': 'Apertura Cuenta Individual PM' }, { 'url': 'https://columbus-cdm.formstack.com/forms/kyc_pf_cdp_1_1', 'text': 'Apertura Cuenta Individual PF CDP' }],
            complements: [{ 'url': 'https://columbus-cdm.formstack.com/forms/carta_instruccion_v1_2', 'text': 'Carta Instrucción' }, { 'url': 'https://columbus-cdm.formstack.com/forms/posici_n_inicial', 'text': 'Posición Inicial' }],
            reports: [{ 'url': 'https://columbus-cdm.formstack.com/forms/solicitud_one_page', 'text': 'Solicitud One Page' }, { 'url': 'IXION', 'text': 'Análisis Portafolios' }],
            operations: [{ 'url': 'https://columbus-cdm.formstack.com/forms/rti_2_0_weetrust', 'text': 'Recepción y transmisión de instrucciones ' }, { 'url': 'https://columbus-cdm.formstack.com/forms/solicitud_de_traspasos_copy', 'text': 'Solicitud Traspasos' }],
            web: [{ 'url': 'https://columbus.mx/', 'text': 'Columbus' }, { 'url': 'https://columbus.mx/login/', 'text': 'Columbus Acceso' }, { 'url': 'https://batial.org/', 'text': 'Batial' }]
        };
    },

    methods: {
        goToLink: function goToLink(link) {
            if (link === '/validacion') {
                this.$router.push(link);
            } else if (link === '/calculadora') {
                this.$router.push(link);
            } else if (link === '/lista-de-analisis') {
                this.$router.push(link);
            }
        }
    }
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Validacion",
    data: function data() {
        return {

            loading: false,
            displaySendUrlDialog: false,
            inputVisible: false,
            inputValue: '',
            listTable: [],
            dialogFormVisible: false,
            formLabelWidth: '120px',
            formData: {},
            currentIndex: 0,
            filterStatus: '',
            checked: false,

            searchText: ''

        };
    },

    computed: {
        validateQuery: function validateQuery() {
            return {
                query: __WEBPACK_IMPORTED_MODULE_0__graphql__["l" /* getAllValidations */],
                variables: {
                    email: this.email,
                    search: this.searchText
                },
                fetchPolicy: 'network-only'
            };
        },
        email: function email() {
            return this.$store.getters.userInfo.email;
        },
        valid: function valid() {
            //this.validate();
            return this.listTable;
        }

    },
    mounted: function mounted() {
        this.validate();
    },

    methods: {
        validate: function validate() {
            var _this = this;

            //console.log("Loading clients", this.listTable)
            this.loading = true;
            var q = this.validateQuery;

            this.$apollo.query({
                query: q.query,
                variables: q.variables,
                fetchPolicy: q.fetchPolicy
            }).then(function (data) {
                //this.successHandler(data.data)
                _this.loading = false;

                /*
                var datos = JSON.parse(data.data.validation.message)
                console.log("1", datos[0])
                var list = []
                Object.keys(datos).forEach(function (key) {
                     //console.log(datos[key]['codigo_cliente'])
                     list.push(
                        {
                            "alias": (datos[key]["alias"]),"nombreCliente": datos[key]["nombre_cliente"],
                            "email":datos[key]["mail_cliente"], "codigo": datos[key]["codigo_cliente"],
                            "celular": datos[key]["celular"], "enviado": datos[key]["validated"],
                            "fecha_ultimo": datos[key]["fecha_ultimo"],"edited":true,
                            "fecha_envio": datos [key]["fecha_envio"], "validate":false}
                        )
                });
                */
                //this.listTable = []
                _this.listTable = data.data.allValidations;
                console.log('DATA', data.data.allValidations);
            }).catch(function (error) {
                console.log(error);
            });
        },

        callFunction: function callFunction() {

            var currentDate = new Date();
            console.log(currentDate);

            var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

            console.log(currentDateWithFormat);
            return currentDateWithFormat;
        },
        handleSave: function handleSave(index, row) {
            row.edited = true;
            row.validated = false;
            var pass = false;
            // Check for blank values
            //if (row.checkTel === true && row.telCelular !== '' && row.checkMail === true && row.mailSiap !== ''  ){
            //    pass = true
            //}
            //if (row.checkTel === false && row.telCelular !== '' && row.checkMail === true && row.mailSiap !== ''  ){
            //    pass = true
            //}

            //console.log("Saved", index, row)
            this.update(index, row);
        },
        handleEdit: function handleEdit(index, row) {
            row.edited = !row.edited;
            row.validated = !row.validated;
            //console.log('EDIT', index, row)
        },
        handleValidation: function handleValidation(index, row) {
            row.edited = true;
            //console.log(index, row.mailSiap, row.telCelular)
            this.checked = false;
            this.formData = row;
            this.currentIndex = index;
            this.dialogFormVisible = true;
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;


            //console.log("COLOR", row.status, row.strStatus)
            if (row.status === true) {
                //console.log('GREEN')
                return 'success-row';
            }

            return '';
        },
        update: function update(index, row) {
            var _this2 = this;

            //console.log("CODIGO CLIENTE", row)

            this.$apollo.mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["y" /* updateValidation */],
                variables: {
                    telCelular: row.telCelular,
                    mailSiap: row.mailSiap,
                    codigoCliente: row.codigoCliente,
                    checkMail: row.checkMail,
                    checkTel: row.checkTel
                }

            }).then(function (data) {
                //this.successHandler(data.data)

                //console.log('GUARDAR client', data.data.updateValidation.client)
                //console.log('old ROW', row)
                //this.listTable[index] = data.data.updateValidation.client
                row.updatedAt = data.data.updateValidation.client.updatedAt;
                row.unico = data.data.updateValidation.client.unico;
                if (data.data.updateValidation.returnCode === 0) {
                    _this2.$refs.singleTable.doLayout();
                    _this2.$message({
                        message: 'Datos Actualizados',
                        type: 'success'
                    });
                } else {
                    _this2.$message.error('No se actualizaron los datos');
                }
            }).catch(function (error) {
                console.log(error);
                _this2.$message.error('Oops, this is a error message.');
            });
        },
        showunique: function showunique() {
            this.$message('Registro único');
        },
        sendData: function sendData() {
            var _this3 = this;

            var checkCel = this.formData.telCelular;

            // Check if only digits otherwise can not send data
            if (checkCel === "" || /^\d+$/.test(checkCel)) {

                this.dialogFormVisible = false;

                //console.log("DATOS!!!", this.formData, this.checked)

                this.$apollo.mutate({
                    mutation: __WEBPACK_IMPORTED_MODULE_0__graphql__["z" /* updateValidationStatus */],
                    variables: {
                        telCelular: this.formData.telCelular,
                        mailSiap: this.formData.mailSiap,
                        codigoCliente: this.formData.codigoCliente,
                        alias: this.formData.alias,
                        history: this.formData.history,
                        checked: this.checked,
                        mailPromotor: this.email
                    }
                }).then(function (data) {
                    _this3.checked = false;
                    //this.successHandler(data.data)
                    //this.formData.fecha_envio = "Enviado"
                    //console.log('Index', this.currentIndex)

                    //console.log('VALIDADO', data.data.updateValidationStatus.client)

                    //this.listTable[this.currentIndex] = data.data.updateValidationStatus.client
                    //this.listTable[this.currentIndex].status = true
                    //this.listTable[this.currentIndex].strStatus = "Enviado"

                    _this3.$message({
                        message: 'Correo Enviado',
                        type: 'success'
                    });
                    //console.log(this.listTable)
                    _this3.validate();
                    _this3.$refs.singleTable.doLayout();
                    // this.tableRowClassName(1)
                }).catch(function (error) {
                    console.log(error);
                    _this3.$message.error('Error de conexión');
                });
            } else {
                this.$message.error('Datos incorrectos, Verificar formato');
            }
        },
        filterTag: function filterTag(value, row) {
            //console.log('Filter', value)
            //row.status = false;
            //this.$refs.singleTable.doLayout()

            if (row.strStatus === 'Sin Enviar') {
                row.status = false;
            } else if (row.strStatus === 'Enviado') {
                row.status = true;
            }
            return row.strStatus === value;
        },
        filterChange: function filterChange(filters) {
            //console.log('FILTER CHANGE', filters);
            //console.log('FILTER CHANGE', filters["el-table_2_column_15"][0]);

            this.validate();
            this.$refs.singleTable.doLayout();
        }
    }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Calculator",
    methods: {
        goToAnalysis: function goToAnalysis(index) {
            //this.$store.dispatch('resetPortfolioForm')
            //this.$store.dispatch('setFormMode', 1)
            //alert(index)
            if (index === 1) {

                this.$router.push('/calculadora/opcion1');
            }
        }
    }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var checkField = function checkField(rule, value, callback) {

            value = parseFloat(value.replace(',', ''));
            if (!value) {
                return callback(new Error('Valor requerido'));
            } else {
                callback();
            }
        };
        return {
            sliderY: 30,
            marks: {
                10: '10 años',
                20: '20 años',
                30: {
                    style: {
                        color: '#1989FA'
                    },
                    label: this.$createElement('strong', '30 años')
                }
            },

            heightValue: 360,
            widthValue: 600,
            strokeWidth: 1.5,
            tasa_real: 0.40,
            margin: { top: 0, bottom: 20, left: 50, right: 20 },
            width: 600,
            height: 350,

            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '$',
                precision: 2,
                masked: false
            },
            money_p: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '%',
                precision: 2,
                masked: false
            },
            ruleForm: {
                capital: 50000000,
                tasa_nominal: 900,
                inflacion: 500,
                //tasa_real: 0.00,
                tasa_isr: 3500,
                tasa_ret_prov: 1.04,
                rango_tiempo: 30
            },
            rules: {
                capital: [{ validator: checkField, trigger: 'blur' }],
                tasa_nominal: [{ validator: checkField, trigger: 'blur' }],
                inflacion: [{ validator: checkField, trigger: 'blur' }],
                //tasa_real: [
                //    { validator: checkField, trigger: 'blur' }
                //],
                tasa_isr: [{ validator: checkField, trigger: 'blur' }],
                tasa_ret_prov: [{ validator: checkField, trigger: 'blur' }],
                retiro: [{ validator: checkField, trigger: 'blur' }]
            }

        };
    },

    methods: {
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    //alert('submit!');
                    console.log('submit!!!');
                    _this.calculate();
                } else {
                    console.log('error submit!!');
                    _this.$message.error('Datos Incorrectos');
                    return false;
                }
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        calculate: function calculate() {
            var _this2 = this;

            //console.log("Loading clients", this.listTable)
            var q = this.calculateQuery;

            this.$apollo.query({
                query: q.query,
                variables: q.variables,
                fetchPolicy: q.fetchPolicy
            }).then(function (data) {
                //this.successHandler(data.data)
                var obj = JSON.parse(data.data.calculate.result);
                // console.log('DATA', data.data)
                console.log(d3);

                var check = d3.select("svg");
                // check if graphs are already loaded
                var value = void 0,
                    value2 = void 0,
                    value3 = void 0;
                var datosTrad = [];
                var datosAseg = [];
                var datosDiff = [];

                for (value in obj.Tradicional) {
                    datosTrad.push(obj.Tradicional[value]);
                }

                for (value2 in obj.Aseguradora) {
                    datosAseg.push(obj.Aseguradora[value2]);
                }

                for (value3 in obj.Diferencia) {
                    datosDiff.push(obj.Diferencia[value3]);
                }

                var graphData = { datosTrad: datosTrad, datosAseg: datosAseg, datosDiff: datosDiff };

                if (check[0][0] === null) {
                    console.log('NEW', check);

                    _this2.createGraph(graphData);
                    _this2.createInfo(graphData);
                } else {
                    _this2.updateGraph(graphData);
                    _this2.createInfo(graphData);
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        updateGraph: function updateGraph(data) {
            var yearsRange = this.sliderY;
            var x = d3.scale.linear().range([0, this.width]);
            var x2 = d3.scale.linear().range([0, this.width]);
            var y = d3.scale.linear().range([this.height, 0]);

            d3.svg.axis().orient("left").scale(x);
            d3.svg.axis().orient("top").scale(y);

            x.domain(d3.extent(data.datosAseg, function (d, i) {
                return i;
            }));
            y.domain([0, d3.max(data.datosAseg, function (d) {
                return d;
            })]);
            x2.domain(d3.extent(data.datosAseg, function (d, i) {
                return i + 1;
            })); // years starting at 1

            var createPath = d3.svg.line().x(function (d, i) {
                return x(i);
            }).y(function (d) {
                return y(d);
            });

            // ########################## UPDATE LINES ###############################
            d3.select(".line-1").transition().duration(1000).attr('d', createPath(data.datosAseg));

            d3.select(".line-2").transition().duration(1000).attr('d', createPath(data.datosTrad));

            // ############################### UPDATE AXIS ##############################
            d3.select(".x.axis").transition().duration(1000).call(d3.svg.axis().scale(x2).orient("bottom").ticks(yearsRange));
            d3.select(".y.axis").transition().duration(1000).call(d3.svg.axis().scale(y).orient("left"));

            // ############################ UPDATE CIRCLES ##############################
            var c1 = d3.select(".circle-1");
            var c2 = d3.select(".circle-2");

            c1.remove();
            c2.remove();
            d3.select(".line-charts").append('g').attr('class', 'circle-1').selectAll("circle").data(data.datosAseg).enter().append("circle").attr("transform", 'translate(' + this.margin.left + ',0)').attr("r", 3).attr("cx", function (d, i) {
                return x(i);
            }).attr("cy", function (d) {
                return y(d);
            }).on("mouseover", function (d, i) {
                d3.select("#tooltip").style("right", 300 + "px")
                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + d.toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            }).transition().duration(1000);
            //.exit().remove();

            d3.select(".line-charts").append('g').attr('class', 'circle-2').selectAll("circle").data(data.datosTrad).enter().append("circle").attr("transform", 'translate(' + this.margin.left + ',0)').attr("r", 3).attr("cx", function (d, i) {
                return x(i);
            }).attr("cy", function (d) {
                return y(d);
            }).on("mouseover", function (d, i) {
                //Update the tooltip position and value
                d3.select("#tooltip").style("right", 300 + "px")
                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            }).transition().duration(1000);

            // ##################################### UPDATE BAR GRAPH #######################################

            var xScale = d3.scale.ordinal().domain(d3.range(yearsRange)).rangeRoundBands([0, this.width], 0.05);

            var yScale = d3.scale.linear().domain([0, d3.max(data.datosAseg)]).range([0, this.height]);

            var barHeight = this.height;
            d3.selectAll("rect").remove();
            d3.select(".line-charts").append("g").selectAll("rect").data(data.datosDiff).enter().append("rect").attr("transform", 'translate(' + this.margin.left + ',-2)').attr("class", "bars")
            //.transition()
            //.duration(1000)
            .attr("x", function (d, i) {
                return xScale(i) + xScale.rangeBand() / 2;
            }).attr("y", function (d) {
                return barHeight - yScale(d);
            }).attr("width", xScale.rangeBand()).attr("height", function (d) {
                return yScale(d);
            }).attr("fill", "#001F5C").on("mouseover", function (d, i) {
                d3.select("#tooltip").style("right", 300 + "px")
                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 })).attr("font-family", "sans-serif").attr("font-size", "20px").attr("fill", "red");
                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            });
        },
        createGraph: function createGraph(data) {
            var yearsRange = this.sliderY;

            var svg = d3.select(".chartwrapper").append('svg')
            //.attr({width: width, height: height})
            .attr('class', 'charts')
            //.append('g')
            //.attr('transform', 'translate(0, 0)')
            .attr("viewBox", '0 0 ' + this.widthValue + ' ' + this.heightValue);

            var chart = svg.append("g").attr("transform", 'translate(' + this.margin.left + ',10)');
            var grp = chart.append("g").attr('class', 'line-charts').attr("transform", 'translate(-' + (this.margin.left - this.strokeWidth) + ',-' + this.margin.top + ')');

            var x = d3.scale.linear().range([0, this.width]);
            var x2 = d3.scale.linear().range([0, this.width]);
            var y = d3.scale.linear().range([this.height, 0]);

            d3.svg.axis().orient("left").scale(x);
            d3.svg.axis().orient("top").scale(y);
            x.domain(d3.extent(data.datosAseg, function (d, i) {
                return i;
            }));
            y.domain([0, d3.max(data.datosAseg, function (d) {
                return d;
            })]);

            var createPath = d3.svg.line().x(function (d, i) {
                return x(i);
            }).y(function (d) {
                return y(d);
            });

            // Line GRAPHS ##########################################
            grp.append('path').attr('d', createPath(data.datosAseg)).transition().duration(1000).attr("transform", 'translate(' + this.margin.left + ',0)').attr('class', 'aseguradora line-1 lines');
            grp.append('path').attr('d', createPath(data.datosTrad)).transition().duration(1000).attr("transform", 'translate(' + this.margin.left + ',0)').attr('class', 'tradicional line-2 lines');
            // ######################################################

            // Line AXIS
            x2.domain(d3.extent(data.datosAseg, function (d, i) {
                return i + 1;
            })); // years starting at 1

            chart.append("g").attr("class", "x axis").transition().duration(1000).attr("transform", 'translate(0,' + this.height + ')').call(d3.svg.axis().scale(x2).orient("bottom").ticks(yearsRange));

            chart.append("g").attr("class", "y axis").transition().duration(1000).attr("transform", 'translate(0, 0)').call(d3.svg.axis().scale(y).orient("left"));

            grp // Add the valueline path.
            .append('g').attr('class', 'circle-1').selectAll("circle").data(data.datosAseg).enter().append("circle").attr("transform", 'translate(' + this.margin.left + ',0)').attr("r", 3).attr("cx", function (d, i) {
                return x(i);
            }).attr("cy", function (d) {
                return y(d);
            }).on("mouseover", function (d, i) {

                //d3.select(this).attr("fill", "orange");

                //Get this bar's x/y values, then augment for the tooltip
                //var xPosition = parseFloat(d3.select(this).attr("cx"));
                //var yPosition = parseFloat(d3.select(this).attr("cy"));

                //Update the tooltip position and value
                d3.select("#tooltip").style("right", 300 + "px")

                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + d.toLocaleString("en-US", { minimumFractionDigits: 2 }));

                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            });

            grp // Add the value line path
            .append('g').attr('class', 'circle-2').selectAll("circle").data(data.datosTrad).enter().append("circle").attr("transform", 'translate(' + this.margin.left + ',0)').attr("r", 3).attr("cx", function (d, i) {
                return x(i);
            }).attr("cy", function (d) {
                return y(d);
            }).on("mouseover", function (d, i) {
                //Update the tooltip position and value
                d3.select("#tooltip").style("right", 300 + "px")
                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            });

            //var barWidth = (width / dataset.length);
            // BAR GRAPH #########################################

            var xScale = d3.scale.ordinal().domain(d3.range(yearsRange)).rangeRoundBands([0, this.width], 0.05);

            var yScale = d3.scale.linear().domain([0, d3.max(data.datosAseg)]).range([0, this.height]);

            var barHeight = this.height;
            var bar = grp.append("g").selectAll("rect");

            bar.data(data.datosDiff).enter().append("rect").attr("transform", 'translate(' + this.margin.left + ',-2)').attr("class", "bars").attr("fill", "#001F5C").attr("x", function (d, i) {
                return xScale(i) + xScale.rangeBand() / 2;
            }).attr("y", function (d) {
                return barHeight - yScale(d);
            }).attr("width", xScale.rangeBand()).attr("height", function (d) {
                return yScale(d);
            }).on("mouseover", function (d, i) {

                d3.select("#tooltip").style("right", 300 + "px")
                //.style("top", yPosition + "px")
                .select("#valueA").text("$" + data.datosAseg[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));

                d3.select('#tooltip').select("#valueT").text("$" + data.datosTrad[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //.attr("font-family", "sans-serif")
                //.attr("font-size", "20px")
                //.attr("fill", "red");

                d3.select('#tooltip').select("#valueD").text(i + 1 + " Años: " + "$" + data.datosDiff[i].toLocaleString("en-US", { minimumFractionDigits: 2 }));
                //Show the tooltip
                d3.select("#tooltip").classed("hidden", false);
            }).on("mouseout", function () {
                //Hide the tooltip
                d3.select("#tooltip").classed("hidden", true);
            });
        },
        createInfo: function createInfo(data) {
            d3.select("#cards-info").select("#info1-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[9]));
            d3.select("#cards-info").select("#info1-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[9]));
            d3.select("#cards-info").select("#info1-D").text("Diferencia a 10 años: " + "$" + this.formatStringFloat(data.datosDiff[9]) + " (" + this.getPercentage(data.datosAseg[9], data.datosTrad[9]) + "%)");
            d3.select(".card-10").style("visibility", "visible");

            if (data.datosAseg.length >= 20) {
                d3.select("#cards-info").select("#info2-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[19]));
                d3.select("#cards-info").select("#info2-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[19]));
                d3.select("#cards-info").select("#info2-D").text("Diferencia a 20 años: " + "$" + this.formatStringFloat(data.datosDiff[19]) + " (" + this.getPercentage(data.datosAseg[19], data.datosTrad[19]) + "%)");
                d3.select(".card-20").style("visibility", "visible");
            } else {
                d3.select(".card-20").style("visibility", "hidden");
            }
            if (data.datosAseg.length >= 30) {
                d3.select("#cards-info").select("#info3-A").text("Aseguradora: " + "$" + this.formatStringFloat(data.datosAseg[29]));
                d3.select("#cards-info").select("#info3-T").text("Tradicional: " + "$" + this.formatStringFloat(data.datosTrad[29]));
                d3.select("#cards-info").select("#info3-D").text("Diferencia a 30 años: " + "$" + this.formatStringFloat(data.datosDiff[29]) + " (" + this.getPercentage(data.datosAseg[29], data.datosTrad[29]) + "%)");
                d3.select(".card-30").style("visibility", "visible");
            } else {
                d3.select(".card-30").style("visibility", "hidden");
            }
        },
        getFloat: function getFloat(strFloat) {
            return parseFloat(strFloat).toFixed(2);
        },
        formatStringFloat: function formatStringFloat(strFloat) {
            return strFloat.toLocaleString("en-US", { minimumFractionDigits: 2 });
        },
        getPercentage: function getPercentage(numAseg, numTrad) {

            return (100 - numTrad * 100 / numAseg).toFixed(2);
        }
    },
    computed: {
        calculateQuery: function calculateQuery() {
            return {
                query: __WEBPACK_IMPORTED_MODULE_0__graphql__["o" /* getCalculation */],
                variables: {
                    capital: this.getFloat(this.ruleForm.capital.replace(',', '')),
                    tasaNominal: this.getFloat(this.ruleForm.tasa_nominal),
                    inflacion: this.getFloat(this.ruleForm.inflacion),
                    tasaReal: this.getFloat(this.tasa_real),
                    tasaIsr: this.getFloat(this.ruleForm.tasa_isr),
                    tasaRet: this.getFloat(this.ruleForm.tasa_ret_prov),
                    rangoTiempo: this.sliderY
                },
                fetchPolicy: 'network-only'
            };
        },
        email: function email() {
            return this.$store.getters.userInfo.email;
        },
        valid: function valid() {
            //this.validate();
            return this.listTable;
        },
        result: function result() {
            return (this.getFloat(this.ruleForm.tasa_nominal) - this.getFloat(this.ruleForm.inflacion)).toFixed(2) + "%";
        }
    },
    mounted: function mounted() {
        this.width = this.width - this.margin.left - this.margin.right - this.strokeWidth * 2;
        this.height = this.height - this.margin.top - this.margin.bottom;
    }
});

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_notification_css__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_base_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_box_css__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_css__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_message__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_slider_css__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dialog_css__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_pagination_css__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_pagination__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tooltip_css__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_tooltip__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_item_css__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_breadcrumb_item__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_breadcrumb_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_breadcrumb_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_group_css__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option_group__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_select_css__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_item_css__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form_item__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_form__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_checkbox_css__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_checkbox__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_group_css__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_menu_item_group__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_menu_item__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_main_css__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_main__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_css__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_menu__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_column_css__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_table_column__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tag_css__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_tag__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_css__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_table__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_submenu_css__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_submenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_submenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_submenu__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_submenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_submenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_row_css__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_row__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_loading_css__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui_lib_loading__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_input_css__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_element_ui_lib_input__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_header_css__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_header__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_element_ui_lib_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_item_css__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_element_ui_lib_dropdown_item__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_menu_css__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_element_ui_lib_dropdown_menu__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_css__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_dropdown__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_date_picker_css__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_element_ui_lib_date_picker__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_item_css__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_element_ui_lib_collapse_item__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_css__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_element_ui_lib_collapse__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_container_css__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_container_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_container_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_element_ui_lib_container__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_element_ui_lib_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_element_ui_lib_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_col_css__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_element_ui_lib_col__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_card_css__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_element_ui_lib_card__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_element_ui_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_element_ui_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_css__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_breadcrumb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_element_ui_lib_breadcrumb__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_element_ui_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_element_ui_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_button_css__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_element_ui_lib_button__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_autocomplete_css__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_element_ui_lib_autocomplete__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_alert_css__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_element_ui_lib_alert__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_element_ui_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_element_ui_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_aside_css__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_aside_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__home_julio_WebstormProjects_PortfolioAnalysis_Front_theme_aside_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_element_ui_lib_aside__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_element_ui_lib_aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_element_ui_lib_aside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_es6_promise_auto__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_unfetch__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_d3__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_v_money__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_vue_responsive__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__App__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_vuex_router_sync__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_vue_apollo__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_apollo_client__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_apollo_link_http__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_apollo_cache_inmemory__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_apollo_link_context__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__store__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__router__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_element_ui_lib_locale_lang_en__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_element_ui_lib_locale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98_element_ui_lib_locale__);

























































































































// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import {scaleLinear} from "d3-scale";

















// const unsync = sync(store, router) // done. Returns an unsync callback fn


Object(__WEBPACK_IMPORTED_MODULE_89_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_95__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_96__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_98_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_97_element_ui_lib_locale_lang_en___default.a);

// Bulma UI components
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_81_element_ui_lib_aside___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_79_element_ui_lib_alert___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_77_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_75_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_73_element_ui_lib_breadcrumb___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_71_element_ui_lib_card___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_69_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_67_element_ui_lib_container___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_65_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_63_element_ui_lib_collapse_item___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_61_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_59_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_57_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_55_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_53_element_ui_lib_header___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_51_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_49_element_ui_lib_loading___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_submenu___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_tag___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_main___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_menu_item_group___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option_group___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_breadcrumb_item___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider___default.a);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_85_d3__);
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_86_v_money___default.a, { precision: 2 });
// Vue.use(MessageBox);
// Vue.component(MessageBox.name,MessageBox);

// Importing prototypes
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_message___default.a;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$msgbox = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$alert = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box___default.a.alert;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box___default.a.confirm;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message_box___default.a.prompt;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_87_vue_responsive__["a" /* default */]);

var authLink = Object(__WEBPACK_IMPORTED_MODULE_94_apollo_link_context__["a" /* setContext */])(function (_, _ref) {
  var headers = _ref.headers;

  // get the authentication token from local storage if it exists
  var token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  if (token) {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headers, {
        authorization: token ? 'JWT ' + token : ""
      })
    };
  }
});

// Apollo and graphql client configuration
// const defaultOptions = {
//   watchQuery: {
//     fetchPolicy: 'network-only',
//     errorPolicy: 'ignore',
//   },
//   query: {
//     fetchPolicy: 'network-only',
//     errorPolicy: 'all',
//   },
// }

var httpLink = new __WEBPACK_IMPORTED_MODULE_92_apollo_link_http__["a" /* HttpLink */]({
  uri: 'https://back.ixion.mx/graphql/',
  //uri: `http://127.0.0.1:8000/graphql/`,
  fetch: __WEBPACK_IMPORTED_MODULE_83_unfetch__["a" /* default */]
});

var apolloClient = new __WEBPACK_IMPORTED_MODULE_91_apollo_client__["a" /* ApolloClient */]({
  link: authLink.concat(httpLink),
  cache: new __WEBPACK_IMPORTED_MODULE_93_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  // defaultOptions: defaultOptions,
  connectToDevTools: true
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_90_vue_apollo__["a" /* default */]({
  defaultClient: apolloClient
});
__WEBPACK_IMPORTED_MODULE_84_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_90_vue_apollo__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_84_vue__["default"]({
  el: '#app',
  apolloProvider: apolloProvider,
  router: __WEBPACK_IMPORTED_MODULE_96__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_95__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_88__App__["a" /* default */] }
});

// Navigation guards
__WEBPACK_IMPORTED_MODULE_96__router__["a" /* default */].beforeEach(function (to, from, next) {
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  var authUser = localStorage.getItem('token');
  var clientAuth = validClientSession(to);
  var validAuth = authUser || clientAuth;
  if (requiresAuth && !validAuth) {
    window.location.assign('/');
  } else {
    next();
  }
});

var validClientSession = function validClientSession(route) {
  if (route.params) {
    var clientPortfolioId = localStorage.getItem('portafolio_id');
    return clientPortfolioId === route.params.id;
  }
};

// StartsWith Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

// Includes Polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49736454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarChart_vue__ = __webpack_require__(1274);
function injectStyle (ssrContext) {
  __webpack_require__(1104)
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49736454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49736454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialSlider_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcaa8950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialSlider_vue__ = __webpack_require__(1285);
function injectStyle (ssrContext) {
  __webpack_require__(1280)
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcaa8950"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcaa8950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalTableData2_vue__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea389ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalTableData2_vue__ = __webpack_require__(1307);
function injectStyle (ssrContext) {
  __webpack_require__(1306)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea389ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalTableData2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea389ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalTableData2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70033fec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1013);
function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70033fec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 989:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17113c41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(1012);
function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17113c41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17113c41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 991:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae550c1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__(994);
function injectStyle (ssrContext) {
  __webpack_require__(993)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae550c1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae550c1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 993:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{staticClass:"drawer-nav"},[(_vm.userIsAdmin)?_c('el-menu',{on:{"select":_vm.handleSelect}},[_c('router-link',{staticClass:"nav-header",attrs:{"to":"/lista-de-analisis"}},[_c('img',{attrs:{"src":"/static/menu.svg"}}),_vm._v(" "),_c('img',{staticClass:"header-logo",attrs:{"src":"/static/logo.svg"}})]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/links"}},[_c('i',{staticClass:"el-icon-share"}),_vm._v("Tablero de control")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/lista-de-analisis"}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("Análisis de portafolios")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/validacion"}},[_c('i',{staticClass:"el-icon-check"}),_vm._v("Validación")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/calculadora"}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v("Calculadoras")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/lista-de-asesores"}},[_vm._v("Asesores")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/login"}},[_vm._v("Cerrar sesión")])],1):_c('el-menu',{on:{"select":_vm.handleSelect}},[_c('router-link',{staticClass:"nav-header",attrs:{"to":"/lista-de-analisis"}},[_c('img',{attrs:{"src":"/static/menu.svg"}}),_vm._v(" "),_c('img',{staticClass:"header-logo",attrs:{"src":"/static/logo.svg"}})]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/links"}},[_c('i',{staticClass:"el-icon-share"}),_vm._v("Tablero de control")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/lista-de-analisis"}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("Análisis de portafolios")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/validacion"}},[_c('i',{staticClass:"el-icon-check"}),_vm._v("Validación")]),_vm._v(" "),_c('el-menu-item',{staticClass:"nav-link",attrs:{"index":"/calculadora"}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v("Calculadoras")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/login"}},[_vm._v("Cerrar sesión")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[500]);


// WEBPACK FOOTER //
// static/js/app.ab996ee629e69726c4b8.js